document.addEventListener("DOMContentLoaded", function () {
  const addBtn         = document.getElementById("addDesignBtn");
  const mobileBar      = document.getElementById("mobileBar");
  const mobileDrawer   = document.getElementById("mobileDrawer");
  const openText       = document.getElementById("openTextPanel");
  const openLogo       = document.getElementById("openLogoPanel");
  const openPattern    = document.getElementById("openPatternPanel");
  const closeDrawer    = document.getElementById("closeDrawer");
  const textPanel      = document.getElementById("textPanel");
  const logoPanel      = document.getElementById("logoPanel");
  const patternPanel   = document.getElementById("patternPanel");
  const textBox        = document.getElementById("textBox");
  const embCanvas      = document.getElementById("embroideryCanvas");
  const textInput      = document.getElementById("textInput");
  const fontWarning    = document.getElementById("fontWarning");
  const sizeInput      = document.getElementById("sizeInput");
  const trackingInput  = document.getElementById("trackingInput");
  const applyText      = document.getElementById("applyText");
  const logoInput      = document.getElementById("logoInput");
  const logoFileName   = document.getElementById("logoFileName");
  const logoWarning    = document.getElementById("logoWarning");
  const logoSizeInput  = document.getElementById("logoSizeInput");
  const applyLogo      = document.getElementById("applyLogo");
  const logoColorMinus = document.getElementById("logoColorMinus");
  const logoColorPlus  = document.getElementById("logoColorPlus");
  const logoColorCount = document.getElementById("logoColorCount");
  const logoSourceColors = document.getElementById("logoSourceColors");
  const logoTargetColors = document.getElementById("logoTargetColors");
  const fontToggle     = document.getElementById("fontToggle");
  const fontList       = document.getElementById("fontList");
  const changeHatBtn   = document.getElementById("changeHatBtn");
  const hatList        = document.getElementById("hatList");
  const mainHat        = document.getElementById("mainHat");
  const deleteText     = document.getElementById("deleteText");
  const rotateText     = document.getElementById("rotateText");
  const resizeText     = document.getElementById("resizeText");
  const safeArea       = document.getElementById("safeArea");
  const warning        = document.getElementById("designWarning");
  const addToCartBtn   = document.getElementById("addToCartBtn");
  const priceTotalValue = document.getElementById("priceTotalValue");
  const priceBreakdown  = document.getElementById("priceBreakdown");
  const qtyInput        = document.getElementById("qtyInput");
  const qtyMinus        = document.getElementById("qtyMinus");
  const qtyPlus         = document.getElementById("qtyPlus");
  const barButtons     = document.querySelectorAll(".mobile-bar button");
  const colorButtons   = document.querySelectorAll(".color-palette button[data-color]");
  const warningDefaultText = warning ? warning.textContent : "";

  let selectedFont  = "block2";
  let selectedColor = "#ffffff";
  let selectedKonturColor = "#000000";
  // Baskı tekniği: "nakis" | "3d" | "uv" — girişte seçilir, ürün metafield'i geçersiz kılabilir
  var urlTeknik = new URLSearchParams(location.search).get("teknik");
  let currentTechnique = (urlTeknik === "uv" || urlTeknik === "3d") ? urlTeknik : "nakis";
  function isUv() { return currentTechnique === "uv"; }
  let currentText   = "BRAVER";
  let currentSize   = 46;
  let currentTracking = 0; // harf aralığı, fontSize oranı (ör. 0.05 = %5)
  let activeDesignType = "text";
  let logoImage = null;
  let logoObjectUrl = "";
  let logoSourceFile = null; // müşterinin yüklediği orijinal dosya (üretim ZIP'ine girer)
  let logoName = "";
  let logoSource = ""; // "upload" (müşteri yükledi, ücretli) | "pattern" (hazır desen, ücretsiz)
  let logoMaxColors = 10;
  let logoDetectedColors = [];
  let logoSelectedSourceColor = "";
  let logoColorMap = {};
  let selectedVariantId = addToCartBtn ? addToCartBtn.dataset.variantId : null;
  let selectedVariantPrice = addToCartBtn ? Number(addToCartBtn.dataset.price || 0) : 0; // kuruş

  let x = 0, y = 0, rotation = 0, scale = 1;
  let committedDesigns = []; // sahnede sabitlenmiş tasarımlar: {id, details, el}
  let designIdSeq = 1;
  let layerSeq = 1;    // katman sırası: büyük = önde (Hatstore 'İleri getir/Geri gönder')
  let activeLayer = 0; // aktif tasarımın katmanı
  let currentView = "front"; // front | left | right
  const viewSwitcher = document.getElementById("viewSwitcher");
  const VIEW_LABELS = { front: "Ön", left: "Sol yan", right: "Sağ yan" };

  // İplik/yazı rengi hex → okunaklı Türkçe ad (sipariş özeti için)
  const COLOR_NAMES = {
    "#000000": "Siyah", "#ffffff": "Beyaz", "#ff0000": "Kırmızı", "#0000ff": "Mavi",
    "#120a8f": "Lacivert", "#ffdf00": "Sarı", "#ff7f00": "Turuncu", "#a0a0a0": "Gri",
    "#f5f5dc": "Bej", "#ec3b83": "Pembe", "#009900": "Yeşil", "#660099": "Mor",
    "#00bce2": "Açık Mavi", "#730d0d": "Bordo", "#b49264": "Camel"
  };
  function colorName(hex) {
    if (!hex) return "";
    var h = String(hex).toLowerCase().trim();
    return COLOR_NAMES[h] || hex;
  }
  let selectedColorName = "";
  const stageZoom = document.getElementById("stageZoom");
  const zoomInBtn = document.getElementById("zoomIn");
  const zoomOutBtn = document.getElementById("zoomOut");
  let zoomLevel = 1;
  const ZOOM_MIN = 1, ZOOM_MAX = 2.5, ZOOM_STEP = 0.25;
  // Yazı render supersampling: küçük yazı küçülünce net kalsın (görünür boyut değişmez)
  const TEXT_SS = 2;
  let mode = null;
  let startX = 0, startY = 0, startPointerX = 0, startPointerY = 0;
  let startRotation = 0, startSize = 46, startAngle = 0;
  let logoResizeBaseWidth = 0, logoResizeBaseHeight = 0;
  let resizeFrame = null, renderFrame = null;

  /* ── Embroidery Canvas Renderer ─────────────────────────── */

  const customizerRoot = document.querySelector(".braver-customizer");
  const glyphBase = window.BRAVER_ASSET_URL
    ? window.BRAVER_ASSET_URL.replace(/font-block2-upper-A\.png.*$/, "")
    : (customizerRoot && customizerRoot.dataset.glyphBase) || "";
  console.log("[Braver] glyphBase:", glyphBase);

  const THREAD_COLORS = [
    "#000000",
    "#ffffff",
    "#ff0000",
    "#0000ff",
    "#120a8f",
    "#ffdf00",
    "#ff7f00",
    "#a0a0a0",
    "#f5f5dc",
    "#ec3b83",
    "#009900",
    "#660099",
    "#00bce2",
    "#730d0d",
    "#b49264"
  ];

  /* ── Efekt fontları: yazı motoru + canvas nakış dokusu ───────────────────── */

  const PNG_FONTS = [
    "block2",
    "bauhaus",
    "wilcom",
    "casualserif",
    "adelle",
    "advent",
    "algerian",
    "angleblock",
    "arialrounded",
    "civic",
    "collage",
    "columbo",
    "freestyle",
    "moly",
    "racer",
    "collagekontur",
    "d3block2",
    "d3mono",
    "d3brush"
  ];

  const FONT_LABELS = {
    testfont: "Test Font",
    block2: "Block2",
    bauhaus: "Bauhaus",
    bookscript: "Book Script",
    wilcom: "Book Script",
    casualserif: "Casuel Serif",
    adelle: "Adelle",
    advent: "Advent",
    algerian: "Algerian",
    angleblock: "Angle Block",
    arialrounded: "Arial Rounded",
    civic: "Civic",
    collage: "Collage",
    columbo: "Columbo",
    freestyle: "Free Style",
    moly: "Moly",
    racer: "Racer",
    collagekontur: "Collage Kontur",
    d3block2: "3D Block2",
    d3mono: "3D Monoglyceride",
    d3brush: "3D Brush Script",
    uvalfa: "Alfa Slab", uvarimo: "Arimo", uvbaloo: "Baloo", uvchakra: "Chakra",
    uvcinzel: "Cinzel", uvgraduate: "Graduate", uvlimelight: "Limelight",
    uvlobster: "Lobster", uvpatrick: "Patrick Hand", uvrighteous: "Righteous",
    uvsigmar: "Sigmar", uvyellowtail: "Yellowtail", uvzilla: "Zilla Slab",
    uvanton: "Anton", uvarchivo: "Archivo Black", uvbangers: "Bangers",
    uvbebas: "Bebas Neue", uvcaveat: "Caveat", uvmontserrat: "Montserrat",
    uvoswald: "Oswald", uvpacifico: "Pacifico", uvplayfair: "Playfair"
  };

  const EFFECT_FONTS = {
    block2:       { family: "BrBlock2, Arial, sans-serif",        weight: "700", style: "normal" },
    bauhaus:      { family: "BrBauhaus, sans-serif",              weight: "400", style: "normal" },
    wilcom:       { family: "BrBookScript, cursive",              weight: "400", style: "normal" },
    bookscript:   { family: "BrBookScript, cursive",              weight: "400", style: "normal" },
    casualserif:  { family: "BrCasual, sans-serif",               weight: "400", style: "normal" },
    adelle:       { family: "BrAdelle, serif",                    weight: "700", style: "normal" },
    advent:       { family: "BrAdvent, serif",                    weight: "400", style: "normal" },
    algerian:     { family: "BrAlgerian, serif",                  weight: "700", style: "normal" },
    angleblock:   { family: "BrAngleBlock, sans-serif",           weight: "700", style: "normal" },
    arialrounded: { family: "BrRounded, sans-serif",              weight: "700", style: "normal" },
    civic:        { family: "BrCivic, serif",                     weight: "400", style: "normal" },
    collage:      { family: "BrCollage, serif",                   weight: "400", style: "normal" },
    columbo:      { family: "BrColumbo, sans-serif",              weight: "400", style: "normal" },
    freestyle:    { family: "BrFreestyle, cursive",               weight: "400", style: "normal" },
    testfont:     { family: "Arial Black, Impact, sans-serif",    weight: "900", style: "normal" },
    // UV baskı düz fontları — gerçek Google Fonts TTF'leri
    uvalfa:       { family: "UvAlfa, serif",            weight: "400", style: "normal" },
    uvarimo:      { family: "UvArimo, sans-serif",      weight: "700", style: "normal" },
    uvbaloo:      { family: "UvBaloo, sans-serif",      weight: "700", style: "normal" },
    uvchakra:     { family: "UvChakra, sans-serif",     weight: "700", style: "normal" },
    uvcinzel:     { family: "UvCinzel, serif",          weight: "700", style: "normal" },
    uvgraduate:   { family: "UvGraduate, serif",        weight: "400", style: "normal" },
    uvlimelight:  { family: "UvLimelight, serif",       weight: "400", style: "normal" },
    uvlobster:    { family: "UvLobster, cursive",       weight: "400", style: "normal" },
    uvpatrick:    { family: "UvPatrick, sans-serif",    weight: "400", style: "normal" },
    uvrighteous:  { family: "UvRighteous, sans-serif",  weight: "400", style: "normal" },
    uvsigmar:     { family: "UvSigmar, sans-serif",     weight: "400", style: "normal" },
    uvyellowtail: { family: "UvYellowtail, cursive",    weight: "400", style: "normal" },
    uvzilla:      { family: "UvZilla, serif",           weight: "700", style: "normal" },
    uvanton:      { family: "UvAnton, sans-serif",      weight: "400", style: "normal" },
    uvarchivo:    { family: "UvArchivo, sans-serif",    weight: "400", style: "normal" },
    uvbangers:    { family: "UvBangers, cursive",       weight: "400", style: "normal" },
    uvbebas:      { family: "UvBebas, sans-serif",      weight: "400", style: "normal" },
    uvcaveat:     { family: "UvCaveat, cursive",        weight: "700", style: "normal" },
    uvmontserrat: { family: "UvMontserrat, sans-serif", weight: "700", style: "normal" },
    uvoswald:     { family: "UvOswald, sans-serif",     weight: "600", style: "normal" },
    uvpacifico:   { family: "UvPacifico, cursive",      weight: "400", style: "normal" },
    uvplayfair:   { family: "UvPlayfair, serif",        weight: "700", style: "normal" }
  };


  function turkishGlyphFiles(prefix, options) {
    var opts = options || {};
    var files = {};
    if (opts.upperCcedilla !== false) files["Ç"] = "font-" + prefix + "-upper-ccedilla.png";
    if (opts.upperGbreve !== false) files["Ğ"] = "font-" + prefix + "-upper-gbreve.png";
    if (opts.upperIdot !== false) files["İ"] = "font-" + prefix + "-upper-idot.png";
    if (opts.upperOdiaeresis !== false) files["Ö"] = "font-" + prefix + "-upper-odiaeresis.png";
    if (opts.upperScedilla !== false) files["Ş"] = "font-" + prefix + "-upper-scedilla.png";
    if (opts.upperUdiaeresis !== false) files["Ü"] = "font-" + prefix + "-upper-udiaeresis.png";
    if (opts.lower !== false) {
      files["ç"] = "font-" + prefix + "-lower-ccedilla.png";
      files["ğ"] = "font-" + prefix + "-lower-gbreve.png";
      files["ı"] = "font-" + prefix + "-lower-dotlessi.png";
      files["ö"] = "font-" + prefix + "-lower-odiaeresis.png";
      files["ş"] = "font-" + prefix + "-lower-scedilla.png";
      files["ü"] = "font-" + prefix + "-lower-udiaeresis.png";
    }
    return files;
  }

  const PNG_FONT_PROFILES = {
    d3block2: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0563,
      lowerGap: 0.0549,
      files: {
        "Ç": "font-d3block2-upper-ccedilla.png",
        "Ö": "font-d3block2-upper-odiaeresis.png",
        "Ü": "font-d3block2-upper-udiaeresis.png",
        "ç": "font-d3block2-lower-ccedilla.png",
        "ö": "font-d3block2-lower-odiaeresis.png",
        "ü": "font-d3block2-lower-udiaeresis.png",
        ".": "font-d3block2-punct-period.png",
        ",": "font-d3block2-punct-comma.png",
        "-": "font-d3block2-punct-hyphen.png",
        "!": "font-d3block2-punct-exclamation.png",
        "?": "font-d3block2-punct-question.png",
        "'": "font-d3block2-punct-apostrophe.png",
        "\"": "font-d3block2-punct-quote.png",
        "&": "font-d3block2-punct-ampersand.png",
        "@": "font-d3block2-punct-at.png",
        "#": "font-d3block2-punct-hash.png",
        "(": "font-d3block2-punct-paren-left.png",
        ")": "font-d3block2-punct-paren-right.png",
        ":": "font-d3block2-punct-colon.png",
        ";": "font-d3block2-punct-semicolon.png",
        "/": "font-d3block2-punct-slash.png",
        "+": "font-d3block2-punct-plus.png",
        "=": "font-d3block2-punct-equals.png",
        "%": "font-d3block2-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.0055, h: 1.0318 },
        B: { top: -0.0274, h: 1.0729 },
        C: { top: -0.0357, h: 1.0976 },
        D: { top: -0.0302, h: 1.0757 },
        E: { top: -0.0302, h: 1.0702 },
        F: { top: -0.0329, h: 1.0427 },
        G: { top: -0.0631, h: 1.1415 },
        H: { top: 0.0055, h: 1.029 },
        I: { top: 0.0027, h: 1.0208 },
        J: { top: 0.0055, h: 1.0674 },
        K: { top: 0.0027, h: 1.04 },
        L: { top: 0.0082, h: 1.0482 },
        M: { top: 0.011, h: 1.0263 },
        N: { top: 0.0055, h: 1.0373 },
        O: { top: -0.0247, h: 1.0894 },
        P: { top: -0.011, h: 1.051 },
        Q: { top: -0.0192, h: 1.1004 },
        R: { top: -0.0137, h: 1.0592 },
        S: { top: -0.0329, h: 1.1086 },
        T: { top: -0.0082, h: 1.051 },
        U: { top: 0.0, h: 1.0812 },
        V: { top: 0.0055, h: 1.0263 },
        W: { top: 0.0027, h: 1.0345 },
        X: { top: 0.0, h: 1.04 },
        Y: { top: 0.0, h: 1.0427 },
        Z: { top: -0.0027, h: 1.0592 },
        "Ç": { top: -0.0357, h: 1.512 },
        "Ö": { top: -0.2662, h: 1.3418 },
        "Ü": { top: -0.2689, h: 1.3446 },
        a: { top: 0.1893, h: 0.8507 },
        b: { top: -0.0329, h: 1.0839 },
        c: { top: 0.1784, h: 0.8644 },
        d: { top: -0.0357, h: 1.0839 },
        e: { top: 0.1811, h: 0.8616 },
        f: { top: -0.0878, h: 1.1059 },
        g: { top: 0.1921, h: 1.136 },
        h: { top: -0.022, h: 1.04 },
        i: { top: -0.0384, h: 1.0565 },
        j: { top: 0.0, h: 1.3638 },
        k: { top: -0.0027, h: 1.0455 },
        l: { top: -0.011, h: 1.0592 },
        m: { top: 0.2113, h: 0.826 },
        n: { top: 0.2113, h: 0.8205 },
        o: { top: 0.2058, h: 0.8726 },
        p: { top: 0.2058, h: 1.1141 },
        q: { top: 0.2058, h: 1.1168 },
        r: { top: 0.2113, h: 0.8177 },
        s: { top: 0.2113, h: 0.8616 },
        t: { top: 0.0055, h: 1.0592 },
        u: { top: 0.2415, h: 0.8342 },
        v: { top: 0.2415, h: 0.7985 },
        w: { top: 0.2415, h: 0.7958 },
        x: { top: 0.2278, h: 0.7985 },
        y: { top: 0.2195, h: 1.1223 },
        z: { top: 0.2085, h: 0.8479 },
        "ç": { top: 0.1784, h: 1.2239 },
        "ö": { top: -0.1207, h: 1.158 },
        "ü": { top: -0.1207, h: 1.1827 },
        "0": { top: -0.0151, h: 1.0852 },
        "1": { top: 0.0226, h: 1.0048 },
        "2": { top: -0.01, h: 1.0601 },
        "3": { top: 0.0, h: 1.0651 },
        "4": { top: 0.0226, h: 1.0174 },
        "5": { top: 0.005, h: 1.0626 },
        "6": { top: -0.0025, h: 1.0651 },
        "7": { top: 0.01, h: 1.03 },
        "8": { top: -0.0126, h: 1.0777 },
        "9": { top: -0.0075, h: 1.0676 },
        ".": { top: 0.8213, h: 0.2187 },
        ",": { top: 0.8213, h: 0.4704 },
        "-": { top: 0.5518, h: 0.2136 },
        "!": { top: 0.0254, h: 1.0197 },
        "?": { top: -0.028, h: 1.0705 },
        "'": { top: 0.0178, h: 0.3204 },
        "\"": { top: 0.0229, h: 0.3229 },
        "&": { top: -0.0076, h: 1.0959 },
        "@": { top: -0.0254, h: 1.2816 },
        "#": { top: 0.0229, h: 1.0324 },
        "(": { top: -0.0941, h: 1.2867 },
        ")": { top: -0.0941, h: 1.2867 },
        ":": { top: 0.3941, h: 0.6459 },
        ";": { top: 0.3865, h: 0.9052 },
        "/": { top: 0.0153, h: 1.0222 },
        "+": { top: 0.3102, h: 0.6357 },
        "=": { top: 0.3026, h: 0.5289 },
        "%": { top: -0.0153, h: 1.129 }
      }
    },
    d3mono: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0865,
      lowerGap: 0.0876,
      files: {
        "Ç": "font-d3mono-upper-ccedilla.png",
        "Ö": "font-d3mono-upper-odiaeresis.png",
        "Ü": "font-d3mono-upper-udiaeresis.png",
        "ç": "font-d3mono-lower-ccedilla.png",
        "ö": "font-d3mono-lower-odiaeresis.png",
        "ü": "font-d3mono-lower-udiaeresis.png",
        ".": "font-d3mono-punct-period.png",
        ",": "font-d3mono-punct-comma.png",
        "-": "font-d3mono-punct-hyphen.png",
        "!": "font-d3mono-punct-exclamation.png",
        "?": "font-d3mono-punct-question.png",
        "'": "font-d3mono-punct-apostrophe.png",
        "\"": "font-d3mono-punct-quote.png",
        "&": "font-d3mono-punct-ampersand.png",
        "@": "font-d3mono-punct-at.png",
        "#": "font-d3mono-punct-hash.png",
        "(": "font-d3mono-punct-paren-left.png",
        ")": "font-d3mono-punct-paren-right.png",
        ":": "font-d3mono-punct-colon.png",
        ";": "font-d3mono-punct-semicolon.png",
        "/": "font-d3mono-punct-slash.png",
        "+": "font-d3mono-punct-plus.png",
        "=": "font-d3mono-punct-equals.png",
        "%": "font-d3mono-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.0045, h: 1.049 },
        B: { top: 0.009, h: 1.0355 },
        C: { top: 0.0067, h: 1.0265 },
        D: { top: 0.0022, h: 1.0288 },
        E: { top: 0.0067, h: 1.0243 },
        F: { top: 0.009, h: 1.0288 },
        G: { top: 0.0067, h: 1.031 },
        H: { top: 0.0, h: 1.04 },
        I: { top: -0.0045, h: 1.0445 },
        J: { top: 0.0022, h: 1.0535 },
        K: { top: -0.0045, h: 1.049 },
        L: { top: -0.0045, h: 1.0378 },
        M: { top: 0.0, h: 1.0422 },
        N: { top: 0.0067, h: 1.049 },
        O: { top: -0.0022, h: 1.0557 },
        P: { top: -0.0022, h: 1.0512 },
        Q: { top: -0.0022, h: 1.058 },
        R: { top: -0.0022, h: 1.0445 },
        S: { top: 0.0067, h: 1.0265 },
        T: { top: 0.0067, h: 1.031 },
        U: { top: -0.0022, h: 1.0535 },
        V: { top: 0.0022, h: 1.0355 },
        W: { top: -0.0022, h: 1.0378 },
        X: { top: -0.0022, h: 1.0445 },
        Y: { top: 0.0, h: 1.04 },
        Z: { top: 0.0022, h: 1.0445 },
        "Ç": { top: -0.0045, h: 1.3253 },
        "Ö": { top: -0.2718, h: 1.3343 },
        "Ü": { top: -0.2718, h: 1.3185 },
        a: { top: 0.1213, h: 0.921 },
        b: { top: -0.2201, h: 1.2556 },
        c: { top: 0.1303, h: 0.9052 },
        d: { top: -0.2224, h: 1.2579 },
        e: { top: 0.1213, h: 0.9097 },
        f: { top: -0.2067, h: 1.2489 },
        g: { top: 0.1325, h: 1.2871 },
        h: { top: -0.2201, h: 1.2601 },
        i: { top: -0.1438, h: 1.1883 },
        j: { top: -0.1438, h: 1.5162 },
        k: { top: -0.2201, h: 1.2601 },
        l: { top: -0.2156, h: 1.2556 },
        m: { top: 0.128, h: 0.921 },
        n: { top: 0.1168, h: 0.9142 },
        o: { top: 0.1078, h: 0.9187 },
        p: { top: 0.1258, h: 1.2489 },
        q: { top: 0.1258, h: 1.2467 },
        r: { top: 0.128, h: 0.9075 },
        s: { top: 0.1325, h: 0.8962 },
        t: { top: -0.0854, h: 1.1164 },
        u: { top: 0.1258, h: 0.9142 },
        v: { top: 0.119, h: 0.9254 },
        w: { top: 0.1258, h: 0.912 },
        x: { top: 0.1123, h: 0.9277 },
        y: { top: 0.1235, h: 1.2467 },
        z: { top: 0.128, h: 0.912 },
        "ç": { top: 0.164, h: 1.2287 },
        "ö": { top: -0.1101, h: 1.168 },
        "ü": { top: -0.1033, h: 1.1546 },
        "0": { top: -0.0064, h: 1.0592 },
        "1": { top: -0.0021, h: 1.0443 },
        "2": { top: -0.0064, h: 1.0464 },
        "3": { top: 0.0107, h: 1.0251 },
        "4": { top: 0.0, h: 1.0443 },
        "5": { top: 0.0043, h: 1.04 },
        "6": { top: 0.0149, h: 1.0229 },
        "7": { top: 0.0064, h: 1.0336 },
        "8": { top: -0.0128, h: 1.072 },
        "9": { top: -0.0021, h: 1.0229 },
        ".": { top: 0.8275, h: 0.2125 },
        ",": { top: 0.7588, h: 0.4654 },
        "-": { top: 0.4977, h: 0.1861 },
        "!": { top: -0.0142, h: 1.038 },
        "?": { top: 0.0121, h: 1.0238 },
        "'": { top: -0.087, h: 0.4593 },
        "\"": { top: -0.087, h: 0.4593 },
        "&": { top: -0.0142, h: 1.0279 },
        "@": { top: -0.0911, h: 1.1594 },
        "#": { top: -0.0425, h: 1.0582 },
        "(": { top: -0.0142, h: 1.2828 },
        ")": { top: -0.0101, h: 1.2808 },
        ":": { top: 0.2023, h: 0.8195 },
        ";": { top: 0.2023, h: 1.0056 },
        "/": { top: -0.0223, h: 1.1796 },
        "+": { top: 0.1922, h: 0.8215 },
        "=": { top: 0.3885, h: 0.3804 },
        "%": { top: 0.0, h: 1.0157 }
      }
    },
    d3brush: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: -0.18,
      lowerGap: -0.18,
      files: {
        "Ç": "font-d3brush-upper-ccedilla.png",
        "Ö": "font-d3brush-upper-odiaeresis.png",
        "Ü": "font-d3brush-upper-udiaeresis.png",
        "ç": "font-d3brush-lower-ccedilla.png",
        "ö": "font-d3brush-lower-odiaeresis.png",
        "ü": "font-d3brush-lower-udiaeresis.png",
        ".": "font-d3brush-punct-period.png",
        ",": "font-d3brush-punct-comma.png",
        "-": "font-d3brush-punct-hyphen.png",
        "!": "font-d3brush-punct-exclamation.png",
        "?": "font-d3brush-punct-question.png",
        "'": "font-d3brush-punct-apostrophe.png",
        "\"": "font-d3brush-punct-quote.png",
        "&": "font-d3brush-punct-ampersand.png",
        "@": "font-d3brush-punct-at.png",
        "#": "font-d3brush-punct-hash.png",
        "(": "font-d3brush-punct-paren-left.png",
        ")": "font-d3brush-punct-paren-right.png",
        ":": "font-d3brush-punct-colon.png",
        ";": "font-d3brush-punct-semicolon.png",
        "/": "font-d3brush-punct-slash.png",
        "+": "font-d3brush-punct-plus.png",
        "=": "font-d3brush-punct-equals.png",
        "%": "font-d3brush-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0156, h: 1.0263 },
        B: { top: -0.0117, h: 1.0498 },
        C: { top: -0.0078, h: 1.0478 },
        D: { top: -0.0117, h: 1.0517 },
        E: { top: -0.0117, h: 1.0576 },
        F: { top: -0.0117, h: 1.0205 },
        G: { top: -0.0117, h: 1.1259 },
        H: { top: -0.0098, h: 1.0244 },
        I: { top: 0.0429, h: 0.9678 },
        J: { top: -0.0117, h: 1.4927 },
        K: { top: -0.0117, h: 1.0263 },
        L: { top: -0.0117, h: 1.0517 },
        M: { top: -0.0117, h: 1.0556 },
        N: { top: -0.0117, h: 1.0537 },
        O: { top: -0.0117, h: 1.0498 },
        P: { top: 0.0117, h: 1.0224 },
        Q: { top: 0.0293, h: 1.1532 },
        R: { top: 0.0078, h: 1.0341 },
        S: { top: 0.0137, h: 1.0517 },
        T: { top: 0.0, h: 1.0341 },
        U: { top: 0.0059, h: 1.0615 },
        V: { top: 0.0098, h: 1.0302 },
        W: { top: 0.0098, h: 1.0302 },
        X: { top: 0.0098, h: 1.0576 },
        Y: { top: 0.0059, h: 1.4888 },
        Z: { top: 0.0098, h: 1.1415 },
        "Ç": { top: 0.0098, h: 1.2956 },
        "Ö": { top: -0.2166, h: 1.2722 },
        "Ü": { top: -0.2088, h: 1.2722 },
        a: { top: 0.3356, h: 0.7044 },
        b: { top: -0.0195, h: 1.0595 },
        c: { top: 0.3337, h: 0.7044 },
        d: { top: -0.0098, h: 1.0498 },
        e: { top: 0.3356, h: 0.7005 },
        f: { top: -0.0195, h: 1.4634 },
        g: { top: 0.3259, h: 1.1141 },
        h: { top: -0.0117, h: 1.0498 },
        i: { top: 0.1639, h: 0.8761 },
        j: { top: 0.16, h: 1.2859 },
        k: { top: -0.002, h: 1.038 },
        l: { top: -0.0176, h: 1.0576 },
        m: { top: 0.359, h: 0.681 },
        n: { top: 0.3746, h: 0.6829 },
        o: { top: 0.3493, h: 0.7063 },
        p: { top: 0.3337, h: 1.1044 },
        q: { top: 0.3337, h: 1.1083 },
        r: { top: 0.3024, h: 0.7376 },
        s: { top: 0.2517, h: 0.7883 },
        t: { top: 0.0234, h: 1.0166 },
        u: { top: 0.3707, h: 0.6673 },
        v: { top: 0.3707, h: 0.6673 },
        w: { top: 0.3629, h: 0.6771 },
        x: { top: 0.3629, h: 0.6751 },
        y: { top: 0.3668, h: 1.0751 },
        z: { top: 0.3298, h: 1.1122 },
        "ç": { top: 0.3063, h: 0.919 },
        "ö": { top: 0.0702, h: 0.9463 },
        "ü": { top: 0.0722, h: 0.9424 },
        "0": { top: 0.002, h: 1.074 },
        "1": { top: 0.03, h: 1.008 },
        "2": { top: 0.002, h: 1.074 },
        "3": { top: 0.0, h: 1.076 },
        "4": { top: 0.026, h: 1.014 },
        "5": { top: 0.0, h: 1.076 },
        "6": { top: 0.0, h: 1.076 },
        "7": { top: 0.0, h: 1.04 },
        "8": { top: 0.0, h: 1.074 },
        "9": { top: 0.0, h: 1.076 },
        ".": { top: 0.8366, h: 0.2034 },
        ",": { top: 0.8462, h: 0.2974 },
        "-": { top: 0.5449, h: 0.2072 },
        "!": { top: -0.0038, h: 1.0285 },
        "?": { top: 0.0019, h: 1.0342 },
        "'": { top: 0.0249, h: 0.2974 },
        "\"": { top: 0.0249, h: 0.2974 },
        "&": { top: -0.0134, h: 1.1359 },
        "@": { top: -0.0211, h: 1.0765 },
        "#": { top: -0.0748, h: 1.157 },
        "(": { top: -0.1075, h: 1.1532 },
        ")": { top: -0.1075, h: 1.159 },
        ":": { top: 0.5661, h: 0.4605 },
        ";": { top: 0.5929, h: 0.5507 },
        "/": { top: -0.0787, h: 1.3086 },
        "+": { top: 0.3473, h: 0.6006 },
        "=": { top: 0.3991, h: 0.4528 },
        "%": { top: -0.0729, h: 1.1148 }
      }
    },
    collagekontur: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜ0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.06,
      forceUppercase: true,
      twoTone: true,
      files: {
        "A": "font-collagekontur-upper-A",
        "B": "font-collagekontur-upper-B",
        "C": "font-collagekontur-upper-C",
        "D": "font-collagekontur-upper-D",
        "E": "font-collagekontur-upper-E",
        "F": "font-collagekontur-upper-F",
        "G": "font-collagekontur-upper-G",
        "H": "font-collagekontur-upper-H",
        "I": "font-collagekontur-upper-I",
        "J": "font-collagekontur-upper-J",
        "K": "font-collagekontur-upper-K",
        "L": "font-collagekontur-upper-L",
        "M": "font-collagekontur-upper-M",
        "N": "font-collagekontur-upper-N",
        "O": "font-collagekontur-upper-O",
        "P": "font-collagekontur-upper-P",
        "Q": "font-collagekontur-upper-Q",
        "R": "font-collagekontur-upper-R",
        "S": "font-collagekontur-upper-S",
        "T": "font-collagekontur-upper-T",
        "U": "font-collagekontur-upper-U",
        "V": "font-collagekontur-upper-V",
        "W": "font-collagekontur-upper-W",
        "X": "font-collagekontur-upper-X",
        "Y": "font-collagekontur-upper-Y",
        "Z": "font-collagekontur-upper-Z",
        "Ç": "font-collagekontur-upper-ccedilla",
        "Ö": "font-collagekontur-upper-odiaeresis",
        "Ü": "font-collagekontur-upper-udiaeresis",
        "0": "font-collagekontur-digit-0",
        "1": "font-collagekontur-digit-1",
        "2": "font-collagekontur-digit-2",
        "3": "font-collagekontur-digit-3",
        "4": "font-collagekontur-digit-4",
        "5": "font-collagekontur-digit-5",
        "6": "font-collagekontur-digit-6",
        "7": "font-collagekontur-digit-7",
        "8": "font-collagekontur-digit-8",
        "9": "font-collagekontur-digit-9",
        ".": "font-collagekontur-punct-period",
        ",": "font-collagekontur-punct-comma",
        "-": "font-collagekontur-punct-hyphen",
        "!": "font-collagekontur-punct-exclamation",
        "?": "font-collagekontur-punct-question",
        "'": "font-collagekontur-punct-apostrophe",
        "\"": "font-collagekontur-punct-quote",
        "&": "font-collagekontur-punct-ampersand",
        "@": "font-collagekontur-punct-at",
        "#": "font-collagekontur-punct-hash",
        "(": "font-collagekontur-punct-paren-left",
        ")": "font-collagekontur-punct-paren-right",
        ":": "font-collagekontur-punct-colon",
        ";": "font-collagekontur-punct-semicolon",
        "/": "font-collagekontur-punct-slash",
        "+": "font-collagekontur-punct-plus",
        "=": "font-collagekontur-punct-equals",
        "%": "font-collagekontur-punct-percent"
      },
      charMetrics: {
        A: { top: 0.0055, h: 1.0386 },
        B: { top: 0.0055, h: 1.0386 },
        C: { top: 0.0014, h: 1.0386 },
        D: { top: 0.0027, h: 1.0331 },
        E: { top: -0.0014, h: 1.0414 },
        F: { top: -0.0041, h: 1.0482 },
        G: { top: -0.0027, h: 1.0345 },
        H: { top: -0.0027, h: 1.0427 },
        I: { top: -0.0014, h: 1.0414 },
        J: { top: 0.0041, h: 1.0386 },
        K: { top: -0.0014, h: 1.04 },
        L: { top: 0.0014, h: 1.0386 },
        M: { top: -0.0027, h: 1.0427 },
        N: { top: 0.0, h: 1.0496 },
        O: { top: 0.0055, h: 1.0318 },
        P: { top: -0.0014, h: 1.0496 },
        Q: { top: 0.0027, h: 1.1032 },
        R: { top: -0.0055, h: 1.0414 },
        S: { top: 0.0014, h: 1.0386 },
        T: { top: 0.0041, h: 1.0359 },
        U: { top: 0.0055, h: 1.0359 },
        V: { top: 0.0041, h: 1.0359 },
        W: { top: 0.0055, h: 1.0345 },
        X: { top: 0.0041, h: 1.0304 },
        Y: { top: -0.0055, h: 1.0455 },
        Z: { top: 0.0, h: 1.04 },
        "Ç": { top: -0.0055, h: 1.2612 },
        "Ö": { top: -0.2981, h: 1.3395 },
        "Ü": { top: -0.2926, h: 1.3313 },
        "0": { top: -0.0014, h: 1.0414 },
        "1": { top: 0.0043, h: 1.0315 },
        "2": { top: 0.0014, h: 1.0386 },
        "3": { top: 0.0014, h: 1.0372 },
        "4": { top: -0.0043, h: 1.0443 },
        "5": { top: -0.0057, h: 1.0457 },
        "6": { top: -0.0057, h: 1.0443 },
        "7": { top: 0.0028, h: 1.0372 },
        "8": { top: -0.0028, h: 1.0357 },
        "9": { top: 0.0, h: 1.04 },
        ".": { top: 0.7872, h: 0.269 },
        ",": { top: 0.7997, h: 0.3658 },
        "-": { top: 0.4034, h: 0.2815 },
        "!": { top: 0.0054, h: 1.0346 },
        "?": { top: -0.0054, h: 1.0436 },
        "'": { top: 0.0197, h: 0.3694 },
        "\"": { top: 0.0161, h: 0.3604 },
        "&": { top: -0.0072, h: 1.0597 },
        "@": { top: -0.009, h: 1.0848 },
        "#": { top: 0.0036, h: 1.0454 },
        "(": { top: -0.1488, h: 1.3466 },
        ")": { top: -0.1488, h: 1.3466 },
        ":": { top: 0.407, h: 0.6114 },
        ";": { top: 0.4106, h: 0.7083 },
        "/": { top: -0.156, h: 1.3502 },
        "+": { top: 0.3766, h: 0.5666 },
        "=": { top: 0.4375, h: 0.4931 },
        "%": { top: 0.0126, h: 1.049 }
      }
    },

    racer: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0819,
      lowerGap: 0.0819,
      files: {
        "Ç": "font-racer-upper-ccedilla.png",
        "Ö": "font-racer-upper-odiaeresis.png",
        "Ü": "font-racer-upper-udiaeresis.png",
        "ç": "font-racer-lower-ccedilla.png",
        "ö": "font-racer-lower-odiaeresis.png",
        "ü": "font-racer-lower-udiaeresis.png",
        ".": "font-racer-punct-period.png",
        ",": "font-racer-punct-comma.png",
        "-": "font-racer-punct-hyphen.png",
        "!": "font-racer-punct-exclamation.png",
        "?": "font-racer-punct-question.png",
        "'": "font-racer-punct-apostrophe.png",
        "\"": "font-racer-punct-quote.png",
        "&": "font-racer-punct-ampersand.png",
        "@": "font-racer-punct-at.png",
        "#": "font-racer-punct-hash.png",
        "(": "font-racer-punct-paren-left.png",
        ")": "font-racer-punct-paren-right.png",
        ":": "font-racer-punct-colon.png",
        ";": "font-racer-punct-semicolon.png",
        "/": "font-racer-punct-slash.png",
        "+": "font-racer-punct-plus.png",
        "=": "font-racer-punct-equals.png",
        "%": "font-racer-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0193, h: 1.0747 },
        B: { top: 0.0039, h: 1.0323 },
        C: { top: -0.0039, h: 1.04 },
        D: { top: 0.0077, h: 1.0323 },
        E: { top: 0.0077, h: 1.0323 },
        F: { top: 0.0, h: 1.0361 },
        G: { top: 0.0077, h: 1.1979 },
        H: { top: -0.0963, h: 1.2557 },
        I: { top: 0.0039, h: 1.04 },
        J: { top: 0.0077, h: 1.2981 },
        K: { top: 0.0, h: 1.0439 },
        L: { top: -0.0193, h: 1.0516 },
        M: { top: 0.0077, h: 1.0323 },
        N: { top: -0.0231, h: 1.0708 },
        O: { top: -0.0039, h: 1.0554 },
        P: { top: -0.0039, h: 1.0207 },
        Q: { top: -0.0462, h: 1.0747 },
        R: { top: 0.0039, h: 1.0361 },
        S: { top: -0.0039, h: 1.0785 },
        T: { top: 0.0, h: 1.0361 },
        U: { top: -0.027, h: 1.0824 },
        V: { top: -0.027, h: 1.0631 },
        W: { top: -0.0077, h: 1.0439 },
        X: { top: -0.0462, h: 1.0939 },
        Y: { top: -0.0077, h: 1.0439 },
        Z: { top: -0.0077, h: 1.2287 },
        "Ç": { top: -0.0116, h: 1.3058 },
        "Ö": { top: -0.2812, h: 1.3212 },
        "Ü": { top: -0.2812, h: 1.3289 },
        a: { top: 0.5084, h: 0.5354 },
        b: { top: 0.1464, h: 0.9052 },
        c: { top: 0.5046, h: 0.5354 },
        d: { top: 0.1502, h: 0.9052 },
        e: { top: 0.5123, h: 0.5239 },
        f: { top: 0.1502, h: 1.1633 },
        g: { top: 0.5123, h: 0.8744 },
        h: { top: 0.1502, h: 0.8936 },
        i: { top: 0.0616, h: 0.9784 },
        j: { top: 0.0616, h: 1.2788 },
        k: { top: 0.1541, h: 0.8859 },
        l: { top: 0.1502, h: 0.8859 },
        m: { top: 0.493, h: 0.5508 },
        n: { top: 0.5007, h: 0.5431 },
        o: { top: 0.5123, h: 0.5431 },
        p: { top: 0.3505, h: 0.9476 },
        q: { top: 0.5161, h: 0.8089 },
        r: { top: 0.3467, h: 0.7049 },
        s: { top: 0.2966, h: 0.7434 },
        t: { top: 0.2465, h: 0.7896 },
        u: { top: 0.52, h: 0.5277 },
        v: { top: 0.5161, h: 0.52 },
        w: { top: 0.5123, h: 0.5354 },
        x: { top: 0.5161, h: 0.52 },
        y: { top: 0.5161, h: 0.8705 },
        z: { top: 0.5123, h: 0.5316 },
        "ç": { top: 0.5123, h: 0.8012 },
        "ö": { top: 0.2157, h: 0.8359 },
        "ü": { top: 0.208, h: 0.832 },
        "0": { top: 0.0193, h: 1.0361 },
        "1": { top: 0.0116, h: 1.0284 },
        "2": { top: 0.0, h: 1.0477 },
        "3": { top: 0.0116, h: 1.0554 },
        "4": { top: 0.0039, h: 1.0323 },
        "5": { top: 0.0193, h: 1.0477 },
        "6": { top: 0.0193, h: 1.0477 },
        "7": { top: 0.0116, h: 1.0284 },
        "8": { top: 0.0039, h: 1.0631 },
        "9": { top: 0.0, h: 1.0439 },
        ".": { top: 0.755, h: 0.285 },
        ",": { top: 0.7896, h: 0.3159 },
        "-": { top: 0.5662, h: 0.2157 },
        "!": { top: 0.0077, h: 1.0439 },
        "?": { top: -0.0154, h: 1.0593 },
        "'": { top: 0.0039, h: 0.3582 },
        "\"": { top: 0.0077, h: 0.3582 },
        "&": { top: -0.0193, h: 1.0439 },
        "@": { top: -0.027, h: 1.0516 },
        "#": { top: 0.0, h: 1.0169 },
        "(": { top: -0.0693, h: 1.2133 },
        ")": { top: -0.0693, h: 1.2133 },
        ":": { top: 0.4699, h: 0.5778 },
        ";": { top: 0.4545, h: 0.6587 },
        "/": { top: 0.0039, h: 1.0246 },
        "+": { top: 0.1079, h: 0.8397 },
        "=": { top: 0.3544, h: 0.4314 },
        "%": { top: 0.0, h: 1.0284 }
      }
    },
    moly: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: -0.0517,
      lowerGap: -0.0517,
      files: {
        "Ç": "font-moly-upper-ccedilla.png",
        "Ö": "font-moly-upper-odiaeresis.png",
        "Ü": "font-moly-upper-udiaeresis.png",
        "ç": "font-moly-lower-ccedilla.png",
        "ö": "font-moly-lower-odiaeresis.png",
        "ü": "font-moly-lower-udiaeresis.png",
        ".": "font-moly-punct-period.png",
        ",": "font-moly-punct-comma.png",
        "-": "font-moly-punct-hyphen.png",
        "!": "font-moly-punct-exclamation.png",
        "?": "font-moly-punct-question.png",
        "'": "font-moly-punct-apostrophe.png",
        "\"": "font-moly-punct-quote.png",
        "&": "font-moly-punct-ampersand.png",
        "@": "font-moly-punct-at.png",
        "#": "font-moly-punct-hash.png",
        "(": "font-moly-punct-paren-left.png",
        ")": "font-moly-punct-paren-right.png",
        ":": "font-moly-punct-colon.png",
        ";": "font-moly-punct-semicolon.png",
        "/": "font-moly-punct-slash.png",
        "+": "font-moly-punct-plus.png",
        "=": "font-moly-punct-equals.png",
        "%": "font-moly-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0155, h: 1.0323 },
        B: { top: 0.0, h: 1.0361 },
        C: { top: 0.0, h: 1.0555 },
        D: { top: -0.0039, h: 1.04 },
        E: { top: 0.0116, h: 1.0245 },
        F: { top: 0.0039, h: 1.0516 },
        G: { top: 0.0, h: 1.0439 },
        H: { top: -0.0039, h: 1.0787 },
        I: { top: 0.0155, h: 1.0361 },
        J: { top: 0.0116, h: 1.2797 },
        K: { top: 0.0155, h: 1.0245 },
        L: { top: 0.0039, h: 1.1521 },
        M: { top: -0.0077, h: 1.0477 },
        N: { top: -0.0271, h: 1.0671 },
        O: { top: 0.0077, h: 1.0516 },
        P: { top: -0.0116, h: 1.0516 },
        Q: { top: 0.0, h: 1.3145 },
        R: { top: 0.0077, h: 1.0516 },
        S: { top: 0.0155, h: 1.0593 },
        T: { top: -0.1005, h: 1.1599 },
        U: { top: 0.0039, h: 1.0748 },
        V: { top: -0.0155, h: 1.1019 },
        W: { top: -0.0271, h: 1.0593 },
        X: { top: 0.0039, h: 1.0323 },
        Y: { top: -0.0309, h: 1.1289 },
        Z: { top: 0.0116, h: 1.0207 },
        "Ç": { top: 0.0, h: 1.3532 },
        "Ö": { top: -0.1199, h: 1.183 },
        "Ü": { top: -0.1199, h: 1.1985 },
        a: { top: 0.4407, h: 0.5993 },
        b: { top: 0.1469, h: 0.8854 },
        c: { top: 0.4485, h: 0.5993 },
        d: { top: 0.1353, h: 0.9047 },
        e: { top: 0.4407, h: 0.5993 },
        f: { top: 0.1314, h: 1.2062 },
        g: { top: 0.4369, h: 0.9008 },
        h: { top: 0.1314, h: 0.9163 },
        i: { top: 0.1585, h: 0.8815 },
        j: { top: 0.1585, h: 1.1792 },
        k: { top: 0.1392, h: 0.9008 },
        l: { top: 0.1314, h: 0.9124 },
        m: { top: 0.4369, h: 0.6031 },
        n: { top: 0.4369, h: 0.6031 },
        o: { top: 0.4291, h: 0.6109 },
        p: { top: 0.4369, h: 0.8931 },
        q: { top: 0.4407, h: 0.8892 },
        r: { top: 0.3634, h: 0.6727 },
        s: { top: 0.4059, h: 0.6418 },
        t: { top: 0.2513, h: 0.7887 },
        u: { top: 0.4407, h: 0.5915 },
        v: { top: 0.433, h: 0.6302 },
        w: { top: 0.433, h: 0.6109 },
        x: { top: 0.4291, h: 0.607 },
        y: { top: 0.4446, h: 0.8931 },
        z: { top: 0.4369, h: 0.5954 },
        "ç": { top: 0.4407, h: 0.8892 },
        "ö": { top: 0.1701, h: 0.8622 },
        "ü": { top: 0.1701, h: 0.8622 },
        "0": { top: 0.1276, h: 0.9008 },
        "1": { top: 0.1314, h: 0.9124 },
        "2": { top: 0.1314, h: 0.9086 },
        "3": { top: 0.1353, h: 0.9549 },
        "4": { top: 0.1314, h: 0.9163 },
        "5": { top: 0.1237, h: 0.9047 },
        "6": { top: 0.1353, h: 0.9047 },
        "7": { top: 0.1314, h: 0.8892 },
        "8": { top: 0.1353, h: 0.897 },
        "9": { top: 0.1392, h: 0.9124 },
        ".": { top: 0.8196, h: 0.2204 },
        ",": { top: 0.8119, h: 0.4059 },
        "-": { top: 0.5606, h: 0.1778 },
        "!": { top: 0.0541, h: 0.9897 },
        "?": { top: -0.0193, h: 1.0593 },
        "'": { top: 0.0425, h: 0.348 },
        "\"": { top: 0.0425, h: 0.348 },
        "&": { top: 0.1005, h: 0.897 },
        "@": { top: 0.3325, h: 0.7887 },
        "#": { top: 0.0812, h: 0.9163 },
        "(": { top: -0.0193, h: 1.1599 },
        ")": { top: -0.0039, h: 1.1869 },
        ":": { top: 0.4871, h: 0.549 },
        ";": { top: 0.4871, h: 0.7307 },
        "/": { top: -0.0193, h: 1.1444 },
        "+": { top: 0.3441, h: 0.5683 },
        "=": { top: 0.4485, h: 0.3943 },
        "%": { top: 0.1005, h: 0.9395 }
      }
    },
    block2: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0683,
      lowerGap: 0.0642,
      files: {
        "Ç": "font-block2-upper-ccedilla.png",
        "Ö": "font-block2-upper-odiaeresis.png",
        "Ü": "font-block2-upper-udiaeresis.png",
        "ç": "font-block2-lower-ccedilla.png",
        "ö": "font-block2-lower-odiaeresis.png",
        "ü": "font-block2-lower-udiaeresis.png",
        ".": "font-block2-punct-period.png",
        ",": "font-block2-punct-comma.png",
        "-": "font-block2-punct-hyphen.png",
        "!": "font-block2-punct-exclamation.png",
        "?": "font-block2-punct-question.png",
        "'": "font-block2-punct-apostrophe.png",
        "\"": "font-block2-punct-quote.png",
        "&": "font-block2-punct-ampersand.png",
        "@": "font-block2-punct-at.png",
        "#": "font-block2-punct-hash.png",
        "(": "font-block2-punct-paren-left.png",
        ")": "font-block2-punct-paren-right.png",
        ":": "font-block2-punct-colon.png",
        ";": "font-block2-punct-semicolon.png",
        "/": "font-block2-punct-slash.png",
        "+": "font-block2-punct-plus.png",
        "=": "font-block2-punct-equals.png",
        "%": "font-block2-punct-percent.png"
      },
      // Wilcom v2 sayfalarından otomatik üretildi: hücreler ortak taban çizgisine göre
      charMetrics: {
        A: { top: 0.0, h: 1.04 },
        B: { top: -0.008, h: 1.0601 },
        C: { top: -0.0642, h: 1.1243 },
        D: { top: -0.008, h: 1.052 },
        E: { top: -0.008, h: 1.052 },
        F: { top: -0.008, h: 1.052 },
        G: { top: -0.0361, h: 1.1163 },
        H: { top: 0.0, h: 1.044 },
        I: { top: 0.004, h: 1.04 },
        J: { top: 0.0, h: 1.0601 },
        K: { top: 0.0, h: 1.048 },
        L: { top: 0.004, h: 1.036 },
        M: { top: 0.0, h: 1.04 },
        N: { top: -0.004, h: 1.048 },
        O: { top: -0.0402, h: 1.1123 },
        P: { top: -0.0161, h: 1.0561 },
        Q: { top: -0.0602, h: 1.1283 },
        R: { top: -0.012, h: 1.048 },
        S: { top: -0.0361, h: 1.1042 },
        T: { top: -0.008, h: 1.04 },
        U: { top: -0.004, h: 1.0721 },
        V: { top: 0.0, h: 1.04 },
        W: { top: 0.004, h: 1.036 },
        X: { top: -0.004, h: 1.044 },
        Y: { top: 0.0, h: 1.032 },
        Z: { top: 0.0, h: 1.04 },
        "Ç": { top: -0.0482, h: 1.5138 },
        "Ö": { top: -0.2971, h: 1.3653 },
        "Ü": { top: -0.2971, h: 1.3693 },
        a: { top: 0.2409, h: 0.8151 },
        b: { top: 0.004, h: 1.052 },
        c: { top: 0.2289, h: 0.8232 },
        d: { top: 0.004, h: 1.052 },
        e: { top: 0.249, h: 0.8031 },
        f: { top: -0.0402, h: 1.0761 },
        g: { top: 0.2369, h: 1.0922 },
        h: { top: 0.0, h: 1.04 },
        i: { top: 0.004, h: 1.032 },
        j: { top: 0.004, h: 1.3412 },
        k: { top: 0.0, h: 1.036 },
        l: { top: 0.008, h: 1.028 },
        m: { top: 0.2409, h: 0.7991 },
        n: { top: 0.2409, h: 0.7991 },
        o: { top: 0.257, h: 0.8031 },
        p: { top: 0.2409, h: 1.0681 },
        q: { top: 0.2409, h: 1.0641 },
        r: { top: 0.249, h: 0.787 },
        s: { top: 0.2409, h: 0.8151 },
        t: { top: 0.0281, h: 1.0119 },
        u: { top: 0.265, h: 0.791 },
        v: { top: 0.265, h: 0.775 },
        w: { top: 0.265, h: 0.775 },
        x: { top: 0.261, h: 0.779 },
        y: { top: 0.265, h: 1.0601 },
        z: { top: 0.2731, h: 0.771 },
        "ç": { top: 0.2369, h: 1.1645 },
        "ö": { top: -0.0482, h: 1.1042 },
        "ü": { top: -0.0482, h: 1.1203 },
        "0": { top: -0.0201, h: 1.0922 },
        "1": { top: 0.004, h: 1.036 },
        "2": { top: -0.0201, h: 1.0681 },
        "3": { top: -0.008, h: 1.0721 },
        "4": { top: 0.008, h: 1.032 },
        "5": { top: 0.0, h: 1.0641 },
        "6": { top: -0.0241, h: 1.0882 },
        "7": { top: 0.008, h: 1.032 },
        "8": { top: -0.0241, h: 1.0842 },
        "9": { top: -0.0241, h: 1.0882 },
        ".": { top: 0.8031, h: 0.2369 },
        ",": { top: 0.8111, h: 0.4738 },
        "-": { top: 0.5501, h: 0.2088 },
        "!": { top: 0.0161, h: 1.036 },
        "?": { top: -0.0201, h: 1.0681 },
        "'": { top: 0.0161, h: 0.3172 },
        "\"": { top: 0.012, h: 0.3212 },
        "&": { top: -0.0201, h: 1.0922 },
        "@": { top: -0.0201, h: 1.2608 },
        "#": { top: 0.012, h: 1.036 },
        "(": { top: -0.004, h: 1.297 },
        ")": { top: -0.004, h: 1.297 },
        ":": { top: 0.2811, h: 0.7669 },
        ";": { top: 0.2811, h: 0.9958 },
        "/": { top: 0.008, h: 1.04 },
        "+": { top: 0.3253, h: 0.6063 },
        "=": { top: 0.3012, h: 0.51 },
        "%": { top: -0.0201, h: 1.1123 }
      }
    },

    bauhaus: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇĞİÖŞÜabcdefghijklmnopqrstuvwxyzçğıöşü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0757,
      lowerGap: 0.0696,
      files: {
        "Ç": "font-bauhaus-upper-ccedilla.png",
        "Ğ": "font-bauhaus-upper-gbreve.png",
        "İ": "font-bauhaus-upper-idot.png",
        "Ö": "font-bauhaus-upper-odiaeresis.png",
        "Ş": "font-bauhaus-upper-scedilla.png",
        "Ü": "font-bauhaus-upper-udiaeresis.png",
        "ç": "font-bauhaus-lower-ccedilla.png",
        "ğ": "font-bauhaus-lower-gbreve.png",
        "ı": "font-bauhaus-lower-dotlessi.png",
        "ö": "font-bauhaus-lower-odiaeresis.png",
        "ş": "font-bauhaus-lower-scedilla.png",
        "ü": "font-bauhaus-lower-udiaeresis.png",
        ".": "font-bauhaus-punct-period.png",
        ",": "font-bauhaus-punct-comma.png",
        "-": "font-bauhaus-punct-hyphen.png",
        "!": "font-bauhaus-punct-exclamation.png",
        "?": "font-bauhaus-punct-question.png",
        "'": "font-bauhaus-punct-apostrophe.png",
        "\"": "font-bauhaus-punct-quote.png",
        "&": "font-bauhaus-punct-ampersand.png",
        "@": "font-bauhaus-punct-at.png",
        "#": "font-bauhaus-punct-hash.png",
        "(": "font-bauhaus-punct-paren-left.png",
        ")": "font-bauhaus-punct-paren-right.png",
        ":": "font-bauhaus-punct-colon.png",
        ";": "font-bauhaus-punct-semicolon.png",
        "/": "font-bauhaus-punct-slash.png",
        "+": "font-bauhaus-punct-plus.png",
        "=": "font-bauhaus-punct-equals.png",
        "%": "font-bauhaus-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.0082, h: 1.0236 },
        B: { top: -0.0082, h: 1.0523 },
        C: { top: 0.0041, h: 1.0359 },
        D: { top: -0.0082, h: 1.0523 },
        E: { top: 0.0, h: 1.0441 },
        F: { top: 0.0041, h: 1.0154 },
        G: { top: -0.0123, h: 1.0646 },
        H: { top: 0.0041, h: 1.0195 },
        I: { top: 0.0041, h: 1.0154 },
        J: { top: 0.0041, h: 1.0359 },
        K: { top: 0.0, h: 1.0236 },
        L: { top: 0.0, h: 1.0359 },
        M: { top: -0.0041, h: 1.0482 },
        N: { top: -0.0041, h: 1.0564 },
        O: { top: -0.0123, h: 1.0728 },
        P: { top: -0.0082, h: 1.0482 },
        Q: { top: -0.0164, h: 1.2488 },
        R: { top: -0.0164, h: 1.0359 },
        S: { top: 0.0, h: 1.04 },
        T: { top: -0.0041, h: 1.04 },
        U: { top: 0.0041, h: 1.0523 },
        V: { top: 0.0082, h: 1.0441 },
        W: { top: 0.0, h: 1.0564 },
        X: { top: 0.0, h: 1.0359 },
        Y: { top: 0.0041, h: 1.0359 },
        Z: { top: -0.0041, h: 1.0482 },
        "Ç": { top: 0.0041, h: 1.3676 },
        "Ğ": { top: -0.2661, h: 1.3184 },
        "İ": { top: -0.3439, h: 1.3635 },
        "Ö": { top: -0.3439, h: 1.388 },
        "Ş": { top: 0.0, h: 1.2488 },
        "Ü": { top: -0.3439, h: 1.388 },
        a: { top: 0.3194, h: 0.7452 },
        b: { top: 0.0164, h: 1.0523 },
        c: { top: 0.3235, h: 0.7329 },
        d: { top: 0.0164, h: 1.0523 },
        e: { top: 0.2907, h: 0.7698 },
        f: { top: 0.0123, h: 1.0154 },
        g: { top: 0.3194, h: 1.0441 },
        h: { top: 0.0164, h: 1.0113 },
        i: { top: 0.0123, h: 1.0113 },
        j: { top: 0.0164, h: 1.343 },
        k: { top: 0.0205, h: 1.0113 },
        l: { top: 0.0164, h: 1.0072 },
        m: { top: 0.3194, h: 0.7083 },
        n: { top: 0.3194, h: 0.7083 },
        o: { top: 0.3112, h: 0.737 },
        p: { top: 0.3071, h: 1.0359 },
        q: { top: 0.303, h: 1.04 },
        r: { top: 0.303, h: 0.7206 },
        s: { top: 0.3194, h: 0.7206 },
        t: { top: 0.1392, h: 0.9008 },
        u: { top: 0.348, h: 0.7083 },
        v: { top: 0.348, h: 0.7124 },
        w: { top: 0.3521, h: 0.7043 },
        x: { top: 0.3153, h: 0.7247 },
        y: { top: 0.3521, h: 0.9909 },
        z: { top: 0.3153, h: 0.7288 },
        "ç": { top: 0.3071, h: 1.0523 },
        "ğ": { top: 0.131, h: 1.2324 },
        "ı": { top: 0.3644, h: 0.6592 },
        "ö": { top: 0.0082, h: 1.04 },
        "ş": { top: 0.3194, h: 0.8271 },
        "ü": { top: 0.0041, h: 1.0441 },
        "0": { top: -0.0082, h: 1.0687 },
        "1": { top: -0.0041, h: 1.0441 },
        "2": { top: -0.0082, h: 1.0564 },
        "3": { top: 0.0, h: 1.0441 },
        "4": { top: 0.0082, h: 1.0359 },
        "5": { top: 0.0, h: 1.0441 },
        "6": { top: 0.0123, h: 1.0441 },
        "7": { top: -0.0082, h: 1.04 },
        "8": { top: -0.0082, h: 1.0687 },
        "9": { top: -0.0082, h: 1.0482 },
        ".": { top: 0.7984, h: 0.2416 },
        ",": { top: 0.823, h: 0.2948 },
        "-": { top: 0.5528, h: 0.1679 },
        "!": { top: -0.0369, h: 1.0687 },
        "?": { top: -0.0532, h: 1.085 },
        "'": { top: -0.0369, h: 0.4176 },
        "\"": { top: -0.0328, h: 0.4176 },
        "&": { top: -0.045, h: 1.0482 },
        "@": { top: -0.0696, h: 1.2693 },
        "#": { top: -0.0532, h: 1.0646 },
        "(": { top: -0.0409, h: 1.2898 },
        ")": { top: -0.045, h: 1.2939 },
        ":": { top: 0.3767, h: 0.6387 },
        ";": { top: 0.3767, h: 0.7616 },
        "/": { top: -0.0369, h: 1.1424 },
        "+": { top: 0.3071, h: 0.5773 },
        "=": { top: 0.3398, h: 0.4463 },
        "%": { top: -0.045, h: 1.04 }
      }
    },
    wilcom: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇĞİÖŞÜabcdefghijklmnopqrstuvwxyzçğıöşü0123456789.,-!?'\"&@#():;/+=%",
      gap: -0.1722,
      lowerGap: -0.1722,
      files: {
        "Ç": "font-wilcom-upper-ccedilla.png",
        "Ğ": "font-wilcom-upper-gbreve.png",
        "İ": "font-wilcom-upper-idot.png",
        "Ö": "font-wilcom-upper-odiaeresis.png",
        "Ş": "font-wilcom-upper-scedilla.png",
        "Ü": "font-wilcom-upper-udiaeresis.png",
        "ç": "font-wilcom-lower-ccedilla.png",
        "ğ": "font-wilcom-lower-gbreve.png",
        "ı": "font-wilcom-lower-dotlessi.png",
        "ö": "font-wilcom-lower-odiaeresis.png",
        "ş": "font-wilcom-lower-scedilla.png",
        "ü": "font-wilcom-lower-udiaeresis.png",
        ".": "font-wilcom-punct-period.png",
        ",": "font-wilcom-punct-comma.png",
        "-": "font-wilcom-punct-hyphen.png",
        "!": "font-wilcom-punct-exclamation.png",
        "?": "font-wilcom-punct-question.png",
        "'": "font-wilcom-punct-apostrophe.png",
        "\"": "font-wilcom-punct-quote.png",
        "&": "font-wilcom-punct-ampersand.png",
        "@": "font-wilcom-punct-at.png",
        "#": "font-wilcom-punct-hash.png",
        "(": "font-wilcom-punct-paren-left.png",
        ")": "font-wilcom-punct-paren-right.png",
        ":": "font-wilcom-punct-colon.png",
        ";": "font-wilcom-punct-semicolon.png",
        "/": "font-wilcom-punct-slash.png",
        "+": "font-wilcom-punct-plus.png",
        "=": "font-wilcom-punct-equals.png",
        "%": "font-wilcom-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0042, h: 1.0358 },
        B: { top: -0.0209, h: 1.0859 },
        C: { top: -0.0209, h: 1.0776 },
        D: { top: -0.0167, h: 1.0818 },
        E: { top: -0.0209, h: 1.0901 },
        F: { top: -0.0167, h: 1.0567 },
        G: { top: -0.0167, h: 1.0818 },
        H: { top: 0.0042, h: 1.0358 },
        I: { top: 0.0042, h: 1.0275 },
        J: { top: 0.0084, h: 1.0484 },
        K: { top: 0.0042, h: 1.0316 },
        L: { top: 0.0042, h: 1.0567 },
        M: { top: 0.0042, h: 1.0316 },
        N: { top: 0.0, h: 1.0316 },
        O: { top: -0.0167, h: 1.0776 },
        P: { top: -0.0167, h: 1.0525 },
        Q: { top: -0.0167, h: 1.3198 },
        R: { top: -0.0209, h: 1.0567 },
        S: { top: -0.0209, h: 1.0818 },
        T: { top: -0.0167, h: 1.0484 },
        U: { top: 0.0042, h: 1.0525 },
        V: { top: 0.0042, h: 1.0358 },
        W: { top: 0.0042, h: 1.0358 },
        X: { top: 0.0042, h: 1.0358 },
        Y: { top: -0.0084, h: 1.0651 },
        Z: { top: -0.0167, h: 1.0818 },
        "Ç": { top: -0.0209, h: 1.3741 },
        "Ğ": { top: -0.2422, h: 1.3073 },
        "İ": { top: -0.3258, h: 1.3574 },
        "Ö": { top: -0.3258, h: 1.3867 },
        "Ş": { top: -0.0209, h: 1.3741 },
        "Ü": { top: -0.3258, h: 1.3867 },
        a: { top: 0.2924, h: 0.7476 },
        b: { top: -0.0167, h: 1.0567 },
        c: { top: 0.2965, h: 0.7476 },
        d: { top: -0.0167, h: 1.0609 },
        e: { top: 0.2924, h: 0.7476 },
        f: { top: -0.0292, h: 1.0442 },
        g: { top: 0.3007, h: 1.0901 },
        h: { top: -0.0125, h: 1.0525 },
        i: { top: 0.0585, h: 0.9857 },
        j: { top: 0.0585, h: 1.3198 },
        k: { top: -0.0167, h: 1.0567 },
        l: { top: -0.0209, h: 1.0651 },
        m: { top: 0.3091, h: 0.7309 },
        n: { top: 0.3133, h: 0.7267 },
        o: { top: 0.2924, h: 0.7518 },
        p: { top: 0.2882, h: 1.0734 },
        q: { top: 0.2924, h: 1.0734 },
        r: { top: 0.284, h: 0.7267 },
        s: { top: 0.2924, h: 0.7476 },
        t: { top: 0.1044, h: 0.9356 },
        u: { top: 0.3133, h: 0.7267 },
        v: { top: 0.3133, h: 0.7267 },
        w: { top: 0.3133, h: 0.7059 },
        x: { top: 0.3174, h: 0.7226 },
        y: { top: 0.3174, h: 1.0525 },
        z: { top: 0.284, h: 0.7727 },
        "ç": { top: 0.2965, h: 0.7476 },
        "ğ": { top: 0.0501, h: 1.3407 },
        "ı": { top: 0.3216, h: 0.7226 },
        "ö": { top: -0.0292, h: 1.0734 },
        "ş": { top: 0.2924, h: 0.9815 },
        "ü": { top: -0.0292, h: 1.0692 },
        "0": { top: -0.0084, h: 1.0734 },
        "1": { top: 0.0042, h: 1.0358 },
        "2": { top: -0.0084, h: 1.0734 },
        "3": { top: -0.0084, h: 1.0692 },
        "4": { top: 0.0084, h: 1.0316 },
        "5": { top: -0.0084, h: 1.0734 },
        "6": { top: 0.0167, h: 1.0484 },
        "7": { top: -0.0084, h: 1.0484 },
        "8": { top: -0.0084, h: 1.0734 },
        "9": { top: -0.0084, h: 1.0442 },
        ".": { top: 0.756, h: 0.284 },
        ",": { top: 0.756, h: 0.4427 },
        "-": { top: 0.5931, h: 0.188 },
        "!": { top: -0.0418, h: 1.0859 },
        "?": { top: -0.0543, h: 1.0985 },
        "'": { top: 0.0042, h: 0.3258 },
        "\"": { top: 0.0084, h: 0.3258 },
        "&": { top: -0.0167, h: 1.0818 },
        "@": { top: -0.1002, h: 1.2071 },
        "#": { top: 0.0084, h: 1.0275 },
        "(": { top: -0.1963, h: 1.3867 },
        ")": { top: -0.1963, h: 1.395 },
        ":": { top: 0.3926, h: 0.6474 },
        ";": { top: 0.4051, h: 0.7936 },
        "/": { top: -0.0794, h: 1.1528 },
        "+": { top: 0.3049, h: 0.6223 },
        "=": { top: 0.497, h: 0.3968 },
        "%": { top: -0.0794, h: 1.1528 }
      }
    },
    casualserif: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇĞİÖŞÜabcdefghijklmnopqrstuvwxyzçğıöşü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0647,
      lowerGap: 0.0647,
      files: {
        "Ç": "font-casualserif-upper-ccedilla.png",
        "Ğ": "font-casualserif-upper-gbreve.png",
        "İ": "font-casualserif-upper-idot.png",
        "Ö": "font-casualserif-upper-odiaeresis.png",
        "Ş": "font-casualserif-upper-scedilla.png",
        "Ü": "font-casualserif-upper-udiaeresis.png",
        "ç": "font-casualserif-lower-ccedilla.png",
        "ğ": "font-casualserif-lower-gbreve.png",
        "ı": "font-casualserif-lower-dotlessi.png",
        "ö": "font-casualserif-lower-odiaeresis.png",
        "ş": "font-casualserif-lower-scedilla.png",
        "ü": "font-casualserif-lower-udiaeresis.png",
        ".": "font-casualserif-punct-period.png",
        ",": "font-casualserif-punct-comma.png",
        "-": "font-casualserif-punct-hyphen.png",
        "!": "font-casualserif-punct-exclamation.png",
        "?": "font-casualserif-punct-question.png",
        "'": "font-casualserif-punct-apostrophe.png",
        "\"": "font-casualserif-punct-quote.png",
        "&": "font-casualserif-punct-ampersand.png",
        "@": "font-casualserif-punct-at.png",
        "#": "font-casualserif-punct-hash.png",
        "(": "font-casualserif-punct-paren-left.png",
        ")": "font-casualserif-punct-paren-right.png",
        ":": "font-casualserif-punct-colon.png",
        ";": "font-casualserif-punct-semicolon.png",
        "/": "font-casualserif-punct-slash.png",
        "+": "font-casualserif-punct-plus.png",
        "=": "font-casualserif-punct-equals.png",
        "%": "font-casualserif-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0121, h: 1.0036 },
        B: { top: 0.0283, h: 0.9914 },
        C: { top: -0.0526, h: 1.0764 },
        D: { top: -0.004, h: 1.036 },
        E: { top: -0.004, h: 1.0562 },
        F: { top: 0.004, h: 1.0117 },
        G: { top: -0.0081, h: 1.0481 },
        H: { top: -0.0607, h: 1.1371 },
        I: { top: 0.0081, h: 1.0279 },
        J: { top: -0.0081, h: 1.0521 },
        K: { top: -0.0243, h: 1.0643 },
        L: { top: 0.0121, h: 1.0157 },
        M: { top: -0.0081, h: 1.0521 },
        N: { top: 0.0243, h: 1.0198 },
        O: { top: 0.0405, h: 0.9874 },
        P: { top: 0.0243, h: 1.0117 },
        Q: { top: -0.004, h: 1.2181 },
        R: { top: 0.004, h: 1.044 },
        S: { top: -0.0728, h: 1.1412 },
        T: { top: -0.0162, h: 1.0562 },
        U: { top: 0.004, h: 1.0238 },
        V: { top: -0.0162, h: 1.0521 },
        W: { top: -0.004, h: 1.04 },
        X: { top: 0.0121, h: 1.04 },
        Y: { top: 0.0, h: 1.044 },
        Z: { top: -0.0202, h: 1.0967 },
        "Ç": { top: -0.0283, h: 1.3314 },
        "Ğ": { top: -0.0081, h: 1.0481 },
        "İ": { top: -0.2711, h: 1.3071 },
        "Ö": { top: -0.2711, h: 1.3273 },
        "Ş": { top: -0.0728, h: 1.3759 },
        "Ü": { top: -0.2711, h: 1.3192 },
        a: { top: 0.3359, h: 0.7082 },
        b: { top: 0.0081, h: 1.0279 },
        c: { top: 0.2833, h: 0.7567 },
        d: { top: 0.0, h: 1.04 },
        e: { top: 0.2954, h: 0.7405 },
        f: { top: -0.004, h: 1.04 },
        g: { top: 0.3237, h: 1.0805 },
        h: { top: 0.0405, h: 1.0036 },
        i: { top: 0.0526, h: 0.9753 },
        j: { top: 0.0243, h: 1.2868 },
        k: { top: 0.0364, h: 1.0076 },
        l: { top: 0.0405, h: 0.9995 },
        m: { top: 0.3521, h: 0.6879 },
        n: { top: 0.348, h: 0.6879 },
        o: { top: 0.3561, h: 0.6879 },
        p: { top: 0.3035, h: 1.0602 },
        q: { top: 0.3399, h: 1.0724 },
        r: { top: 0.344, h: 0.6839 },
        s: { top: 0.3399, h: 0.7082 },
        t: { top: 0.1781, h: 0.8539 },
        u: { top: 0.348, h: 0.6839 },
        v: { top: 0.344, h: 0.7122 },
        w: { top: 0.3521, h: 0.692 },
        x: { top: 0.3156, h: 0.7325 },
        y: { top: 0.344, h: 0.9914 },
        z: { top: 0.344, h: 0.7041 },
        "ç": { top: 0.2833, h: 0.9429 },
        "ğ": { top: 0.0567, h: 1.3475 },
        "ı": { top: 0.3521, h: 0.6758 },
        "ö": { top: 0.0728, h: 0.9672 },
        "ş": { top: 0.3399, h: 0.8862 },
        "ü": { top: 0.0728, h: 0.9672 },
        "0": { top: 0.004, h: 1.04 },
        "1": { top: 0.0364, h: 1.0036 },
        "2": { top: 0.0202, h: 1.0279 },
        "3": { top: 0.0567, h: 0.9753 },
        "4": { top: 0.0445, h: 0.9955 },
        "5": { top: 0.0405, h: 0.9995 },
        "6": { top: 0.0324, h: 1.0117 },
        "7": { top: 0.0364, h: 0.9955 },
        "8": { top: 0.0121, h: 1.04 },
        "9": { top: 0.0243, h: 1.0117 },
        ".": { top: 0.8174, h: 0.2226 },
        ",": { top: 0.7891, h: 0.3844 },
        "-": { top: 0.5989, h: 0.1902 },
        "!": { top: -0.0324, h: 1.0764 },
        "?": { top: -0.004, h: 1.04 },
        "'": { top: -0.089, h: 0.4694 },
        "\"": { top: -0.089, h: 0.4735 },
        "&": { top: -0.0647, h: 1.1088 },
        "@": { top: -0.0364, h: 1.2342 },
        "#": { top: 0.004, h: 1.0562 },
        "(": { top: -0.0364, h: 1.2221 },
        ")": { top: -0.0405, h: 1.2221 },
        ":": { top: 0.4977, h: 0.5463 },
        ";": { top: 0.4977, h: 0.6798 },
        "/": { top: 0.004, h: 1.0521 },
        "+": { top: 0.3763, h: 0.6111 },
        "=": { top: 0.4128, h: 0.433 },
        "%": { top: -0.089, h: 1.1493 }
      }
    },
    adelle: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0595,
      lowerGap: 0.0476,
      files: {
        "Ç": "font-adelle-upper-ccedilla.png",
        "Ö": "font-adelle-upper-odiaeresis.png",
        "Ü": "font-adelle-upper-udiaeresis.png",
        "ç": "font-adelle-lower-ccedilla.png",
        "ö": "font-adelle-lower-odiaeresis.png",
        "ü": "font-adelle-lower-udiaeresis.png",
        ".": "font-adelle-punct-period.png",
        ",": "font-adelle-punct-comma.png",
        "-": "font-adelle-punct-hyphen.png",
        "!": "font-adelle-punct-exclamation.png",
        "?": "font-adelle-punct-question.png",
        "'": "font-adelle-punct-apostrophe.png",
        "\"": "font-adelle-punct-quote.png",
        "&": "font-adelle-punct-ampersand.png",
        "@": "font-adelle-punct-at.png",
        "#": "font-adelle-punct-hash.png",
        "(": "font-adelle-punct-paren-left.png",
        ")": "font-adelle-punct-paren-right.png",
        ":": "font-adelle-punct-colon.png",
        ";": "font-adelle-punct-semicolon.png",
        "/": "font-adelle-punct-slash.png",
        "+": "font-adelle-punct-plus.png",
        "=": "font-adelle-punct-equals.png",
        "%": "font-adelle-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0318, h: 1.0043 },
        B: { top: 0.0, h: 1.036 },
        C: { top: -0.004, h: 1.0479 },
        D: { top: 0.0, h: 1.036 },
        E: { top: -0.004, h: 1.044 },
        F: { top: -0.004, h: 1.04 },
        G: { top: -0.004, h: 1.0479 },
        H: { top: 0.0, h: 1.04 },
        I: { top: 0.004, h: 1.036 },
        J: { top: 0.004, h: 1.04 },
        K: { top: 0.0, h: 1.04 },
        L: { top: 0.004, h: 1.036 },
        M: { top: 0.0, h: 1.04 },
        N: { top: -0.004, h: 1.044 },
        O: { top: -0.0079, h: 1.0559 },
        P: { top: 0.0, h: 1.036 },
        Q: { top: -0.004, h: 1.302 },
        R: { top: 0.0, h: 1.04 },
        S: { top: -0.004, h: 1.0519 },
        T: { top: -0.004, h: 1.04 },
        U: { top: 0.004, h: 1.04 },
        V: { top: 0.004, h: 1.0003 },
        W: { top: 0.004, h: 1.0003 },
        X: { top: 0.004, h: 1.036 },
        Y: { top: 0.004, h: 1.0321 },
        Z: { top: -0.004, h: 1.0479 },
        "Ç": { top: 0.0, h: 1.3576 },
        "Ö": { top: -0.2501, h: 1.298 },
        "Ü": { top: -0.2501, h: 1.2901 },
        a: { top: 0.2858, h: 0.7582 },
        b: { top: 0.004, h: 1.036 },
        c: { top: 0.2858, h: 0.7582 },
        d: { top: 0.004, h: 1.036 },
        e: { top: 0.2858, h: 0.7582 },
        f: { top: 0.004, h: 1.0321 },
        g: { top: 0.2858, h: 1.0598 },
        h: { top: 0.004, h: 1.036 },
        i: { top: 0.004, h: 1.0321 },
        j: { top: 0.004, h: 1.3337 },
        k: { top: 0.004, h: 1.036 },
        l: { top: 0.004, h: 1.036 },
        m: { top: 0.2818, h: 0.7582 },
        n: { top: 0.2818, h: 0.7582 },
        o: { top: 0.2858, h: 0.7582 },
        p: { top: 0.2818, h: 1.0479 },
        q: { top: 0.2818, h: 1.044 },
        r: { top: 0.2818, h: 0.7542 },
        s: { top: 0.2858, h: 0.7582 },
        t: { top: 0.0953, h: 0.9487 },
        u: { top: 0.2858, h: 0.7621 },
        v: { top: 0.2898, h: 0.7185 },
        w: { top: 0.2898, h: 0.7185 },
        x: { top: 0.2898, h: 0.7463 },
        y: { top: 0.2898, h: 1.0281 },
        z: { top: 0.2858, h: 0.7542 },
        "ç": { top: 0.2858, h: 1.0757 },
        "ö": { top: 0.004, h: 1.044 },
        "ü": { top: 0.004, h: 1.0479 },
        "0": { top: -0.0556, h: 1.0479 },
        "1": { top: -0.0516, h: 1.036 },
        "2": { top: -0.0556, h: 1.044 },
        "3": { top: -0.0556, h: 1.1829 },
        "4": { top: -0.0278, h: 1.1194 },
        "5": { top: -0.127, h: 1.2544 },
        "6": { top: -0.1707, h: 1.1631 },
        "7": { top: -0.0556, h: 1.1472 },
        "8": { top: -0.1707, h: 1.1631 },
        "9": { top: -0.0556, h: 1.1829 },
        ".": { top: 0.8534, h: 0.1866 },
        ",": { top: 0.8336, h: 0.3414 },
        "-": { top: 0.5398, h: 0.2104 },
        "!": { top: 0.0675, h: 0.9725 },
        "?": { top: 0.0437, h: 0.9963 },
        "'": { top: 0.004, h: 0.3295 },
        "\"": { top: 0.004, h: 0.3295 },
        "&": { top: 0.1072, h: 0.9685 },
        "@": { top: 0.2501, h: 1.0479 },
        "#": { top: 0.2898, h: 0.7463 },
        "(": { top: 0.0476, h: 1.2147 },
        ")": { top: 0.0476, h: 1.2147 },
        ":": { top: 0.3453, h: 0.6947 },
        ";": { top: 0.3453, h: 0.8296 },
        "/": { top: 0.0159, h: 1.1432 },
        "+": { top: 0.3334, h: 0.5438 },
        "=": { top: 0.4247, h: 0.4605 },
        "%": { top: 0.1667, h: 0.909 }
      }
    },
    advent: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜ0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0576,
      lowerGap: 0.0576,
      forceUppercase: true,
      files: {
        "Ç": "font-advent-upper-ccedilla.png",
        "Ö": "font-advent-upper-odiaeresis.png",
        "Ü": "font-advent-upper-udiaeresis.png",
        ".": "font-advent-punct-period.png",
        ",": "font-advent-punct-comma.png",
        "-": "font-advent-punct-hyphen.png",
        "!": "font-advent-punct-exclamation.png",
        "?": "font-advent-punct-question.png",
        "'": "font-advent-punct-apostrophe.png",
        "\"": "font-advent-punct-quote.png",
        "&": "font-advent-punct-ampersand.png",
        "@": "font-advent-punct-at.png",
        "#": "font-advent-punct-hash.png",
        "(": "font-advent-punct-paren-left.png",
        ")": "font-advent-punct-paren-right.png",
        ":": "font-advent-punct-colon.png",
        ";": "font-advent-punct-semicolon.png",
        "/": "font-advent-punct-slash.png",
        "+": "font-advent-punct-plus.png",
        "=": "font-advent-punct-equals.png",
        "%": "font-advent-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.004, h: 1.0321 },
        B: { top: -0.0119, h: 1.0559 },
        C: { top: 0.0, h: 1.044 },
        D: { top: -0.004, h: 1.0598 },
        E: { top: 0.0, h: 1.04 },
        F: { top: 0.0, h: 1.04 },
        G: { top: -0.004, h: 1.0519 },
        H: { top: 0.0079, h: 1.0281 },
        I: { top: 0.0079, h: 1.0281 },
        J: { top: 0.0079, h: 1.0559 },
        K: { top: 0.004, h: 1.036 },
        L: { top: 0.0079, h: 1.036 },
        M: { top: -0.0119, h: 1.0479 },
        N: { top: -0.0119, h: 1.0479 },
        O: { top: -0.004, h: 1.044 },
        P: { top: -0.0119, h: 1.0479 },
        Q: { top: 0.0, h: 1.1472 },
        R: { top: -0.0079, h: 1.044 },
        S: { top: -0.0159, h: 1.0678 },
        T: { top: 0.0, h: 1.036 },
        U: { top: 0.0119, h: 1.04 },
        V: { top: 0.0079, h: 1.0479 },
        W: { top: 0.0079, h: 1.0519 },
        X: { top: 0.0079, h: 1.0321 },
        Y: { top: 0.0079, h: 1.0321 },
        Z: { top: 0.0, h: 1.044 },
        "Ç": { top: 0.004, h: 1.3536 },
        "Ö": { top: -0.2342, h: 1.2821 },
        "Ü": { top: -0.2342, h: 1.2861 },
        "0": { top: -0.0159, h: 1.0638 },
        "1": { top: 0.0119, h: 1.0321 },
        "2": { top: -0.0159, h: 1.0638 },
        "3": { top: -0.0159, h: 1.0638 },
        "4": { top: -0.0159, h: 1.0559 },
        "5": { top: -0.0159, h: 1.0638 },
        "6": { top: -0.0159, h: 1.0559 },
        "7": { top: -0.0159, h: 1.0559 },
        "8": { top: -0.0159, h: 1.0559 },
        "9": { top: -0.0119, h: 1.0559 },
        ".": { top: 0.8415, h: 0.1985 },
        ",": { top: 0.8415, h: 0.2898 },
        "-": { top: 0.5359, h: 0.1945 },
        "!": { top: -0.0238, h: 1.0678 },
        "?": { top: -0.0278, h: 1.0718 },
        "'": { top: -0.0079, h: 0.3056 },
        "\"": { top: -0.0357, h: 0.3096 },
        "&": { top: 0.0278, h: 0.9765 },
        "@": { top: -0.0079, h: 1.0281 },
        "#": { top: 0.0198, h: 1.0082 },
        "(": { top: -0.1548, h: 1.3417 },
        ")": { top: -0.1548, h: 1.3417 },
        ":": { top: 0.5676, h: 0.4684 },
        ";": { top: 0.5716, h: 0.5637 },
        "/": { top: 0.0079, h: 1.0241 },
        "+": { top: 0.2183, h: 0.8217 },
        "=": { top: 0.5756, h: 0.4049 },
        "%": { top: -0.0278, h: 1.1115 }
      }
    },
    algerian: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜ0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0672,
      lowerGap: 0.0672,
      forceUppercase: true,
      files: {
        "Ç": "font-algerian-upper-ccedilla.png",
        "Ö": "font-algerian-upper-odiaeresis.png",
        "Ü": "font-algerian-upper-udiaeresis.png",
        ".": "font-algerian-punct-period.png",
        ",": "font-algerian-punct-comma.png",
        "-": "font-algerian-punct-hyphen.png",
        "!": "font-algerian-punct-exclamation.png",
        "?": "font-algerian-punct-question.png",
        "'": "font-algerian-punct-apostrophe.png",
        "\"": "font-algerian-punct-quote.png",
        "&": "font-algerian-punct-ampersand.png",
        "@": "font-algerian-punct-at.png",
        "#": "font-algerian-punct-hash.png",
        "(": "font-algerian-punct-paren-left.png",
        ")": "font-algerian-punct-paren-right.png",
        ":": "font-algerian-punct-colon.png",
        ";": "font-algerian-punct-semicolon.png",
        "/": "font-algerian-punct-slash.png",
        "+": "font-algerian-punct-plus.png",
        "=": "font-algerian-punct-equals.png",
        "%": "font-algerian-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.004, h: 1.04 },
        B: { top: -0.0119, h: 1.0598 },
        C: { top: -0.0237, h: 1.0914 },
        D: { top: 0.0, h: 1.044 },
        E: { top: 0.004, h: 1.0321 },
        F: { top: 0.0, h: 1.0281 },
        G: { top: -0.004, h: 1.0479 },
        H: { top: 0.004, h: 1.036 },
        I: { top: 0.004, h: 1.036 },
        J: { top: 0.004, h: 1.0519 },
        K: { top: 0.0, h: 1.044 },
        L: { top: 0.004, h: 1.04 },
        M: { top: 0.004, h: 1.036 },
        N: { top: 0.0079, h: 1.0321 },
        O: { top: -0.0079, h: 1.0637 },
        P: { top: 0.0, h: 1.04 },
        Q: { top: -0.0198, h: 1.2417 },
        R: { top: -0.0158, h: 1.1784 },
        S: { top: -0.0158, h: 1.0716 },
        T: { top: 0.004, h: 1.0321 },
        U: { top: 0.004, h: 1.0519 },
        V: { top: -0.2412, h: 1.2812 },
        W: { top: -0.2729, h: 1.3168 },
        X: { top: 0.0079, h: 1.0281 },
        Y: { top: -0.2689, h: 1.3089 },
        Z: { top: -0.0079, h: 1.0519 },
        "Ç": { top: -0.0198, h: 1.3998 },
        "Ö": { top: -0.2847, h: 1.3366 },
        "Ü": { top: -0.2847, h: 1.3445 },
        "0": { top: -0.0198, h: 1.0756 },
        "1": { top: 0.0198, h: 1.0163 },
        "2": { top: -0.0079, h: 1.0519 },
        "3": { top: -0.0277, h: 1.0875 },
        "4": { top: 0.0158, h: 1.0242 },
        "5": { top: -0.1068, h: 1.1863 },
        "6": { top: -0.0277, h: 1.0914 },
        "7": { top: 0.0119, h: 1.0281 },
        "8": { top: -0.2214, h: 1.301 },
        "9": { top: -0.004, h: 1.2259 },
        ".": { top: 0.8027, h: 0.2373 },
        ",": { top: 0.8106, h: 0.4231 },
        "-": { top: 0.4468, h: 0.1424 },
        "!": { top: 0.0119, h: 1.0914 },
        "?": { top: 0.0158, h: 1.0875 },
        "'": { top: -0.0079, h: 0.3519 },
        "\"": { top: -0.0079, h: 0.3519 },
        "&": { top: -0.0435, h: 1.0716 },
        "@": { top: -0.0316, h: 1.0756 },
        "#": { top: -0.0158, h: 1.044 },
        "(": { top: -0.1424, h: 1.3168 },
        ")": { top: -0.1424, h: 1.3287 },
        ":": { top: 0.2254, h: 0.8106 },
        ";": { top: 0.2294, h: 1.0044 },
        "/": { top: -0.1424, h: 1.3168 },
        "+": { top: 0.1582, h: 0.6722 },
        "=": { top: 0.3005, h: 0.4113 },
        "%": { top: -0.0435, h: 1.131 }
      }
    },
    angleblock: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.065,
      lowerGap: 0.065,
      files: {
        "Ç": "font-angleblock-upper-ccedilla.png",
        "Ö": "font-angleblock-upper-odiaeresis.png",
        "Ü": "font-angleblock-upper-udiaeresis.png",
        "ç": "font-angleblock-lower-ccedilla.png",
        "ö": "font-angleblock-lower-odiaeresis.png",
        "ü": "font-angleblock-lower-udiaeresis.png",
        ".": "font-angleblock-punct-period.png",
        ",": "font-angleblock-punct-comma.png",
        "-": "font-angleblock-punct-hyphen.png",
        "!": "font-angleblock-punct-exclamation.png",
        "?": "font-angleblock-punct-question.png",
        "'": "font-angleblock-punct-apostrophe.png",
        "\"": "font-angleblock-punct-quote.png",
        "&": "font-angleblock-punct-ampersand.png",
        "@": "font-angleblock-punct-at.png",
        "#": "font-angleblock-punct-hash.png",
        "(": "font-angleblock-punct-paren-left.png",
        ")": "font-angleblock-punct-paren-right.png",
        ":": "font-angleblock-punct-colon.png",
        ";": "font-angleblock-punct-semicolon.png",
        "/": "font-angleblock-punct-slash.png",
        "+": "font-angleblock-punct-plus.png",
        "=": "font-angleblock-punct-equals.png",
        "%": "font-angleblock-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.004, h: 1.036 },
        B: { top: -0.004, h: 1.044 },
        C: { top: 0.0, h: 1.044 },
        D: { top: 0.0, h: 1.044 },
        E: { top: 0.0, h: 1.044 },
        F: { top: 0.0, h: 1.036 },
        G: { top: -0.004, h: 1.048 },
        H: { top: 0.0, h: 1.04 },
        I: { top: 0.0, h: 1.036 },
        J: { top: 0.0, h: 1.044 },
        K: { top: 0.004, h: 1.036 },
        L: { top: 0.0, h: 1.044 },
        M: { top: 0.0, h: 1.04 },
        N: { top: 0.004, h: 1.036 },
        O: { top: -0.004, h: 1.048 },
        P: { top: 0.0, h: 1.036 },
        Q: { top: -0.004, h: 1.044 },
        R: { top: -0.004, h: 1.044 },
        S: { top: 0.004, h: 1.044 },
        T: { top: 0.004, h: 1.036 },
        U: { top: 0.004, h: 1.04 },
        V: { top: 0.0, h: 1.036 },
        W: { top: 0.004, h: 1.036 },
        X: { top: 0.004, h: 1.036 },
        Y: { top: 0.004, h: 1.032 },
        Z: { top: -0.004, h: 1.048 },
        "Ç": { top: 0.0, h: 1.344 },
        "Ö": { top: -0.252, h: 1.296 },
        "Ü": { top: -0.252, h: 1.3 },
        a: { top: 0.288, h: 0.756 },
        b: { top: 0.02, h: 1.02 },
        c: { top: 0.292, h: 0.752 },
        d: { top: 0.02, h: 1.024 },
        e: { top: 0.288, h: 0.76 },
        f: { top: 0.02, h: 1.02 },
        g: { top: 0.288, h: 1.232 },
        h: { top: 0.02, h: 1.016 },
        i: { top: 0.02, h: 1.016 },
        j: { top: 0.02, h: 1.5 },
        k: { top: 0.02, h: 1.02 },
        l: { top: 0.02, h: 1.016 },
        m: { top: 0.288, h: 0.748 },
        n: { top: 0.288, h: 0.748 },
        o: { top: 0.288, h: 0.756 },
        p: { top: 0.288, h: 1.232 },
        q: { top: 0.292, h: 1.228 },
        r: { top: 0.292, h: 0.744 },
        s: { top: 0.296, h: 0.752 },
        t: { top: 0.02, h: 1.016 },
        u: { top: 0.292, h: 0.748 },
        v: { top: 0.292, h: 0.748 },
        w: { top: 0.296, h: 0.744 },
        x: { top: 0.296, h: 0.74 },
        y: { top: 0.292, h: 1.228 },
        z: { top: 0.288, h: 0.756 },
        "ç": { top: 0.292, h: 1.072 },
        "ö": { top: 0.02, h: 1.02 },
        "ü": { top: 0.02, h: 1.024 },
        "0": { top: 0.008, h: 1.032 },
        "1": { top: 0.008, h: 1.032 },
        "2": { top: 0.008, h: 1.032 },
        "3": { top: 0.008, h: 1.032 },
        "4": { top: 0.008, h: 1.032 },
        "5": { top: 0.008, h: 1.032 },
        "6": { top: 0.008, h: 1.032 },
        "7": { top: 0.008, h: 1.032 },
        "8": { top: 0.008, h: 1.032 },
        "9": { top: 0.008, h: 1.032 },
        ".": { top: 0.852, h: 0.188 },
        ",": { top: 0.852, h: 0.336 },
        "-": { top: 0.428, h: 0.188 },
        "!": { top: 0.008, h: 1.036 },
        "?": { top: -0.004, h: 1.044 },
        "'": { top: 0.004, h: 0.34 },
        "\"": { top: 0.004, h: 0.344 },
        "&": { top: 0.0, h: 1.044 },
        "@": { top: -0.076, h: 1.312 },
        "#": { top: 0.112, h: 0.82 },
        "(": { top: 0.004, h: 1.036 },
        ")": { top: 0.004, h: 1.036 },
        ":": { top: 0.564, h: 0.476 },
        ";": { top: 0.564, h: 0.62 },
        "/": { top: -0.024, h: 1.124 },
        "+": { top: 0.252, h: 0.536 },
        "=": { top: 0.276, h: 0.488 },
        "%": { top: 0.0, h: 1.052 }
      }
    },
    arialrounded: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇĞİÖŞÜabcdefghijklmnopqrstuvwxyzçğıöşü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.1265,
      lowerGap: 0.1205,
      files: {
        "Ç": "font-arialrounded-upper-ccedilla.png",
        "Ğ": "font-arialrounded-upper-gbreve.png",
        "İ": "font-arialrounded-upper-idot.png",
        "Ö": "font-arialrounded-upper-odiaeresis.png",
        "Ş": "font-arialrounded-upper-scedilla.png",
        "Ü": "font-arialrounded-upper-udiaeresis.png",
        "ç": "font-arialrounded-lower-ccedilla.png",
        "ğ": "font-arialrounded-lower-gbreve.png",
        "ı": "font-arialrounded-lower-dotlessi.png",
        "ö": "font-arialrounded-lower-odiaeresis.png",
        "ş": "font-arialrounded-lower-scedilla.png",
        "ü": "font-arialrounded-lower-udiaeresis.png",
        ".": "font-arialrounded-punct-period.png",
        ",": "font-arialrounded-punct-comma.png",
        "-": "font-arialrounded-punct-hyphen.png",
        "!": "font-arialrounded-punct-exclamation.png",
        "?": "font-arialrounded-punct-question.png",
        "'": "font-arialrounded-punct-apostrophe.png",
        "\"": "font-arialrounded-punct-quote.png",
        "&": "font-arialrounded-punct-ampersand.png",
        "@": "font-arialrounded-punct-at.png",
        "#": "font-arialrounded-punct-hash.png",
        "(": "font-arialrounded-punct-paren-left.png",
        ")": "font-arialrounded-punct-paren-right.png",
        ":": "font-arialrounded-punct-colon.png",
        ";": "font-arialrounded-punct-semicolon.png",
        "/": "font-arialrounded-punct-slash.png",
        "+": "font-arialrounded-punct-plus.png",
        "=": "font-arialrounded-punct-equals.png",
        "%": "font-arialrounded-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.008, h: 1.044 },
        B: { top: 0.008, h: 1.0239 },
        C: { top: -0.008, h: 1.0601 },
        D: { top: 0.004, h: 1.032 },
        E: { top: -0.008, h: 1.028 },
        F: { top: -0.008, h: 1.048 },
        G: { top: 0.0, h: 1.048 },
        H: { top: 0.0, h: 1.052 },
        I: { top: 0.0, h: 1.048 },
        J: { top: -0.012, h: 1.048 },
        K: { top: -0.012, h: 1.0561 },
        L: { top: -0.008, h: 1.036 },
        M: { top: 0.0, h: 1.036 },
        N: { top: 0.0, h: 1.048 },
        O: { top: -0.008, h: 1.0561 },
        P: { top: 0.0, h: 1.04 },
        Q: { top: -0.008, h: 1.1283 },
        R: { top: 0.004, h: 1.032 },
        S: { top: -0.012, h: 1.052 },
        T: { top: 0.004, h: 1.028 },
        U: { top: -0.012, h: 1.052 },
        V: { top: -0.008, h: 1.052 },
        W: { top: -0.012, h: 1.052 },
        X: { top: -0.012, h: 1.052 },
        Y: { top: -0.012, h: 1.0561 },
        Z: { top: 0.0, h: 1.0239 },
        "Ç": { top: -0.012, h: 1.3171 },
        "Ğ": { top: -0.2771, h: 1.3251 },
        "İ": { top: 0.0, h: 1.048 },
        "Ö": { top: -0.3092, h: 1.3452 },
        "Ş": { top: -0.008, h: 1.3131 },
        "Ü": { top: -0.3092, h: 1.3412 },
        a: { top: 0.261, h: 0.783 },
        b: { top: -0.008, h: 1.052 },
        c: { top: 0.261, h: 0.779 },
        d: { top: -0.008, h: 1.048 },
        e: { top: 0.265, h: 0.775 },
        f: { top: -0.004, h: 1.052 },
        g: { top: 0.269, h: 1.048 },
        h: { top: 0.012, h: 1.052 },
        i: { top: -0.0321, h: 1.0802 },
        j: { top: -0.0321, h: 1.3452 },
        k: { top: 0.004, h: 1.0561 },
        l: { top: 0.008, h: 1.048 },
        m: { top: 0.265, h: 0.779 },
        n: { top: 0.265, h: 0.779 },
        o: { top: 0.261, h: 0.775 },
        p: { top: 0.261, h: 1.052 },
        q: { top: 0.265, h: 1.044 },
        r: { top: 0.261, h: 0.779 },
        s: { top: 0.261, h: 0.779 },
        t: { top: 0.012, h: 1.032 },
        u: { top: 0.261, h: 0.779 },
        v: { top: 0.261, h: 0.779 },
        w: { top: 0.257, h: 0.783 },
        x: { top: 0.253, h: 0.787 },
        y: { top: 0.257, h: 1.052 },
        z: { top: 0.2771, h: 0.7589 },
        "ç": { top: 0.257, h: 1.048 },
        "ğ": { top: -0.0161, h: 1.3331 },
        "ı": { top: 0.2731, h: 0.775 },
        "ö": { top: -0.0321, h: 1.0761 },
        "ş": { top: 0.261, h: 1.044 },
        "ü": { top: -0.0321, h: 1.0761 },
        "0": { top: 0.0161, h: 1.032 },
        "1": { top: 0.012, h: 1.032 },
        "2": { top: 0.0201, h: 1.0199 },
        "3": { top: 0.012, h: 1.028 },
        "4": { top: 0.012, h: 1.036 },
        "5": { top: 0.0161, h: 1.028 },
        "6": { top: 0.012, h: 1.028 },
        "7": { top: 0.012, h: 1.028 },
        "8": { top: 0.012, h: 1.028 },
        "9": { top: 0.012, h: 1.028 },
        ".": { top: 0.8031, h: 0.2369 },
        ",": { top: 0.8031, h: 0.4417 },
        "-": { top: 0.5501, h: 0.2008 },
        "!": { top: 0.008, h: 1.1324 },
        "?": { top: 0.008, h: 1.1324 },
        "'": { top: 0.0241, h: 0.3855 },
        "\"": { top: 0.0241, h: 0.3855 },
        "&": { top: 0.008, h: 1.0561 },
        "@": { top: -0.012, h: 1.2448 },
        "#": { top: 0.0, h: 1.04 },
        "(": { top: -0.008, h: 1.301 },
        ")": { top: -0.008, h: 1.301 },
        ":": { top: 0.261, h: 0.775 },
        ";": { top: 0.261, h: 0.9798 },
        "/": { top: 0.008, h: 1.0601 },
        "+": { top: 0.3815, h: 0.5341 },
        "=": { top: 0.4297, h: 0.4417 },
        "%": { top: 0.008, h: 1.0721 }
      }
    },
    civic: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.0595,
      lowerGap: 0.0675,
      files: {
        "Ç": "font-civic-upper-ccedilla.png",
        "Ö": "font-civic-upper-odiaeresis.png",
        "Ü": "font-civic-upper-udiaeresis.png",
        "ç": "font-civic-lower-ccedilla.png",
        "ö": "font-civic-lower-odiaeresis.png",
        "ü": "font-civic-lower-udiaeresis.png",
        ".": "font-civic-punct-period.png",
        ",": "font-civic-punct-comma.png",
        "-": "font-civic-punct-hyphen.png",
        "!": "font-civic-punct-exclamation.png",
        "?": "font-civic-punct-question.png",
        "'": "font-civic-punct-apostrophe.png",
        "\"": "font-civic-punct-quote.png",
        "&": "font-civic-punct-ampersand.png",
        "@": "font-civic-punct-at.png",
        "#": "font-civic-punct-hash.png",
        "(": "font-civic-punct-paren-left.png",
        ")": "font-civic-punct-paren-right.png",
        ":": "font-civic-punct-colon.png",
        ";": "font-civic-punct-semicolon.png",
        "/": "font-civic-punct-slash.png",
        "+": "font-civic-punct-plus.png",
        "=": "font-civic-punct-equals.png",
        "%": "font-civic-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.0079, h: 1.036 },
        B: { top: 0.0, h: 1.044 },
        C: { top: 0.0, h: 1.04 },
        D: { top: 0.0, h: 1.044 },
        E: { top: 0.0, h: 1.044 },
        F: { top: -0.004, h: 1.044 },
        G: { top: 0.004, h: 1.044 },
        H: { top: 0.0079, h: 1.04 },
        I: { top: 0.0, h: 1.04 },
        J: { top: -0.004, h: 1.044 },
        K: { top: 0.0079, h: 1.036 },
        L: { top: 0.004, h: 1.036 },
        M: { top: -0.004, h: 1.0519 },
        N: { top: -0.004, h: 1.04 },
        O: { top: 0.0, h: 1.044 },
        P: { top: -0.004, h: 1.0479 },
        Q: { top: 0.004, h: 1.1353 },
        R: { top: 0.004, h: 1.036 },
        S: { top: 0.0, h: 1.044 },
        T: { top: -0.004, h: 1.044 },
        U: { top: 0.0079, h: 1.036 },
        V: { top: 0.004, h: 1.0281 },
        W: { top: 0.004, h: 1.0321 },
        X: { top: 0.0079, h: 1.0321 },
        Y: { top: 0.004, h: 1.036 },
        Z: { top: -0.0079, h: 1.0559 },
        "Ç": { top: 0.0119, h: 1.2385 },
        "Ö": { top: -0.1826, h: 1.2226 },
        "Ü": { top: -0.1826, h: 1.2305 },
        a: { top: 0.3493, h: 0.6907 },
        b: { top: 0.0119, h: 1.0281 },
        c: { top: 0.3453, h: 0.6986 },
        d: { top: 0.0119, h: 1.0281 },
        e: { top: 0.3493, h: 0.6907 },
        f: { top: 0.0119, h: 1.0281 },
        g: { top: 0.3493, h: 0.9805 },
        h: { top: 0.0119, h: 1.0281 },
        i: { top: 0.1508, h: 0.8892 },
        j: { top: 0.1508, h: 1.1789 },
        k: { top: 0.0119, h: 1.0281 },
        l: { top: 0.0119, h: 1.0241 },
        m: { top: 0.3493, h: 0.6907 },
        n: { top: 0.3453, h: 0.6947 },
        o: { top: 0.3533, h: 0.6907 },
        p: { top: 0.3493, h: 0.9805 },
        q: { top: 0.3493, h: 0.9805 },
        r: { top: 0.3453, h: 0.6907 },
        s: { top: 0.3453, h: 0.6947 },
        t: { top: 0.1429, h: 0.8931 },
        u: { top: 0.3453, h: 0.6947 },
        v: { top: 0.3493, h: 0.6788 },
        w: { top: 0.3493, h: 0.6827 },
        x: { top: 0.3453, h: 0.6986 },
        y: { top: 0.3453, h: 0.9844 },
        z: { top: 0.3414, h: 0.6986 },
        "ç": { top: 0.3453, h: 0.8971 },
        "ö": { top: 0.1627, h: 0.8773 },
        "ü": { top: 0.1826, h: 0.8614 },
        "0": { top: 0.0397, h: 1.0003 },
        "1": { top: 0.0476, h: 0.9924 },
        "2": { top: 0.0397, h: 1.0003 },
        "3": { top: 0.0397, h: 1.0003 },
        "4": { top: 0.0476, h: 0.9884 },
        "5": { top: 0.0397, h: 1.0003 },
        "6": { top: 0.0397, h: 1.0003 },
        "7": { top: 0.0357, h: 1.0043 },
        "8": { top: 0.0397, h: 1.0003 },
        "9": { top: 0.0437, h: 0.9963 },
        ".": { top: 0.8693, h: 0.1707 },
        ",": { top: 0.8693, h: 0.3692 },
        "-": { top: 0.6351, h: 0.1508 },
        "!": { top: 0.004, h: 1.044 },
        "?": { top: 0.0, h: 1.04 },
        "'": { top: 0.004, h: 0.2898 },
        "\"": { top: 0.0, h: 0.2977 },
        "&": { top: 0.0198, h: 1.0202 },
        "@": { top: 0.2223, h: 0.8098 },
        "#": { top: 0.0, h: 1.04 },
        "(": { top: 0.0, h: 1.2583 },
        ")": { top: 0.0, h: 1.2583 },
        ":": { top: 0.5121, h: 0.5398 },
        ";": { top: 0.5081, h: 0.7185 },
        "/": { top: 0.0318, h: 0.9963 },
        "+": { top: 0.1905, h: 0.782 },
        "=": { top: 0.4089, h: 0.3573 },
        "%": { top: 0.0079, h: 1.04 }
      }
    },
    collage: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜ0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.06,
      lowerGap: 0.06,
      forceUppercase: true,
      files: {
        "Ç": "font-collage-upper-ccedilla.png",
        "Ö": "font-collage-upper-odiaeresis.png",
        "Ü": "font-collage-upper-udiaeresis.png",
        ".": "font-collage-punct-period.png",
        ",": "font-collage-punct-comma.png",
        "-": "font-collage-punct-hyphen.png",
        "!": "font-collage-punct-exclamation.png",
        "?": "font-collage-punct-question.png",
        "'": "font-collage-punct-apostrophe.png",
        "\"": "font-collage-punct-quote.png",
        "&": "font-collage-punct-ampersand.png",
        "@": "font-collage-punct-at.png",
        "#": "font-collage-punct-hash.png",
        "(": "font-collage-punct-paren-left.png",
        ")": "font-collage-punct-paren-right.png",
        ":": "font-collage-punct-colon.png",
        ";": "font-collage-punct-semicolon.png",
        "/": "font-collage-punct-slash.png",
        "+": "font-collage-punct-plus.png",
        "=": "font-collage-punct-equals.png",
        "%": "font-collage-punct-percent.png"
      },
      charMetrics: {
        A: { top: 0.008, h: 1.036 },
        B: { top: 0.004, h: 1.04 },
        C: { top: -0.004, h: 1.048 },
        D: { top: 0.0, h: 1.036 },
        E: { top: -0.004, h: 1.048 },
        F: { top: -0.016, h: 1.056 },
        G: { top: -0.008, h: 1.044 },
        H: { top: 0.0, h: 1.04 },
        I: { top: 0.0, h: 1.04 },
        J: { top: 0.004, h: 1.04 },
        K: { top: -0.004, h: 1.04 },
        L: { top: 0.004, h: 1.036 },
        M: { top: -0.008, h: 1.044 },
        N: { top: -0.004, h: 1.052 },
        O: { top: 0.0, h: 1.04 },
        P: { top: -0.008, h: 1.052 },
        Q: { top: 0.0, h: 1.104 },
        R: { top: -0.008, h: 1.044 },
        S: { top: 0.0, h: 1.048 },
        T: { top: 0.0, h: 1.04 },
        U: { top: 0.008, h: 1.04 },
        V: { top: 0.012, h: 1.028 },
        W: { top: 0.008, h: 1.032 },
        X: { top: 0.008, h: 1.028 },
        Y: { top: -0.004, h: 1.044 },
        Z: { top: -0.004, h: 1.052 },
        "Ç": { top: -0.008, h: 1.248 },
        "Ö": { top: -0.276, h: 1.324 },
        "Ü": { top: -0.276, h: 1.32 },
        "0": { top: 0.0, h: 1.04 },
        "1": { top: 0.0, h: 1.036 },
        "2": { top: 0.0, h: 1.04 },
        "3": { top: 0.0, h: 1.04 },
        "4": { top: 0.0, h: 1.04 },
        "5": { top: 0.0, h: 1.04 },
        "6": { top: 0.0, h: 1.04 },
        "7": { top: 0.0, h: 1.04 },
        "8": { top: 0.0, h: 1.04 },
        "9": { top: 0.0, h: 1.04 },
        ".": { top: 0.796, h: 0.244 },
        ",": { top: 0.808, h: 0.344 },
        "-": { top: 0.408, h: 0.256 },
        "!": { top: 0.004, h: 1.02 },
        "?": { top: -0.016, h: 1.04 },
        "'": { top: 0.02, h: 0.348 },
        "\"": { top: 0.016, h: 0.336 },
        "&": { top: -0.012, h: 1.056 },
        "@": { top: -0.024, h: 1.096 },
        "#": { top: 0.004, h: 1.028 },
        "(": { top: -0.148, h: 1.332 },
        ")": { top: -0.148, h: 1.332 },
        ":": { top: 0.412, h: 0.588 },
        ";": { top: 0.412, h: 0.692 },
        "/": { top: -0.148, h: 1.328 },
        "+": { top: 0.38, h: 0.544 },
        "=": { top: 0.44, h: 0.472 },
        "%": { top: 0.012, h: 1.032 }
      }
    },
    columbo: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.076,
      lowerGap: 0.068,
      files: {
        "Ç": "font-columbo-upper-ccedilla.png",
        "Ö": "font-columbo-upper-odiaeresis.png",
        "Ü": "font-columbo-upper-udiaeresis.png",
        "ç": "font-columbo-lower-ccedilla.png",
        "ö": "font-columbo-lower-odiaeresis.png",
        "ü": "font-columbo-lower-udiaeresis.png",
        ".": "font-columbo-punct-period.png",
        ",": "font-columbo-punct-comma.png",
        "-": "font-columbo-punct-hyphen.png",
        "!": "font-columbo-punct-exclamation.png",
        "?": "font-columbo-punct-question.png",
        "'": "font-columbo-punct-apostrophe.png",
        "\"": "font-columbo-punct-quote.png",
        "&": "font-columbo-punct-ampersand.png",
        "@": "font-columbo-punct-at.png",
        "#": "font-columbo-punct-hash.png",
        "(": "font-columbo-punct-paren-left.png",
        ")": "font-columbo-punct-paren-right.png",
        ":": "font-columbo-punct-colon.png",
        ";": "font-columbo-punct-semicolon.png",
        "/": "font-columbo-punct-slash.png",
        "+": "font-columbo-punct-plus.png",
        "=": "font-columbo-punct-equals.png",
        "%": "font-columbo-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.004, h: 1.044 },
        B: { top: -0.004, h: 1.044 },
        C: { top: 0.004, h: 1.036 },
        D: { top: -0.008, h: 1.064 },
        E: { top: 0.004, h: 1.036 },
        F: { top: 0.0, h: 1.036 },
        G: { top: -0.008, h: 1.056 },
        H: { top: 0.004, h: 1.036 },
        I: { top: 0.008, h: 1.028 },
        J: { top: 0.008, h: 1.04 },
        K: { top: 0.008, h: 1.028 },
        L: { top: 0.008, h: 1.052 },
        M: { top: 0.0, h: 1.044 },
        N: { top: -0.004, h: 1.052 },
        O: { top: -0.004, h: 1.052 },
        P: { top: 0.0, h: 1.028 },
        Q: { top: 0.004, h: 1.072 },
        R: { top: -0.012, h: 1.052 },
        S: { top: 0.008, h: 1.036 },
        T: { top: -0.004, h: 1.04 },
        U: { top: 0.008, h: 1.048 },
        V: { top: 0.0, h: 1.052 },
        W: { top: 0.004, h: 1.048 },
        X: { top: 0.0, h: 1.044 },
        Y: { top: 0.0, h: 1.044 },
        Z: { top: -0.004, h: 1.104 },
        "Ç": { top: 0.0, h: 1.304 },
        "Ö": { top: -0.324, h: 1.372 },
        "Ü": { top: -0.324, h: 1.38 },
        a: { top: 0.336, h: 0.712 },
        b: { top: 0.1, h: 0.94 },
        c: { top: 0.348, h: 0.696 },
        d: { top: 0.1, h: 0.94 },
        e: { top: 0.336, h: 0.712 },
        f: { top: 0.092, h: 0.944 },
        g: { top: 0.344, h: 1.02 },
        h: { top: 0.1, h: 0.936 },
        i: { top: 0.08, h: 0.948 },
        j: { top: 0.076, h: 1.288 },
        k: { top: 0.1, h: 0.932 },
        l: { top: 0.1, h: 0.932 },
        m: { top: 0.336, h: 0.696 },
        n: { top: 0.324, h: 0.712 },
        o: { top: 0.352, h: 0.692 },
        p: { top: 0.344, h: 1.02 },
        q: { top: 0.348, h: 1.016 },
        r: { top: 0.34, h: 0.696 },
        s: { top: 0.344, h: 0.72 },
        t: { top: 0.092, h: 0.944 },
        u: { top: 0.336, h: 0.704 },
        v: { top: 0.352, h: 0.692 },
        w: { top: 0.344, h: 0.7 },
        x: { top: 0.336, h: 0.704 },
        y: { top: 0.336, h: 1.024 },
        z: { top: 0.332, h: 0.732 },
        "ç": { top: 0.364, h: 0.912 },
        "ö": { top: 0.008, h: 1.052 },
        "ü": { top: 0.012, h: 1.04 },
        "0": { top: 0.212, h: 0.812 },
        "1": { top: 0.212, h: 0.828 },
        "2": { top: 0.212, h: 0.828 },
        "3": { top: 0.2, h: 0.928 },
        "4": { top: 0.204, h: 1.056 },
        "5": { top: 0.172, h: 0.952 },
        "6": { top: -0.016, h: 1.072 },
        "7": { top: 0.208, h: 0.82 },
        "8": { top: 0.064, h: 0.972 },
        "9": { top: 0.196, h: 1.092 },
        ".": { top: 0.852, h: 0.188 },
        ",": { top: 0.732, h: 0.376 },
        "-": { top: 0.552, h: 0.148 },
        "!": { top: -0.036, h: 1.072 },
        "?": { top: -0.1, h: 1.076 },
        "'": { top: -0.144, h: 0.452 },
        "\"": { top: -0.144, h: 0.448 },
        "&": { top: 0.028, h: 0.944 },
        "@": { top: 0.108, h: 0.908 },
        "#": { top: 0.248, h: 0.772 },
        "(": { top: 0.144, h: 1.064 },
        ")": { top: 0.148, h: 1.06 },
        ":": { top: 0.508, h: 0.468 },
        ";": { top: 0.5, h: 0.608 },
        "/": { top: 0.148, h: 1.064 },
        "+": { top: 0.3, h: 0.732 },
        "=": { top: 0.488, h: 0.32 },
        "%": { top: -0.064, h: 1.04 }
      }
    },
    freestyle: {
      chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZÇÖÜabcdefghijklmnopqrstuvwxyzçöü0123456789.,-!?'\"&@#():;/+=%",
      gap: 0.034,
      lowerGap: 0.034,
      files: {
        "Ç": "font-freestyle-upper-ccedilla.png",
        "Ö": "font-freestyle-upper-odiaeresis.png",
        "Ü": "font-freestyle-upper-udiaeresis.png",
        "ç": "font-freestyle-lower-ccedilla.png",
        "ö": "font-freestyle-lower-odiaeresis.png",
        "ü": "font-freestyle-lower-udiaeresis.png",
        ".": "font-freestyle-punct-period.png",
        ",": "font-freestyle-punct-comma.png",
        "-": "font-freestyle-punct-hyphen.png",
        "!": "font-freestyle-punct-exclamation.png",
        "?": "font-freestyle-punct-question.png",
        "'": "font-freestyle-punct-apostrophe.png",
        "\"": "font-freestyle-punct-quote.png",
        "&": "font-freestyle-punct-ampersand.png",
        "@": "font-freestyle-punct-at.png",
        "#": "font-freestyle-punct-hash.png",
        "(": "font-freestyle-punct-paren-left.png",
        ")": "font-freestyle-punct-paren-right.png",
        ":": "font-freestyle-punct-colon.png",
        ";": "font-freestyle-punct-semicolon.png",
        "/": "font-freestyle-punct-slash.png",
        "+": "font-freestyle-punct-plus.png",
        "=": "font-freestyle-punct-equals.png",
        "%": "font-freestyle-punct-percent.png"
      },
      charMetrics: {
        A: { top: -0.0073, h: 1.0363 },
        B: { top: -0.011, h: 1.0437 },
        C: { top: -0.0037, h: 1.0254 },
        D: { top: -0.0073, h: 1.0473 },
        E: { top: -0.0037, h: 1.018 },
        F: { top: 0.0037, h: 1.0254 },
        G: { top: -0.011, h: 1.0327 },
        H: { top: -0.0037, h: 1.0363 },
        I: { top: 0.0, h: 1.04 },
        J: { top: -0.0037, h: 1.3403 },
        K: { top: 0.0, h: 1.0363 },
        L: { top: 0.0, h: 1.018 },
        M: { top: -0.0037, h: 1.0363 },
        N: { top: 0.022, h: 1.0217 },
        O: { top: 0.0146, h: 1.029 },
        P: { top: 0.0146, h: 1.0327 },
        Q: { top: 0.0146, h: 1.1828 },
        R: { top: 0.022, h: 1.029 },
        S: { top: 0.022, h: 1.0217 },
        T: { top: 0.0293, h: 1.0217 },
        U: { top: 0.0146, h: 1.0363 },
        V: { top: -0.0146, h: 1.073 },
        W: { top: -0.0073, h: 1.0546 },
        X: { top: 0.011, h: 1.1535 },
        Y: { top: -0.011, h: 1.2707 },
        Z: { top: 0.0256, h: 1.0107 },
        "Ç": { top: 0.0183, h: 1.3183 },
        "Ö": { top: -0.2637, h: 1.2854 },
        "Ü": { top: -0.2637, h: 1.3037 },
        a: { top: 0.3332, h: 0.6994 },
        b: { top: -0.022, h: 1.0583 },
        c: { top: 0.3332, h: 0.7031 },
        d: { top: -0.022, h: 1.062 },
        e: { top: 0.3223, h: 0.7177 },
        f: { top: -0.022, h: 1.3256 },
        g: { top: 0.3369, h: 0.9814 },
        h: { top: -0.022, h: 1.0363 },
        i: { top: 0.033, h: 0.9924 },
        j: { top: 0.0439, h: 1.2414 },
        k: { top: -0.022, h: 1.0656 },
        l: { top: -0.022, h: 1.0583 },
        m: { top: 0.3223, h: 0.6994 },
        n: { top: 0.3442, h: 0.6958 },
        o: { top: 0.3515, h: 0.6958 },
        p: { top: 0.3369, h: 0.9887 },
        q: { top: 0.2307, h: 1.0839 },
        r: { top: 0.3442, h: 0.6885 },
        s: { top: 0.3515, h: 0.6958 },
        t: { top: 0.238, h: 0.8166 },
        u: { top: 0.3442, h: 0.6958 },
        v: { top: 0.2087, h: 0.8423 },
        w: { top: 0.2124, h: 0.8423 },
        x: { top: 0.3479, h: 0.7837 },
        y: { top: 0.3442, h: 1.007 },
        z: { top: 0.3552, h: 0.6958 },
        "ç": { top: 0.3515, h: 0.9997 },
        "ö": { top: 0.0732, h: 0.9777 },
        "ü": { top: 0.0659, h: 0.9777 },
        "0": { top: -0.0256, h: 1.04 },
        "1": { top: -0.0256, h: 1.0546 },
        "2": { top: -0.022, h: 1.0254 },
        "3": { top: -0.0256, h: 1.1279 },
        "4": { top: -0.033, h: 1.1352 },
        "5": { top: -0.022, h: 1.0913 },
        "6": { top: -0.0476, h: 1.0693 },
        "7": { top: -0.022, h: 1.0766 },
        "8": { top: -0.0146, h: 1.029 },
        "9": { top: -0.0403, h: 1.1425 },
        ".": { top: 0.813, h: 0.227 },
        ",": { top: 0.8056, h: 0.4614 },
        "-": { top: 0.6042, h: 0.1941 },
        "!": { top: 0.0073, h: 1.0437 },
        "?": { top: 0.011, h: 1.0437 },
        "'": { top: 0.0623, h: 0.3992 },
        "\"": { top: 0.0586, h: 0.4101 },
        "&": { top: 0.033, h: 1.0693 },
        "@": { top: 0.0256, h: 1.2158 },
        "#": { top: 0.0403, h: 0.9961 },
        "(": { top: 0.0073, h: 1.1352 },
        ")": { top: 0.0073, h: 1.1462 },
        ":": { top: 0.3662, h: 0.6885 },
        ";": { top: 0.3662, h: 0.9008 },
        "/": { top: 0.0073, h: 1.1718 },
        "+": { top: 0.2124, h: 0.8166 },
        "=": { top: 0.4028, h: 0.4431 },
        "%": { top: 0.0073, h: 1.1572 }
      }
    },
  };

  function pngFontGap(prefix, fontSize, dpr) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    if (typeof profile.gap === "number") return fontSize * dpr * profile.gap;
    return Math.max(1, fontSize * dpr * 0.028);
  }

  function pngCharGap(prefix, char, fontSize, dpr) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    if (profile.charGap && typeof profile.charGap[char] === "number") {
      return fontSize * dpr * profile.charGap[char];
    }
    var isLower = (char >= "a" && char <= "z") || "çğıöşü".indexOf(char) !== -1;
    if (isLower && typeof profile.lowerGap === "number") return fontSize * dpr * profile.lowerGap;
    return pngFontGap(prefix, fontSize, dpr);
  }

  function pngPairGap(prefix, char, nextChar, fontSize, dpr) {
    return pngPairGapBase(prefix, char, nextChar, fontSize, dpr) + fontSize * dpr * currentTracking;
  }

  function pngPairGapBase(prefix, char, nextChar, fontSize, dpr) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    var pair = char + (nextChar || "");
    if (profile.pairGap && typeof profile.pairGap[pair] === "number") {
      return fontSize * dpr * profile.pairGap[pair];
    }
    if (char === "r" && isUpperPngChar(nextChar) && typeof profile.rUpperGap === "number") {
      return fontSize * dpr * profile.rUpperGap;
    }
    var nextIsLower = (nextChar >= "a" && nextChar <= "z") || "çğıöşü".indexOf(nextChar || "") !== -1;
    if (char === "V" && nextIsLower && typeof profile.vLowerGap === "number") {
      return fontSize * dpr * profile.vLowerGap;
    }
    return pngCharGap(prefix, char, fontSize, dpr);
  }

  function isUpperPngChar(char) {
    return (char >= "A" && char <= "Z") || "ÇĞİÖŞÜ".indexOf(char) !== -1;
  }

  function pngCharScale(prefix, char) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    return (profile.charScale && profile.charScale[char]) || 1;
  }

  function pngCharYOffset(prefix, char, fontSize) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    if (isUpperPngChar(char) && typeof profile.upperYOffset === "number") {
      return fontSize * profile.upperYOffset;
    }
    return 0;
  }

  function pngGlyphAdvance(prefix, char, width, fontSize, dpr) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    if (profile.upperAdvance && isUpperPngChar(char)) {
      return Math.max(width, fontSize * dpr * profile.upperAdvance);
    }
    return width;
  }

  const pngGlyphFiles = {};
  const pngGlyphCache = {};

  PNG_FONTS.forEach(function (prefix) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    var chars = profile.chars || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    pngGlyphFiles[prefix] = {};
    pngGlyphCache[prefix] = {};
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").forEach(function (c) {
      if (chars.indexOf(c) === -1) return;
      pngGlyphFiles[prefix][c] = "font-" + prefix + "-upper-" + c + ".png";
    });
    "abcdefghijklmnopqrstuvwxyz".split("").forEach(function (c) {
      if (chars.indexOf(c) === -1) return;
      pngGlyphFiles[prefix][c] = "font-" + prefix + "-lower-" + c + ".png";
    });
    "0123456789".split("").forEach(function (c) {
      if (chars.indexOf(c) === -1) return;
      pngGlyphFiles[prefix][c] = "font-" + prefix + "-digit-" + c + ".png";
    });
    Object.keys(profile.files || {}).forEach(function (c) {
      pngGlyphFiles[prefix][c] = profile.files[c];
    });
  });

  function textRows(text) {
    return String(text || "")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .split("\n")
      .map(function (line) { return line || " "; });
  }

  function getPngGlyph(prefix, char) {
    if (char === " ") return { space: true };
    var files = pngGlyphFiles[prefix];
    if (!files) return null;
    var file = files[char];
    if (!file) return null;
    var cache = pngGlyphCache[prefix];
    if (cache[char]) return cache[char];

    var profile2 = PNG_FONT_PROFILES[prefix] || {};
    if (profile2.twoTone) {
      // Konturlu font: iç + kontur katmanları ayrı görsellerde
      var g2 = { loaded: false, img: new Image(), img2: new Image(), _n: 0 };
      function oneLoaded() {
        g2._n++;
        if (g2._n < 2) return;
        g2.loaded = true;
        if (activeDesignType === "text" && selectedFont === prefix && pngFontSupports(prefix, currentText)) scheduleEmbroideryUpdate();
      }
      g2.img.onload = oneLoaded;
      g2.img2.onload = oneLoaded;
      g2.img.onerror = g2.img2.onerror = function () { console.error("[Braver] Kontur glyph yüklenemedi:", file); };
      g2.img.src = glyphBase + file + "-ic.png?v=2";
      g2.img2.src = glyphBase + file + "-kontur.png?v=2";
      cache[char] = g2;
      return g2;
    }
    var glyph = { loaded: false, img: new Image() };
    // Sürüm damgasını artırarak CDN/tarayıcı önbelleğini kır.
    // Not: Shopify CDN yalnız "v" parametresini önbellek anahtarına dahil ediyor.
    var url = glyphBase + file + "?v=20260722";
    glyph.img.onload = function () {
      glyph.loaded = true;
      if (activeDesignType === "text" && selectedFont === prefix && pngFontSupports(prefix, currentText)) scheduleEmbroideryUpdate();
    };
    glyph.img.onerror = function () {
      console.error("[Braver] Glyph yüklenemedi:", url);
    };
    glyph.img.src = url;
    cache[char] = glyph;
    return glyph;
  }

  // Gerçek fontu tarayıcıya yükle; yüklenince aktif yazıyı tazele
  function ensureEffectFontLoaded(key) {
    if (!(window.document && document.fonts)) return;
    var f = fontStack(key, 40);
    if (document.fonts.check(f)) return;
    document.fonts.load(f).then(function () {
      if (selectedFont === key && activeDesignType === "text" &&
          !textBox.classList.contains("is-hidden")) {
        scheduleEmbroideryUpdate();
      }
    }).catch(function () {});
  }

  function preloadPngFont(prefix) {
    var files = pngGlyphFiles[prefix];
    if (!files) return;
    Object.keys(files).forEach(function (c) { getPngGlyph(prefix, c); });
  }

  function pngFontSupports(prefix, text) {
    var files = pngGlyphFiles[prefix];
    if (!files) return false;
    return !!text && String(text).split("").every(function (char) {
      return char === "\n" || char === "\r" || char === " " || !!files[char];
    });
  }

  function normalizeTextForFont(prefix, text) {
    var profile = PNG_FONT_PROFILES[prefix] || {};
    var value = String(text || "");
    if (!profile.forceUppercase) return value;
    return value.toLocaleUpperCase("tr-TR");
  }

  function normalizeTextInputForSelectedFont() {
    if (!textInput) return currentText;
    var normalized = normalizeTextForFont(selectedFont, textInput.value);
    if (textInput.value !== normalized) textInput.value = normalized;
    return normalized;
  }

  function unsupportedPngChars(prefix, text) {
    var files = pngGlyphFiles[prefix];
    var seen = {};
    if (!files) return [];
    return String(text || "").split("").filter(function (char) {
      var supported = char === "\n" || char === "\r" || char === " " || !!files[char];
      if (supported || seen[char]) return false;
      seen[char] = true;
      return true;
    });
  }

  function displayChar(char) {
    if (char === "\t") return "tab";
    return char;
  }

  function setFontWarning(message) {
    if (!fontWarning) return;
    if (!message) {
      fontWarning.classList.add("is-hidden");
      fontWarning.textContent = "";
      return;
    }
    fontWarning.textContent = message;
    fontWarning.classList.remove("is-hidden");
  }

  function setLogoWarning(message) {
    if (!logoWarning) return;
    if (!message) {
      logoWarning.classList.add("is-hidden");
      logoWarning.textContent = "";
      return;
    }
    logoWarning.textContent = message;
    logoWarning.classList.remove("is-hidden");
  }

  function updateFontWarning(text) {
    if (!isPngFont(selectedFont)) {
      setFontWarning("");
      return true;
    }
    var value = text == null ? currentText : text;
    var missing = unsupportedPngChars(selectedFont, value);
    if (!missing.length) {
      setFontWarning("");
      return true;
    }
    setFontWarning((FONT_LABELS[selectedFont] || "Bu font") + " bu karakterleri desteklemiyor: " + missing.map(displayChar).join(" "));
    return false;
  }

  function rgba(r, g, b, a) {
    return "rgba(" + clampChannel(r) + "," + clampChannel(g) + "," + clampChannel(b) + "," + a + ")";
  }

  function shadeRgb(r, g, b, amount, alpha) {
    var target = amount >= 0 ? 255 : 0;
    var ratio = Math.abs(amount);
    return rgba(
      r + (target - r) * ratio,
      g + (target - g) * ratio,
      b + (target - b) * ratio,
      alpha
    );
  }

  // Wilcom tarzı tatami dolgu: her renk bölgesi kendi düz iplik rengiyle,
  // tek sabit açıda, kısa ve TAM OPAK stitch sıralarıyla doldurulur.
  // Dersler (tatami denemelerinden): uzun stitch fırça etkisi yapar → kısa tut;
  // alternatif açılar herringbone tuzağı → tek açı; düşük alpha doku göstermez →
  // opak iplik + satır/dikiş aralarında koyu "dikiş dibi"; açık bölgeye çok hafif
  // doku, koyu bölgeye güçlü ridge.
  function renderLogoEmbroidery(ctx, sourceCanvas, maskCanvas, regionInfo, dpr) {
    var W = sourceCanvas.width;
    var H = sourceCanvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";
    // Kenar antialias tabanı: bölge maskeleri binary olduğundan kenar yumuşaklığı buradan gelir.
    ctx.drawImage(sourceCanvas, 0, 0);

    var region = regionInfo && regionInfo.region;
    var palette = (regionInfo && regionInfo.palette) || [];

    if (region && palette.length) {
      var angle = 26 * Math.PI / 180;
      var ux = Math.cos(angle), uy = Math.sin(angle);
      var px = -uy, py = ux;
      var rowStep = Math.max(2, 2.4 * dpr);
      var lw = rowStep * 0.82;
      var stitchLen = 8 * dpr;
      var gapLen = 0.8 * dpr;
      var period = stitchLen + gapLen;

      // Tüm bölge maskeleri + bbox'lar tek geçişte
      var nReg = palette.length;
      var boxes = new Array(nReg);
      var maskImages = new Array(nReg);
      var maskCtxTmp = document.createElement("canvas").getContext("2d");
      for (var r0 = 0; r0 < nReg; r0++) {
        boxes[r0] = null;
        maskImages[r0] = maskCtxTmp.createImageData(W, H);
      }
      for (var idx = 0; idx < region.length; idx++) {
        var rg = region[idx];
        if (rg < 0 || rg >= nReg) continue;
        var xPix = idx % W, yPix = (idx / W) | 0;
        var o = idx * 4;
        var md = maskImages[rg].data;
        md[o] = 255; md[o + 1] = 255; md[o + 2] = 255; md[o + 3] = 255;
        var bb = boxes[rg];
        if (!bb) { boxes[rg] = { x0: xPix, y0: yPix, x1: xPix, y1: yPix, count: 1 }; }
        else {
          if (xPix < bb.x0) bb.x0 = xPix; if (xPix > bb.x1) bb.x1 = xPix;
          if (yPix < bb.y0) bb.y0 = yPix; if (yPix > bb.y1) bb.y1 = yPix;
          bb.count++;
        }
      }

      var regCanvas = document.createElement("canvas");
      regCanvas.width = W; regCanvas.height = H;
      var regCtx = regCanvas.getContext("2d");
      regCtx.lineCap = "butt";
      var maskImgCanvas = document.createElement("canvas");
      maskImgCanvas.width = W; maskImgCanvas.height = H;
      var maskImgCtx = maskImgCanvas.getContext("2d");

      for (var r = 0; r < nReg; r++) {
        var box = boxes[r];
        if (!box || box.count < 6) continue;
        var col = hexToRgb(palette[r]);
        var luma = (col.r * 299 + col.g * 587 + col.b * 114) / 1000;
        var isLight = luma > 210;
        var isDark = luma < 70;
        var baseShade = isLight ? -0.07 : (isDark ? -0.5 : -0.2);
        // koyu bölgede sheen abartılırsa siyah gri beneklenir — düşük tut
        var maxSheen = isLight ? 0.045 : (isDark ? 0.1 : 0.14);

        maskImgCtx.putImageData(maskImages[r], 0, 0);

        regCtx.clearRect(0, 0, W, H);
        // dikiş dibi: satır/dikiş aralarında görünen koyu taban
        regCtx.fillStyle = shadeRgb(col.r, col.g, col.b, baseShade, 1);
        regCtx.fillRect(box.x0, box.y0, box.x1 - box.x0 + 1, box.y1 - box.y0 + 1);

        regCtx.lineWidth = lw;
        var corners = [[box.x0, box.y0], [box.x1, box.y0], [box.x0, box.y1], [box.x1, box.y1]];
        var pMin = Infinity, pMax = -Infinity, tMin = Infinity, tMax = -Infinity;
        for (var ci = 0; ci < 4; ci++) {
          var pp = corners[ci][0] * px + corners[ci][1] * py;
          var tt = corners[ci][0] * ux + corners[ci][1] * uy;
          if (pp < pMin) pMin = pp; if (pp > pMax) pMax = pp;
          if (tt < tMin) tMin = tt; if (tt > tMax) tMax = tt;
        }
        var rowIdx = Math.floor(pMin / rowStep);
        for (var pos = rowIdx * rowStep; pos <= pMax + rowStep; pos += rowStep, rowIdx++) {
          var cx = px * pos, cy = py * pos;
          var phase = ((rowIdx % 3) + 1) * period / 3; // iğne batışları şaşırtmalı
          var segIdx = Math.floor((tMin - phase) / period);
          for (var t = segIdx * period + phase; t < tMax + period; t += period, segIdx++) {
            // deterministik segment parlaklığı: iplik sırasında hafif ışıltı farkı
            var hsh = ((rowIdx * 73856093) ^ (segIdx * 19349663)) >>> 0;
            var jitter = ((hsh % 1000) / 1000 - 0.5);
            var shade = maxSheen * (0.55 + jitter * 0.9);
            regCtx.strokeStyle = shadeRgb(col.r, col.g, col.b, shade, 1);
            regCtx.beginPath();
            regCtx.moveTo(cx + ux * t, cy + uy * t);
            regCtx.lineTo(cx + ux * (t + stitchLen), cy + uy * (t + stitchLen));
            regCtx.stroke();
          }
        }

        regCtx.globalCompositeOperation = "destination-in";
        regCtx.drawImage(maskImgCanvas, 0, 0);
        regCtx.globalCompositeOperation = "source-over";
        ctx.drawImage(regCanvas, 0, 0);
      }
    }

    function drawInnerRim(color, alpha, cutX, cutY, blur) {
      var rimC = document.createElement("canvas");
      rimC.width = W;
      rimC.height = H;
      var rimCtx = rimC.getContext("2d");
      rimCtx.fillStyle = color;
      rimCtx.fillRect(0, 0, W, H);
      rimCtx.globalCompositeOperation = "destination-in";
      rimCtx.drawImage(maskCanvas, 0, 0);
      rimCtx.globalCompositeOperation = "destination-out";
      rimCtx.drawImage(maskCanvas, Math.round(cutX * dpr), Math.round(cutY * dpr));

      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.globalCompositeOperation = "source-atop";
      ctx.filter = "blur(" + Math.max(0.35, blur * dpr) + "px)";
      ctx.drawImage(rimC, 0, 0);
      ctx.restore();
    }

    drawInnerRim("#ffffff", 0.28, 1.15, 1.15, 0.45);
    drawInnerRim("#000000", 0.2, -1.25, -1.25, 0.55);

    var shadowC = document.createElement("canvas");
    shadowC.width = W; shadowC.height = H;
    var sCtx = shadowC.getContext("2d");
    sCtx.fillStyle = "#000000";
    sCtx.fillRect(0, 0, W, H);
    sCtx.globalCompositeOperation = "destination-in";
    sCtx.drawImage(maskCanvas, 0, 0);

    ctx.save();
    ctx.filter = "blur(" + Math.round(2.4 * dpr) + "px)";
    ctx.globalAlpha = 0.42;
    ctx.globalCompositeOperation = "destination-over";
    ctx.drawImage(shadowC, Math.round(2.2 * dpr), Math.round(3.2 * dpr));
    ctx.globalAlpha = 0.16;
    ctx.filter = "blur(" + Math.round(5 * dpr) + "px)";
    ctx.drawImage(shadowC, Math.round(4 * dpr), Math.round(5 * dpr));
    ctx.restore();

    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 1;
  }

  function renderLogoCanvas() {
    if (!logoImage) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (isUv()) {
      // UV baskı: görsel olduğu gibi (tam renk), nakış işlemleri atlanır
      const maxW0 = Math.max(20, currentSize);
      const ratio0 = logoImage.naturalHeight && logoImage.naturalWidth
        ? logoImage.naturalHeight / logoImage.naturalWidth : 1;
      const w0 = Math.ceil(maxW0), h0 = Math.ceil(maxW0 * ratio0);
      embCanvas.width = w0 * dpr;
      embCanvas.height = h0 * dpr;
      embCanvas.style.width = w0 + "px";
      embCanvas.style.height = h0 + "px";
      const c0 = embCanvas.getContext("2d");
      c0.clearRect(0, 0, embCanvas.width, embCanvas.height);
      c0.imageSmoothingEnabled = true;
      c0.imageSmoothingQuality = "high";
      c0.drawImage(logoImage, 0, 0, embCanvas.width, embCanvas.height);
      trimCanvas(embCanvas, dpr);
      render();
      return;
    }
    const maxW = Math.max(20, currentSize);
    const ratio = logoImage.naturalHeight && logoImage.naturalWidth
      ? logoImage.naturalHeight / logoImage.naturalWidth
      : 1;
    const w = Math.ceil(maxW);
    const h = Math.ceil(maxW * ratio);

    embCanvas.width = w * dpr;
    embCanvas.height = h * dpr;
    embCanvas.style.width = w + "px";
    embCanvas.style.height = h + "px";

    const ctx = embCanvas.getContext("2d");
    ctx.clearRect(0, 0, embCanvas.width, embCanvas.height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    const sourceCanvas = document.createElement("canvas");
    const sourceCtx = sourceCanvas.getContext("2d");
    sourceCanvas.width = embCanvas.width;
    sourceCanvas.height = embCanvas.height;
    sourceCtx.imageSmoothingEnabled = true;
    sourceCtx.imageSmoothingQuality = "high";
    sourceCtx.drawImage(logoImage, 0, 0, sourceCanvas.width, sourceCanvas.height);

    const sourceImage = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
    const sourceData = sourceImage.data;
    const maskCanvas = document.createElement("canvas");
    const maskCtx = maskCanvas.getContext("2d");
    maskCanvas.width = sourceCanvas.width;
    maskCanvas.height = sourceCanvas.height;
    const maskImage = maskCtx.createImageData(maskCanvas.width, maskCanvas.height);
    const maskData = maskImage.data;
    const W = maskCanvas.width;
    const H = maskCanvas.height;

    for (let i = 0; i < sourceData.length; i += 4) {
      const a = sourceData[i + 3] > 24 ? sourceData[i + 3] : 0;
      maskData[i] = 255;
      maskData[i + 1] = 255;
      maskData[i + 2] = 255;
      maskData[i + 3] = a;
    }
    maskCtx.putImageData(maskImage, 0, 0);
    updateLogoPaletteFromNatural();
    const threadResult = quantizeLogoSource(sourceImage, maskData, W, H);
    sourceCtx.putImageData(threadResult.image, 0, 0);

    const threadData = sourceCtx.getImageData(0, 0, W, H).data;
    const finalMaskCanvas = document.createElement("canvas");
    const finalMaskCtx = finalMaskCanvas.getContext("2d");
    finalMaskCanvas.width = W;
    finalMaskCanvas.height = H;
    const finalMaskImage = finalMaskCtx.createImageData(W, H);
    const finalMaskData = finalMaskImage.data;

    for (let i = 0; i < threadData.length; i += 4) {
      const a = threadData[i + 3] > 24 ? threadData[i + 3] : 0;
      finalMaskData[i] = 255;
      finalMaskData[i + 1] = 255;
      finalMaskData[i + 2] = 255;
      finalMaskData[i + 3] = a;
    }
    finalMaskCtx.putImageData(finalMaskImage, 0, 0);

    renderLogoEmbroidery(ctx, sourceCanvas, finalMaskCanvas, threadResult, dpr);
    trimCanvas(embCanvas, dpr);
    render();
  }

  function updateDesign() {
    if (activeDesignType === "logo") {
      renderLogoCanvas();
      return;
    }
    updateEmbroidery();
  }

  // Tasarımın GERÇEK tekniği: 3D yalnız ön yüzdeki d3-fontlu YAZI için geçerli.
  // Global durum bayat '3d' kalsa bile düz fontlu tasarım klasik nakıştır —
  // PDF 'Uygulama' alanı ve 3D ücreti bu alandan türediği için burada kesinleşir.
  function designTechniqueFor(type, fontKey) {
    var t = effectiveTechnique(currentView);
    if (t === "3d" && (type !== "text" || !/^d3/.test(String(fontKey || "")))) return "nakis";
    return t;
  }

  function currentDesignDetails() {
    if (activeDesignType === "logo") {
      return {
        type: "Logo",
        layer: activeLayer,
        technique: designTechniqueFor("logo"),
        source: logoSource || "upload",
        label: logoName || "Logo",
        file: logoName || "",
        logoImage: logoImage,
        logoName: logoName || "",
        logoFile: logoSource === "upload" ? logoSourceFile : null,
        logoColorMap: Object.assign({}, logoColorMap),
        logoDetectedColors: logoDetectedColors.slice(),
        logoSelectedSourceColor: logoSelectedSourceColor || "",
        colors: logoDetectedColors.map(function (hex) {
          var mapped = normalizeHex(logoColorMap[hex] || hex);
          return mapped === hex ? hex : hex + ">" + mapped;
        }).join(", "),
        size: currentSize,
        view: currentView,
        x: x,
        y: y,
        rotation: rotation
      };
    }
    return {
      type: "Yazı",
      layer: activeLayer,
      technique: designTechniqueFor("text", selectedFont),
      label: currentText || "",
      text: currentText || "",
      fontKey: selectedFont,
      font: FONT_LABELS[selectedFont] || selectedFont || "",
      color: selectedColor || "",
      konturColor: isTwoToneFont(selectedFont) ? (selectedKonturColor || "") : "",
      size: currentSize,
      tracking: currentTracking,
      view: currentView,
      x: x,
      y: y,
      rotation: rotation
    };
  }

  // Katman sistemi: aynı z-index'te DOM sırası boyar — büyük layer sona (öne) gelir
  function applyLayerOrder() {
    var items = committedDesigns.map(function (d) {
      return { el: d.el, layer: Number(d.details.layer || 0) };
    });
    if (!textBox.classList.contains("is-hidden")) items.push({ el: textBox, layer: activeLayer });
    items.sort(function (a, b) { return a.layer - b.layer; });
    var parent = textBox.parentNode;
    if (!parent) return;
    items.forEach(function (it) { parent.appendChild(it.el); });
  }

  // Aktif tasarımı bir katman ileri (+1) / geri (-1): aynı görünümdeki komşuyla takas
  function moveActiveLayer(dir) {
    if (textBox.classList.contains("is-hidden")) return;
    var target = null;
    committedDesigns.forEach(function (d) {
      if ((d.details.view || "front") !== currentView) return;
      var L = Number(d.details.layer || 0);
      if (dir > 0 && L > activeLayer && (!target || L < Number(target.details.layer))) target = d;
      if (dir < 0 && L < activeLayer && (!target || L > Number(target.details.layer))) target = d;
    });
    if (!target) return; // zaten en önde/en arkada
    var tmp = Number(target.details.layer);
    target.details.layer = activeLayer;
    activeLayer = tmp;
    applyLayerOrder();
  }

  document.querySelectorAll(".layer-up").forEach(function (b) {
    b.addEventListener("click", function () { moveActiveLayer(1); });
  });
  document.querySelectorAll(".layer-down").forEach(function (b) {
    b.addEventListener("click", function () { moveActiveLayer(-1); });
  });

  function freezeCurrentDesign() {
    if (textBox.classList.contains("is-hidden")) return;
    var details = currentDesignDetails();
    var id = "d" + (designIdSeq++);

    // Aktif canvas'ın anlık kopyası
    var snap = document.createElement("canvas");
    snap.width = embCanvas.width;
    snap.height = embCanvas.height;
    snap.getContext("2d").drawImage(embCanvas, 0, 0);
    snap.style.width = embCanvas.style.width;
    snap.style.height = embCanvas.style.height;
    snap.style.display = "block";

    var el = document.createElement("div");
    el.className = "committed-design";
    el.dataset.designId = id;
    el.style.top = textBox.style.top;
    el.style.left = textBox.style.left;
    el.style.transform = textBox.style.transform;
    el.appendChild(snap);
    el.addEventListener("click", function (e) {
      e.stopPropagation();
      selectCommittedDesign(id);
    });
    textBox.parentNode.appendChild(el);

    committedDesigns.push({ id: id, details: details, el: el });
    applyLayerOrder();

    // Aktif kutuyu boşalt
    textBox.classList.add("is-hidden");
    textBox.classList.remove("active", "idle", "outside");
    x = 0; y = 0; rotation = 0; scale = 1;
    render();
  }

  function prepareDesignSlot(nextType) {
    if (!textBox.classList.contains("is-hidden") && activeDesignType !== nextType) {
      // Farklı türde yeni tasarım geliyor: aktif tasarımı KAYBETME — sahneye
      // sabitle (kullanıcı yazı yazarken logo yüklerse yazı silinmesin)
      freezeCurrentDesign();
      activeLayer = layerSeq++; // yeni tasarım en üst katmanda başlar
    } else if (textBox.classList.contains("is-hidden")) {
      activeLayer = layerSeq++;
    }
  }

  function allDesignDetails() {
    var list = committedDesigns.map(function (d) { return d.details; });
    if (!textBox.classList.contains("is-hidden")) list.push(currentDesignDetails());
    return list;
  }

  // Ek ücret sayımı (fiyat gösterimi ve sepete ekleme aynı mantığı kullanır)
  function feeCounts(designs) {
    // Logo ücreti tasarımın KENDİ tekniğine bakar: nakışla işlenen yüklenen logo
    // (3D modunda yan yüze yüklenen logo da nakıştır → ücretli; UV hariç).
    // BENZERSİZ dosya başına BİR ücret (12 Ağu kararı, #14297): müşteri aynı
    // logoyu birden çok yüze koyarsa tek ücret — anahtar: dosya adı + boyut.
    var benzersiz = {};
    designs.forEach(function (d) {
      if (d.type !== "Logo" || (d.source || "upload") !== "upload") return;
      if ((d.technique || "nakis") !== "nakis") return;
      var anahtar = (d.logoName || d.file || d.label || "logo") + ":" +
        ((d.logoFile && d.logoFile.size) ||
         (d.logoImage && (d.logoImage.naturalWidth + "x" + d.logoImage.naturalHeight)) || "");
      benzersiz[anahtar] = true;
    });
    var logoCount = Object.keys(benzersiz).length;
    var sides = {};
    designs.forEach(function (d) {
      if (d.view === "left" || d.view === "right") sides[d.view] = true;
    });
    // 3D ücreti tek seferlik: siparişte en az bir 3D tasarım varsa 1
    var d3Count = designs.some(function (d) { return d.technique === "3d"; }) ? 1 : 0;
    return { logoCount: logoCount, sideCount: Object.keys(sides).length, d3Count: d3Count };
  }

  function fmtTL(kurus) {
    var tl = Math.round(kurus) / 100;
    var opts = { minimumFractionDigits: (tl % 1 ? 2 : 0), maximumFractionDigits: 2 };
    try { return tl.toLocaleString("tr-TR", opts) + " TL"; }
    catch (e) { return tl + " TL"; }
  }

  // Adede göre toplu alım indirim yüzdesi (0-100)
  function bulkPctForQty(qty) {
    var bulk = window.BRAVER_BULK || {};
    if (!bulk.enabled || !bulk.tiers) return 0;
    var pct = 0;
    bulk.tiers.forEach(function (t) {
      var min = Number(t.min);
      if (qty >= min && Number(t.pct) > pct) pct = Number(t.pct);
    });
    return pct;
  }

  function currentQty() {
    var q = Math.floor(Number(qtyInput && qtyInput.value) || 1);
    return q > 0 ? q : 1;
  }

  function updatePriceDisplay() {
    if (!priceTotalValue) return;
    var fees = window.BRAVER_FEES || {};
    var counts = feeCounts(allDesignDetails());
    var base = Number(selectedVariantPrice || 0);
    var qty = currentQty();
    var pct = bulkPctForQty(qty);
    // Şapka satırına adet × indirim; logo/3D ücretleri tek seferlik,
    // YAN ücreti her şapkaya işlendiği için ADETLE ÇARPILIR (20 Ağu kararı)
    var hatSubtotal = base * qty * (1 - pct / 100);
    var logoFee = counts.logoCount * (Number(fees.logoAmount) || 0) * 100;
    var sideFee = counts.sideCount * qty * (Number(fees.sideAmount) || 0) * 100;
    var d3Fee = counts.d3Count * (Number(fees.d3Amount) || 0) * 100;
    priceTotalValue.textContent = fmtTL(hatSubtotal + logoFee + sideFee + d3Fee);
    if (priceBreakdown) {
      var parts = [];
      var hatLabel = "Şapka " + fmtTL(base);
      if (qty > 1) hatLabel += " ×" + qty;
      if (pct > 0) hatLabel += " (−%" + pct + ")";
      parts.push(hatLabel);
      if (d3Fee) parts.push("3D nakış " + fmtTL(d3Fee));
      if (logoFee) parts.push("Logo nakış ×" + counts.logoCount + " " + fmtTL(logoFee));
      if (sideFee) parts.push("Yan ×" + (counts.sideCount * qty) + " " + fmtTL(sideFee));
      if (qty > 1 || pct > 0 || logoFee || sideFee || d3Fee) {
        priceBreakdown.textContent = parts.join(" + ");
        priceBreakdown.classList.remove("is-hidden");
      } else {
        priceBreakdown.classList.add("is-hidden");
      }
    }
  }

  function updateAddButton() {
    var hasInView = !textBox.classList.contains("is-hidden") ||
      committedDesigns.some(function (d) { return (d.details.view || "front") === currentView; });
    addBtn.style.display = "flex";
    addBtn.classList.remove("is-fading");
    addBtn.classList.toggle("is-compact", hasInView);
    addBtn.querySelector("strong").textContent = "Tasarım ekle";
    // Mobil: teknik seçildiyse araç çubuğu (Yazı/Desen/Medya) hep erişilebilir kalsın
    if (!isDesktopCustomizer() && techniqueChosen && mobileBar) {
      mobileBar.classList.remove("is-hidden");
    }
    updatePriceDisplay();
  }

  function showAddAnotherButton() {
    updateAddButton();
  }

  function restoreDesign(design) {
    activeDesignType = design.type === "Logo" ? "logo" : "text";
    activeLayer = design.layer != null ? Number(design.layer) : layerSeq++;
    layerSeq = Math.max(layerSeq, activeLayer + 1);
    currentSize = Number(design.size || 46);
    x = Number(design.x || 0);
    y = Number(design.y || 0);
    rotation = Number(design.rotation || 0);
    scale = 1;

    if (activeDesignType === "logo") {
      logoImage = design.logoImage || logoImage;
      logoName = design.logoName || design.file || "";
      logoSource = design.source || "upload";
      logoSourceFile = design.logoFile || null;
      logoColorMap = Object.assign({}, design.logoColorMap || {});
      logoDetectedColors = (design.logoDetectedColors || []).slice();
      logoSelectedSourceColor = design.logoSelectedSourceColor || logoDetectedColors[0] || "";
      if (logoFileName) logoFileName.textContent = logoName || "PNG, JPG, WebP veya SVG";
      if (logoSizeInput) logoSizeInput.value = String(Math.round(currentSize));
      renderLogoColorTools();
      updateLogoPreview();
      renderLogoCanvas();
      openLogo.classList.add("active");
      openText.classList.remove("active");
      openPanel(logoPanel);
    } else {
      currentText = design.text || "";
      selectedFont = design.fontKey || selectedFont;
      selectedColor = design.color || selectedColor;
      if (design.konturColor) {
        selectedKonturColor = design.konturColor;
        konturButtons.forEach(function (b) {
          b.classList.toggle("active", b.dataset.kcolor === selectedKonturColor);
        });
      }
      refreshKonturRow();
      currentTracking = Number(design.tracking || 0);
      if (textInput) textInput.value = currentText;
      if (fontToggle) fontToggle.textContent = FONT_LABELS[selectedFont] || selectedFont;
      if (sizeInput) sizeInput.value = String(Math.round(currentSize));
      if (trackingInput) trackingInput.value = String(Math.round(currentTracking * 100));
      colorButtons.forEach(function (btn) {
        btn.classList.toggle("active", normalizeHex(btn.dataset.color) === normalizeHex(selectedColor));
      });
      updateEmbroidery();
      openText.classList.add("active");
      openLogo.classList.remove("active");
      openPanel(textPanel);
    }

    textBox.classList.remove("is-hidden");
    setActive();
    mobileBar.classList.remove("is-hidden");
  }

  function selectCommittedDesign(id) {
    var idx = -1;
    committedDesigns.forEach(function (d, i) { if (d.id === id) idx = i; });
    if (idx === -1) return;
    freezeCurrentDesign(); // aktif tasarım varsa önce sabitle
    idx = -1;
    committedDesigns.forEach(function (d, i) { if (d.id === id) idx = i; });
    var entry = committedDesigns.splice(idx, 1)[0];
    entry.el.parentNode.removeChild(entry.el);
    restoreDesign(entry.details);
    updateAddButton();
    checkBounds();
  }

  if (viewSwitcher) {
    viewSwitcher.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setView(btn.dataset.view);
      });
    });
  }

  /* ── Yakınlaştırma & Kaydırma ────────────────────────────── */

  let panX = 0, panY = 0;
  let panning = false, panStartX = 0, panStartY = 0, panPointerX = 0, panPointerY = 0;

  function clampPan() {
    if (!stageZoom) return;
    var maxX = (zoomLevel - 1) * stageZoom.offsetWidth / 2;
    var maxY = (zoomLevel - 1) * stageZoom.offsetHeight / 2;
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  }

  function applyZoom() {
    if (!stageZoom) return;
    if (zoomLevel === 1) { panX = 0; panY = 0; }
    clampPan();
    stageZoom.style.transform = zoomLevel === 1
      ? ""
      : "translate(" + panX + "px," + panY + "px) scale(" + zoomLevel + ")";
    stageZoom.classList.toggle("zoomed", zoomLevel > 1);
    if (zoomInBtn) zoomInBtn.disabled = zoomLevel >= ZOOM_MAX;
    if (zoomOutBtn) zoomOutBtn.disabled = zoomLevel <= ZOOM_MIN;
  }

  if (zoomInBtn) {
    zoomInBtn.addEventListener("click", function () {
      zoomLevel = Math.min(ZOOM_MAX, Math.round((zoomLevel + ZOOM_STEP) * 100) / 100);
      applyZoom();
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener("click", function () {
      zoomLevel = Math.max(ZOOM_MIN, Math.round((zoomLevel - ZOOM_STEP) * 100) / 100);
      applyZoom();
    });
  }
  applyZoom();

  if (stageZoom) {
    stageZoom.addEventListener("pointerdown", function (e) {
      if (zoomLevel === 1) return;
      // Tasarım kutusu, sabit tasarım veya butonların üstünde pan başlatma
      if (e.target.closest(".text-box") ||
          e.target.closest(".committed-design") ||
          e.target.closest(".design-placeholder")) return;
      panning = true;
      panPointerX = e.clientX; panPointerY = e.clientY;
      panStartX = panX; panStartY = panY;
      stageZoom.classList.add("panning");
      // Parmak sahne dışına taşsa da pan sürsün; tarayıcı pointercancel üretmesin
      try { stageZoom.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    window.addEventListener("pointermove", function (e) {
      if (!panning) return;
      panX = panStartX + (e.clientX - panPointerX);
      panY = panStartY + (e.clientY - panPointerY);
      clampPan();
      stageZoom.style.transform = "translate(" + panX + "px," + panY + "px) scale(" + zoomLevel + ")";
      e.preventDefault();
    });

    function endPan() {
      panning = false;
      stageZoom.classList.remove("panning");
    }
    window.addEventListener("pointerup", endPan);
    window.addEventListener("pointercancel", endPan);
  }

  function pngGlyphMetrics(char, fontSize, prefix) {
    var capHeight = fontSize * 1.04;
    var xHeight = fontSize * 0.72;
    var ascenderHeight = fontSize * 0.94;
    var descenderDepth = fontSize * 0.2;
    var ascenders = "bdfhklt";
    var descenders = "gjpqy";

    // Font bazlı özel kutular (kaynak hücre geometrisi standarttan sapıyorsa)
    var profile = prefix ? PNG_FONT_PROFILES[prefix] : null;
    if (profile && profile.charMetrics && profile.charMetrics[char]) {
      var cm = profile.charMetrics[char];
      return {
        height: fontSize * cm.h,
        top: fontSize * cm.top,
        bottom: fontSize * (cm.top + cm.h)
      };
    }

    if (isUpperPngChar(char)) {
      return { height: capHeight, top: 0, bottom: capHeight };
    }
    if (char >= "0" && char <= "9") {
      return { height: capHeight * 0.96, top: capHeight * 0.04, bottom: capHeight };
    }
    if (descenders.indexOf(char) !== -1) {
      return { height: xHeight + descenderDepth, top: capHeight - xHeight, bottom: capHeight + descenderDepth };
    }
    if (ascenders.indexOf(char) !== -1) {
      return { height: ascenderHeight, top: capHeight - ascenderHeight, bottom: capHeight };
    }
    return { height: xHeight, top: capHeight - xHeight, bottom: capHeight };
  }

  function measurePngText(prefix, text, fontSize) {
    if (!pngFontSupports(prefix, text)) return null;
    var capHeight = fontSize * 1.04;
    var lineGap = Math.max(3, fontSize * 0.16);
    var maxWidth = 0, totalHeight = 0, ready = true;

    textRows(text).forEach(function (line, index) {
      var width = 0, minTop = capHeight, maxBottom = 0, hasGlyph = false, lastGap = 0;
      line.split("").forEach(function (char, charIndex, chars) {
        if (char === " ") { width += fontSize * 0.34; return; }
        var glyph = getPngGlyph(prefix, char);
        if (!glyph || !glyph.loaded || !glyph.img.naturalWidth) { ready = false; return; }
        var metrics = pngGlyphMetrics(char, fontSize, prefix);
        var scale = pngCharScale(prefix, char);
        var yOffset = pngCharYOffset(prefix, char, fontSize);
        var gap = pngPairGap(prefix, char, chars[charIndex + 1], fontSize, 1);
        var glyphWidth = (glyph.img.naturalWidth / glyph.img.naturalHeight) * metrics.height * scale;
        width += pngGlyphAdvance(prefix, char, glyphWidth, fontSize, 1) + gap;
        lastGap = gap;
        minTop = Math.min(minTop, metrics.top + yOffset - ((metrics.height * (scale - 1)) / 2));
        maxBottom = Math.max(maxBottom, metrics.bottom + yOffset + ((metrics.height * (scale - 1)) / 2));
        hasGlyph = true;
      });
      var height = hasGlyph ? Math.max(1, maxBottom - minTop) : capHeight;
      maxWidth = Math.max(maxWidth, Math.max(1, width - lastGap));
      totalHeight += height + (index > 0 ? lineGap : 0);
    });

    if (!ready) return null;
    return {
      width: Math.max(1, maxWidth),
      height: Math.max(capHeight, totalHeight),
      ascent: Math.max(capHeight, totalHeight),
      descent: 0,
      left: 0
    };
  }

  function drawTintedGlyphImage(ctx, img, x, y, width, height, color, dpr, withShadow) {
    color = color || "#ffffff";
    var luma = colorLuma(color);
    ctx.save();
    if (withShadow) {
      ctx.shadowColor = "rgba(0,0,0,0.52)";
      ctx.shadowBlur = Math.max(0.4, dpr * 0.45);
      ctx.shadowOffsetX = Math.max(0.4, dpr * 0.45);
      ctx.shadowOffsetY = Math.max(0.5, dpr * 0.62);
    }

    if (luma > 235) {
      ctx.drawImage(img, x, y, width, height);
      ctx.restore();
      return;
    }

    var tint = document.createElement("canvas");
    tint.width = Math.max(1, Math.round(width));
    tint.height = Math.max(1, Math.round(height));
    var tctx = tint.getContext("2d");
    tctx.drawImage(img, 0, 0, tint.width, tint.height);
    tctx.globalCompositeOperation = "source-in";
    tctx.fillStyle = color;
    tctx.fillRect(0, 0, tint.width, tint.height);
    tctx.globalCompositeOperation = "multiply";
    tctx.globalAlpha = 0.28;
    tctx.drawImage(img, 0, 0, tint.width, tint.height);
    tctx.globalCompositeOperation = "screen";
    tctx.globalAlpha = 0.18;
    tctx.drawImage(img, 0, 0, tint.width, tint.height);

    ctx.drawImage(tint, x, y, width, height);
    ctx.restore();
  }

  function drawPngGlyph(ctx, glyph, x, y, width, height, color, dpr) {
    drawTintedGlyphImage(ctx, glyph.img, x, y, width, height, color, dpr, true);
    if (glyph.img2 && glyph.img2.naturalWidth) {
      // kontur katmanı: ikinci renk, gölgesiz (iç katman gölgeyi verdi)
      drawTintedGlyphImage(ctx, glyph.img2, x, y, width, height, selectedKonturColor, dpr, false);
    }
  }

  function renderPngText(prefix, canvas, text, color, fontSize, pad) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
    var capHeight = fontSize * 1.04;
    var lineGap = Math.max(3, fontSize * 0.16);
    var lineTop = pad;

    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    textRows(text).forEach(function (line) {
      var lineWidth = 0, minTop = capHeight, maxBottom = 0, hasGlyph = false, lastGap = 0;

      line.split("").forEach(function (char, charIndex, chars) {
        if (char === " ") { lineWidth += fontSize * dpr * 0.34; return; }
        var glyph = getPngGlyph(prefix, char);
        if (!glyph || !glyph.loaded || !glyph.img.naturalWidth) return;
        var metrics = pngGlyphMetrics(char, fontSize, prefix);
        var scale = pngCharScale(prefix, char);
        var yOffset = pngCharYOffset(prefix, char, fontSize);
        var gap = pngPairGap(prefix, char, chars[charIndex + 1], fontSize, dpr);
        var h = metrics.height * dpr * scale;
        var glyphWidth = (glyph.img.naturalWidth / glyph.img.naturalHeight) * h;
        lineWidth += pngGlyphAdvance(prefix, char, glyphWidth, fontSize, dpr) + gap;
        lastGap = gap;
        minTop = Math.min(minTop, metrics.top + yOffset - ((metrics.height * (scale - 1)) / 2));
        maxBottom = Math.max(maxBottom, metrics.bottom + yOffset + ((metrics.height * (scale - 1)) / 2));
        hasGlyph = true;
      });

      var lineHeight = hasGlyph ? Math.max(1, maxBottom - minTop) : capHeight;
      lineWidth = Math.max(1, lineWidth - lastGap);
      var cursor = Math.max(pad * dpr, (canvas.width - lineWidth) / 2);

      line.split("").forEach(function (char, charIndex, chars) {
        if (char === " ") { cursor += fontSize * dpr * 0.34; return; }
        var glyph = getPngGlyph(prefix, char);
        if (!glyph || !glyph.loaded || !glyph.img.naturalWidth) return;
        var metrics = pngGlyphMetrics(char, fontSize, prefix);
        var scale = pngCharScale(prefix, char);
        var yOffset = pngCharYOffset(prefix, char, fontSize);
        var gap = pngPairGap(prefix, char, chars[charIndex + 1], fontSize, dpr);
        var h = metrics.height * dpr * scale;
        var w = (glyph.img.naturalWidth / glyph.img.naturalHeight) * h;
        var advance = pngGlyphAdvance(prefix, char, w, fontSize, dpr);
        var topOffset = metrics.top + yOffset - ((metrics.height * (scale - 1)) / 2);
        drawPngGlyph(ctx, glyph, cursor + ((advance - w) / 2), (lineTop + topOffset - minTop) * dpr, w, h, color, dpr);
        cursor += advance + gap;
      });

      lineTop += lineHeight + lineGap;
    });
  }


  function fontStack(fontFamily, fontSize) {
    const profile = EFFECT_FONTS[fontFamily] || {
      family: /\s/.test(fontFamily) ? '"' + fontFamily + '"' : fontFamily,
      weight: "900",
      style: "normal"
    };
    return profile.style + " " + profile.weight + " " + fontSize + "px " + profile.family;
  }

  function measureText(text, fontSize, fontFamily) {
    const mc   = document.createElement("canvas");
    const mctx = mc.getContext("2d");
    mctx.font         = fontStack(fontFamily, fontSize);
    mctx.textBaseline = "alphabetic";
    const rows = textRows(text);
    let width = 0;
    let left = 0;
    let ascent = 0;
    let descent = 0;
    rows.forEach(function (line) {
      const m = mctx.measureText(line);
      const lineLeft = Math.max(0, Math.ceil(m.actualBoundingBoxLeft || 0));
      const lineRight = Math.max(0, Math.ceil(m.actualBoundingBoxRight || m.width));
      width = Math.max(width, lineLeft + lineRight);
      left = Math.max(left, lineLeft);
      ascent = Math.max(ascent, Math.ceil(m.actualBoundingBoxAscent || fontSize * 0.78));
      descent = Math.max(descent, Math.ceil(m.actualBoundingBoxDescent || fontSize * 0.22));
    });
    const lineHeight = Math.max(fontSize * 1.16, ascent + descent);
    return {
      width:   width,
      left:    left,
      ascent:  Math.ceil(ascent + lineHeight * (rows.length - 1)),
      descent: Math.ceil(descent)
    };
  }

  /* Hex rengi RGB'ye çevirir */
  function hexToRgb(hex) {
    let h = hex.replace("#", "");
    if (h.length === 3) {
      h = h.split("").map(function (char) { return char + char; }).join("");
    }
    return {
      r: parseInt(h.slice(0, 2), 16),
      g: parseInt(h.slice(2, 4), 16),
      b: parseInt(h.slice(4, 6), 16)
    };
  }

  function clampChannel(value) {
    return Math.max(0, Math.min(255, Math.round(value)));
  }

  function mixColor(hex, amount, alpha) {
    const c = hexToRgb(hex);
    const target = amount >= 0 ? 255 : 0;
    const ratio = Math.abs(amount);
    return "rgba(" +
      clampChannel(c.r + (target - c.r) * ratio) + "," +
      clampChannel(c.g + (target - c.g) * ratio) + "," +
      clampChannel(c.b + (target - c.b) * ratio) + "," + alpha + ")";
  }

  function colorLuma(hex) {
    const c = hexToRgb(hex);
    return (c.r * 299 + c.g * 587 + c.b * 114) / 1000;
  }

  const THREAD_RGB = THREAD_COLORS.map(function (hex) {
    var rgb = hexToRgb(hex);
    rgb.hex = hex;
    return rgb;
  });

  function normalizeHex(hex) {
    if (!hex) return "";
    var h = hex.toLowerCase();
    if (h.length === 4) {
      h = "#" + h.slice(1).split("").map(function (char) { return char + char; }).join("");
    }
    return h;
  }

  function nearestThreadColor(r, g, b, allowedColors) {
    var allowed = allowedColors && allowedColors.length ? allowedColors.map(normalizeHex) : null;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    if (max > 216 && max - min < 34 && (!allowed || allowed.indexOf("#ffffff") !== -1)) return "#ffffff";
    var best = THREAD_RGB[0];
    var bestScore = Infinity;
    THREAD_RGB.forEach(function (color) {
      if (allowed && allowed.indexOf(color.hex) === -1) return;
      var dr = r - color.r;
      var dg = g - color.g;
      var db = b - color.b;
      var score = dr * dr * 0.32 + dg * dg * 0.44 + db * db * 0.24;
      if (score < bestScore) {
        bestScore = score;
        best = color;
      }
    });
    return best.hex;
  }

  function logoThreadColor(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var chroma = max - min;
    var luma = (r * 299 + g * 587 + b * 114) / 1000;
    if (chroma < 56) {
      // Akromatik: koyu → siyah, orta ton → gri iplik, yalnız gerçekten açık olan → beyaz
      if (luma > 210) return "#ffffff";
      if (luma > 92) return "#a0a0a0";
      return "#000000";
    }
    if (max > 216 && chroma < 34) return "#ffffff";
    return nearestThreadColor(r, g, b);
  }

  function renderLogoColorTools() {
    if (logoColorCount) logoColorCount.textContent = String(logoMaxColors);
    if (!logoSourceColors || !logoTargetColors) return;

    logoSourceColors.innerHTML = "";
    logoDetectedColors.forEach(function (hex) {
      var mapped = normalizeHex(logoColorMap[hex] || hex);
      var btn = document.createElement("button");
      var removed = mapped === "transparent";
      btn.type = "button";
      btn.className = "thread-swatch" + (removed ? " is-empty" : "") + (hex === logoSelectedSourceColor ? " active" : "");
      if (!removed) btn.style.setProperty("--swatch-color", mapped);
      btn.dataset.sourceColor = hex;
      btn.title = hex + (mapped !== hex ? " → " + (removed ? "kaldır" : mapped) : "");
      btn.addEventListener("click", function () {
        logoSelectedSourceColor = hex;
        renderLogoColorTools();
      });
      logoSourceColors.appendChild(btn);
    });

    logoTargetColors.innerHTML = "";
    var removeActive = logoSelectedSourceColor && normalizeHex(logoColorMap[logoSelectedSourceColor]) === "transparent";
    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "thread-swatch is-empty" + (removeActive ? " active" : "");
    removeBtn.title = "Bu rengi kaldır";
    removeBtn.addEventListener("click", function () {
      if (!logoSelectedSourceColor) return;
      logoColorMap[logoSelectedSourceColor] = "transparent";
      renderLogoColorTools();
      if (activeDesignType === "logo") renderLogoCanvas();
    });
    logoTargetColors.appendChild(removeBtn);

    THREAD_COLORS.forEach(function (hex) {
      var normalized = normalizeHex(hex);
      var active = logoSelectedSourceColor && normalizeHex(logoColorMap[logoSelectedSourceColor] || logoSelectedSourceColor) === normalized;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "thread-swatch" + (active ? " active" : "");
      btn.style.setProperty("--swatch-color", normalized);
      btn.dataset.targetColor = normalized;
      btn.addEventListener("click", function () {
        if (!logoSelectedSourceColor) return;
        logoColorMap[logoSelectedSourceColor] = normalized;
        renderLogoColorTools();
        if (activeDesignType === "logo") renderLogoCanvas();
      });
      logoTargetColors.appendChild(btn);
    });
  }

  // Palet, küçültülmüş sahne canvas'ından DEĞİL logonun doğal çözünürlüğünden çıkarılır:
  // küçültme, renk sınırlarında geniş karışım bantları üretip palete sahte renk sokuyor.
  // Aynı logo + aynı maks. renk için yeniden hesaplanmaz (recolor/resize hızlanır).
  var lastPaletteImg = null;
  var lastPaletteMax = 0;
  function updateLogoPaletteFromNatural() {
    if (!logoImage) return;
    if (logoImage === lastPaletteImg && logoMaxColors === lastPaletteMax) return;
    lastPaletteImg = logoImage;
    lastPaletteMax = logoMaxColors;
    var nw = logoImage.naturalWidth || logoImage.width;
    var nh = logoImage.naturalHeight || logoImage.height;
    if (!nw || !nh) return;
    var k = Math.min(1, 900 / Math.max(nw, nh));
    var w = Math.max(1, Math.round(nw * k));
    var h = Math.max(1, Math.round(nh * k));
    var c = document.createElement("canvas");
    c.width = w; c.height = h;
    var cx = c.getContext("2d");
    cx.drawImage(logoImage, 0, 0, w, h);
    var srcData = cx.getImageData(0, 0, w, h).data;
    updateLogoPaletteFromImage(srcData, srcData, w, h); // maske = alfa kanalının kendisi
  }

  function updateLogoPaletteFromImage(sourceData, maskData, width, height) {
    var counts = {};
    var solid = {};
    var sampleStep = Math.max(1, Math.round(Math.max(width, height) / 220));
    var d = sampleStep;

    function hexAt(xPos, yPos) {
      if (xPos < 0 || yPos < 0 || xPos >= width || yPos >= height) return null;
      var idx = (yPos * width + xPos) * 4;
      if (maskData[idx + 3] <= 24) return null;
      return logoThreadColor(sourceData[idx], sourceData[idx + 1], sourceData[idx + 2]);
    }

    for (var yPos = 0; yPos < height; yPos += sampleStep) {
      for (var xPos = 0; xPos < width; xPos += sampleStep) {
        var hex = hexAt(xPos, yPos);
        if (!hex) continue;
        counts[hex] = (counts[hex] || 0) + 1;
        // Kenar antialias bantları palete sahte renk sokuyor: yalnız komşuları da
        // aynı renge çıkan "katı" örnekler palet adayı sayılır.
        var same = 0;
        if (hexAt(xPos - d, yPos) === hex) same++;
        if (hexAt(xPos + d, yPos) === hex) same++;
        if (hexAt(xPos, yPos - d) === hex) same++;
        if (hexAt(xPos, yPos + d) === hex) same++;
        if (same >= 3) solid[hex] = (solid[hex] || 0) + 1;
      }
    }

    var candidates = Object.keys(solid).filter(function (hex) { return solid[hex] >= 3; });
    if (!candidates.length) candidates = Object.keys(counts); // tamamı ince detaysa eski davranış
    logoDetectedColors = candidates
      .sort(function (a, b) { return counts[b] - counts[a]; })
      .slice(0, logoMaxColors)
      .map(normalizeHex);

    var keep = {};
    logoDetectedColors.forEach(function (hex) { keep[hex] = true; });
    Object.keys(logoColorMap).forEach(function (hex) {
      if (!keep[hex]) delete logoColorMap[hex];
    });
    if (!logoSelectedSourceColor || !keep[logoSelectedSourceColor]) {
      logoSelectedSourceColor = logoDetectedColors[0] || "";
    }
    renderLogoColorTools();
  }

  // Piksel renklerini iplik paletine indirger; ayrıca tatami motoru için
  // piksel başına renk bölgesi haritası (region: palet indeksi, -1=boş) üretir.
  function quantizeLogoSource(sourceImage, maskData, width, height) {
    if (!logoDetectedColors.length) return { image: sourceImage, region: null, palette: [] };
    var image = new ImageData(new Uint8ClampedArray(sourceImage.data), width, height);
    var data = image.data;
    var region = new Int16Array(width * height);
    region.fill(-1);
    var palette = [];
    var palIndex = {};

    for (var i = 0; i < data.length; i += 4) {
      if (maskData[i + 3] <= 24) {
        data[i + 3] = 0;
        continue;
      }
      var baseHex = logoThreadColor(data[i], data[i + 1], data[i + 2]);
      // palet dışı kalan (antialias sınırı) pikselleri algılanan renklerden en yakınına yapıştır
      if (logoDetectedColors.indexOf(baseHex) === -1) {
        baseHex = nearestThreadColor(data[i], data[i + 1], data[i + 2], logoDetectedColors);
      }
      var mappedHex = normalizeHex(logoColorMap[baseHex]);
      var finalHex = mappedHex || baseHex;
      if (finalHex === "transparent") {
        data[i + 3] = 0;
        continue;
      }

      var pi = palIndex[finalHex];
      if (pi == null) {
        pi = palette.length;
        palette.push(finalHex);
        palIndex[finalHex] = pi;
      }
      region[i >> 2] = pi;

      var rgb = hexToRgb(finalHex);
      data[i] = rgb.r;
      data[i + 1] = rgb.g;
      data[i + 2] = rgb.b;
      data[i + 3] = maskData[i + 3];
    }
    return { image: image, region: region, palette: palette };
  }

  // Maske alfa kanalından temiz nakış görünümü: düz dolgu + kenar kabartması
  // + (istenirse) iplik saçağı + kumaş gölgesi. Hem gerçek font hem PNG glyph
  // yolunun ortak efekt motoru.
  function applyEmbroideryEffect(canvas, mask, color, fontSize, useFringe) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
    const ctx = canvas.getContext("2d");
    const W = canvas.width, H = canvas.height;
    if (!W || !H) return;
    const N = W * H;

    ctx.clearRect(0, 0, W, H);

    const md = mask.getContext("2d").getImageData(0, 0, W, H).data;
    const ink0 = new Uint8Array(N);
    for (let i = 0; i < N; i++) ink0[i] = md[i * 4 + 3] > 60 ? 1 : 0;

    // Chamfer mesafe dönüşümü (3-4)
    function edt(inside) {
      const d = new Float32Array(N);
      for (let i = 0; i < N; i++) d[i] = ink0[i] === inside ? 1e7 : 0;
      for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
        const i = y * W + x;
        let v = d[i];
        if (v === 0) continue;
        if (x > 0) v = Math.min(v, d[i - 1] + 3);
        if (y > 0) {
          v = Math.min(v, d[i - W] + 3);
          if (x > 0) v = Math.min(v, d[i - W - 1] + 4);
          if (x < W - 1) v = Math.min(v, d[i - W + 1] + 4);
        }
        d[i] = v;
      }
      for (let y = H - 1; y >= 0; y--) for (let x = W - 1; x >= 0; x--) {
        const i = y * W + x;
        let v = d[i];
        if (v === 0) continue;
        if (x < W - 1) v = Math.min(v, d[i + 1] + 3);
        if (y < H - 1) {
          v = Math.min(v, d[i + W] + 3);
          if (x < W - 1) v = Math.min(v, d[i + W + 1] + 4);
          if (x > 0) v = Math.min(v, d[i + W - 1] + 4);
        }
        d[i] = v;
      }
      for (let i = 0; i < N; i++) d[i] /= 3;
      return d;
    }
    const D = edt(1);

    function blur(a, r, passes) {
      const b = new Float32Array(N);
      const span = 2 * r + 1;
      for (let p = 0; p < passes; p++) {
        for (let y = 0; y < H; y++) {
          const row = y * W;
          let acc = 0;
          for (let x = -r; x <= r; x++) acc += a[row + Math.min(W - 1, Math.max(0, x))];
          for (let x = 0; x < W; x++) {
            b[row + x] = acc / span;
            acc += a[row + Math.min(W - 1, x + r + 1)] - a[row + Math.max(0, x - r)];
          }
        }
        for (let x = 0; x < W; x++) {
          let acc = 0;
          for (let y = -r; y <= r; y++) acc += b[Math.min(H - 1, Math.max(0, y)) * W + x];
          for (let y = 0; y < H; y++) {
            a[y * W + x] = acc / span;
            acc += b[Math.min(H - 1, y + r + 1) * W + x] - b[Math.max(0, y - r) * W + x];
          }
        }
      }
      return a;
    }

    // Kabartma için mesafe alanı gradyanı
    const Ds = blur(Float32Array.from(D), Math.max(1, Math.round(dpr)), 2);
    const gxA = new Float32Array(N), gyA = new Float32Array(N);
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const i = y * W + x;
      gxA[i] = Ds[y * W + Math.min(W - 1, x + 1)] - Ds[y * W + Math.max(0, x - 1)];
      gyA[i] = Ds[Math.min(H - 1, y + 1) * W + x] - Ds[Math.max(0, y - 1) * W + x];
    }

    // Saçak yalnız gerçek font yolunda gerekli (PNG glyph kenarları zaten dikişli)
    let Dout = null, binsS = null, fno = null, cosA = null, sinA = null;
    let spacing = 1, fringe = 0;
    const K = 8;
    if (useFringe) {
      Dout = edt(0);
      const c2 = new Float32Array(N), s2 = new Float32Array(N);
      for (let i = 0; i < N; i++) {
        const th = Math.atan2(gxA[i], -gyA[i]);
        c2[i] = Math.cos(2 * th);
        s2[i] = Math.sin(2 * th);
      }
      const rDir = Math.max(1, Math.round(3 * dpr));
      blur(c2, rDir, 2);
      blur(s2, rDir, 2);
      const bins = new Uint8Array(N);
      for (let i = 0; i < N; i++) {
        const th = 0.5 * Math.atan2(s2[i], c2[i]);
        bins[i] = ((Math.round((th + Math.PI / 2) / Math.PI * K) % K) + K) % K;
      }
      binsS = new Uint8Array(N);
      const best = new Float32Array(N);
      const tmp = new Float32Array(N);
      for (let k = 0; k < K; k++) {
        for (let i = 0; i < N; i++) tmp[i] = bins[i] === k ? 1 : 0;
        blur(tmp, rDir, 2);
        for (let i = 0; i < N; i++) if (tmp[i] > best[i]) { best[i] = tmp[i]; binsS[i] = k; }
      }
      let seed = 123456789;
      function rnd() { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296 - 0.5; }
      fno = new Float32Array(N);
      for (let i = 0; i < N; i++) fno[i] = rnd() * 2;
      blur(fno, Math.max(1, Math.round(0.6 * dpr)), 2);
      let sum = 0;
      for (let i = 0; i < N; i++) sum += fno[i] * fno[i];
      const k2 = 1 / (Math.sqrt(sum / N) || 1);
      for (let i = 0; i < N; i++) fno[i] *= k2;
      spacing = Math.max(2.6, fontSize * 0.095) * dpr;
      fringe = Math.max(0.6, fontSize * 0.010) * dpr;
      cosA = []; sinA = [];
      for (let k = 0; k < K; k++) {
        const ang = (k / K) * Math.PI - Math.PI / 2;
        cosA[k] = Math.cos(ang);
        sinA[k] = Math.sin(ang);
      }
    }

    const rgb = hexToRgb(color);
    const tex = document.createElement("canvas");
    tex.width = W; tex.height = H;
    const tctx = tex.getContext("2d");
    const img = tctx.createImageData(W, H);
    const px = img.data;

    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const i = y * W + x;
      let isInk = ink0[i] === 1;
      let isFringe = false;
      if (!isInk) {
        if (!useFringe) continue;
        const k = binsS[i];
        const ph = (x * cosA[k] + y * sinA[k]) / spacing;
        const t = ph - Math.floor(ph);
        const u = 2 * t - 1;
        const cyl = Math.sqrt(Math.max(0, 1 - u * u));
        const crest = Math.min(1, Math.max(0, (cyl - 0.85) / 0.15));
        if (crest > 0) {
          const fn = Math.min(1.2, Math.max(0.3, fno[i] * 0.4 + 0.8));
          if (Dout[i] <= fringe * crest * fn) { isInk = true; isFringe = true; }
        }
        if (!isInk) continue;
      }

      const edge = Math.min(1, (isFringe ? 0.45 : D[i] / (1.5 * dpr)));
      // Kenar kabartması: sol-üstten ışık, sağ-alta gölge (3B puf etkisi)
      let emboss = 0;
      const gl = Math.hypot(gxA[i], gyA[i]);
      if (gl > 0.01) {
        const band = Math.max(0, 1 - D[i] / (2.2 * dpr));
        emboss = ((-gxA[i] - gyA[i]) / gl) * 0.7071 * band * 0.22;
      }
      const f = 0.985 * (0.72 + 0.28 * edge) * (1 + emboss);
      const p = i * 4;
      px[p]     = Math.min(255, Math.max(0, rgb.r * f));
      px[p + 1] = Math.min(255, Math.max(0, rgb.g * f));
      px[p + 2] = Math.min(255, Math.max(0, rgb.b * f));
      px[p + 3] = 255;
    }
    tctx.putImageData(img, 0, 0);

    ctx.save();
    ctx.shadowColor = "rgba(0,0,0,0.5)";
    ctx.shadowBlur = Math.max(0.8, dpr * 1.1);
    ctx.shadowOffsetX = Math.max(0.5, dpr * 0.7);
    ctx.shadowOffsetY = Math.max(0.7, dpr * 0.95);
    ctx.drawImage(tex, 0, 0);
    ctx.restore();
  }

  // UV baskı: düz, keskin, dokusuz metin (gerçek font)
  function renderUvText(canvas, text, color, fontSize, fontFamily, pad) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
    const ctx = canvas.getContext("2d");
    const W = canvas.width, H = canvas.height;
    if (!W || !H) return;
    const font = fontStack(fontFamily, Math.round(fontSize * dpr));
    const rows = textRows(text);
    const lineAscent = Math.max(1, fontSize * 0.78);
    const lineHeight = Math.max(fontSize * 1.16, lineAscent + fontSize * 0.22) * dpr;
    ctx.clearRect(0, 0, W, H);
    ctx.font = font;
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = color;
    rows.forEach(function (line, i) {
      const mm = ctx.measureText(line);
      const left = Math.max(0, mm.actualBoundingBoxLeft || 0);
      const right = Math.max(0, mm.actualBoundingBoxRight || mm.width);
      const x = Math.round((W - (left + right)) / 2 + left);
      const y = Math.round(pad * dpr + lineAscent * dpr + i * lineHeight);
      ctx.fillText(line, x, y);
    });
  }

  function renderEmbroidery(canvas, text, color, fontSize, fontFamily, pad, ascent, textLeft) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
    const W = canvas.width, H = canvas.height;
    if (!W || !H) return;
    const fSize = Math.round(fontSize * dpr);
    const font = fontStack(fontFamily, fSize);
    const rows = textRows(text);
    const lineAscent = Math.max(1, fontSize * 0.78);
    const lineHeight = Math.max(fontSize * 1.16, lineAscent + fontSize * 0.22) * dpr;

    const mask = document.createElement("canvas");
    mask.width = W; mask.height = H;
    const mctx = mask.getContext("2d");
    mctx.font = font;
    mctx.textBaseline = "alphabetic";
    mctx.fillStyle = "#fff";
    rows.forEach(function (line, i) {
      const m = mctx.measureText(line);
      const left = Math.max(0, m.actualBoundingBoxLeft || 0);
      const right = Math.max(0, m.actualBoundingBoxRight || m.width);
      const x = Math.round((W - (left + right)) / 2 + left);
      const y = Math.round(pad * dpr + lineAscent * dpr + i * lineHeight);
      mctx.fillText(line, x, y);
    });

    applyEmbroideryEffect(canvas, mask, color, fontSize, true);
  }

  /* Render sonrası canvas'ı gerçek içerik sınırına kırpar */
  function trimCanvas(canvas, dpr) {
    const ctx  = canvas.getContext("2d");
    const W    = canvas.width;
    const H    = canvas.height;
    const data = ctx.getImageData(0, 0, W, H).data;
    let minY = H, maxY = -1, minX = W, maxX = -1;

    for (var y = 0; y < H; y++) {
      for (var x = 0; x < W; x++) {
        if (data[(y * W + x) * 4 + 3] > 8) {
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
        }
      }
    }

    if (maxY < minY || maxX < minX) return;

    // Nakış sırtı için 1px güvenlik payı, başka boşluk yok
    var pixPad = Math.round(dpr);
    minY = Math.max(0, minY - pixPad);
    maxY = Math.min(H - 1, maxY + pixPad);
    minX = Math.max(0, minX - pixPad);
    maxX = Math.min(W - 1, maxX + pixPad);

    var newW = maxX - minX + 1;
    var newH = maxY - minY + 1;
    if (newW === W && newH === H) return;

    var cropped = ctx.getImageData(minX, minY, newW, newH);
    canvas.width  = newW;
    canvas.height = newH;
    canvas.style.width  = (newW / dpr) + "px";
    canvas.style.height = (newH / dpr) + "px";
    canvas.getContext("2d").putImageData(cropped, 0, 0);
  }

  function isPngFont(font) {
    return PNG_FONTS.indexOf(font) !== -1;
  }

  function updateEmbroidery() {
    const pad = Math.max(6, currentSize * 0.12);
    const dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
    activeDesignType = "text";
    if (!updateFontWarning(currentText)) return;
    const usePng = !isUv() && isPngFont(selectedFont) && pngFontSupports(selectedFont, currentText);
    const glyphMeasure = usePng ? measurePngText(selectedFont, currentText, currentSize) : null;
    const fallbackFont = selectedFont;
    const m = glyphMeasure || measureText(currentText, currentSize, fallbackFont);
    const w = Math.ceil(m.width + pad * 2);
    const h = Math.ceil(m.ascent + m.descent + pad * 2);

    embCanvas.width        = w * dpr;
    embCanvas.height       = h * dpr;
    embCanvas.style.width  = w + "px";
    embCanvas.style.height = h + "px";

    if (glyphMeasure) {
      renderPngText(selectedFont, embCanvas, currentText, selectedColor, currentSize, pad);
    } else if (isUv()) {
      renderUvText(embCanvas, currentText, selectedColor, currentSize, fallbackFont, pad);
    } else {
      renderEmbroidery(embCanvas, currentText, selectedColor, currentSize, fallbackFont, pad, m.ascent, m.left);
    }

    trimCanvas(embCanvas, dpr);
    render();
  }

  function scheduleEmbroideryUpdate() {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      // Ertelenen güncelleme yazı içindir: kare çalışana dek aktif tasarım
      // LOGO olduysa (glif/font yüklemesi + hızlı logo uygulama yarışı,
      // arka plan sekmesinde donan rAF) yazıyı logonun üstüne çizme
      if (activeDesignType === "logo") return;
      updateEmbroidery();
    });
  }

  // Görünüme göre geçerli teknik: 3D yalnız ÖN yüze uygulanır,
  // 3D seçiliyken yan görünümler klasik nakış kurallarıyla çalışır
  function effectiveTechnique(view) {
    if (currentTechnique === "3d" && (view || currentView) !== "front") return "nakis";
    return currentTechnique;
  }

  // 3D nakışta minimum harf yüksekliği 3 cm (üretim sınırı); diğer bağlamlarda 20 px
  function minTextSizePx() {
    if (effectiveTechnique(currentView) !== "3d") return 20;
    var s = cmPerPx(currentView);
    if (!s) return 20;
    return Math.max(20, Math.round(3 / s / 1.04));
  }

  // Tasarım alandan taşıyorsa sığacak şekilde küçült (yazı + logo/desen)
  function fitDesignToSafeArea() {
    if (textBox.classList.contains("is-hidden")) return;
    var area = safeAreaClientRect();
    if (!area.width || !area.height) return;
    var maxW = area.width * 0.92;
    var maxH = area.height * 0.92;
    var isLogo = activeDesignType === "logo";
    for (var i = 0; i < 24; i++) {
      var box = textBox.getBoundingClientRect();
      if (box.width <= maxW && box.height <= maxH) break;
      var ratio = Math.min(maxW / box.width, maxH / box.height);
      // Her adımda en az 1 azal: oran hesabı bayat rect yüzünden takılsa bile yakınsar
      var next = Math.max(isLogo ? 20 : minTextSizePx(),
        Math.min(Math.floor(currentSize * ratio), currentSize - 1));
      if (next >= currentSize) break;
      currentSize = next;
      if (isLogo) {
        if (logoSizeInput) logoSizeInput.value = String(Math.round(currentSize));
        renderLogoCanvas();
      } else {
        if (sizeInput) sizeInput.value = String(Math.round(currentSize));
        updateEmbroidery();
      }
    }
  }

  // Geriye dönük uyumluluk
  function fitTextToSafeArea() { fitDesignToSafeArea(); }

  /* ── Konumlandırma & sınır kontrolü ─────────────────────── */

  const DEFAULT_SAFE_AREA = { top: 18, left: 13, width: 74, height: 36 };
  let currentSafeArea = Object.assign({}, DEFAULT_SAFE_AREA);

  // "top,left,width,height" (yüzde) formatını çözer; geçersizse null
  function parseSafeArea(str) {
    if (!str) return null;
    var parts = String(str).split(",").map(function (s) { return parseFloat(s); });
    if (parts.length !== 4 || parts.some(function (n) { return isNaN(n); })) return null;
    return { top: parts[0], left: parts[1], width: parts[2], height: parts[3] };
  }

  const DEFAULT_SIDE_SAFE_AREA_RIGHT = { top: 48, left: 23, width: 31, height: 16 };
  const DEFAULT_SIDE_SAFE_AREA_LEFT  = { top: 48, left: 47, width: 31, height: 16 };

  // Model bazlı tasarım alanları (fotoğraf analizinden; kadrajlar standart olduğundan tek değer)
  const MODEL_SAFE = {
    "new-era": {
      // Katalog 3/4 sağ açı — yan panel bölgesi; varyant metafield'i (safe_area_right) ezer
      right: { top: 40.0, left: 42.0, width: 26.0, height: 18.0 }
    },
    yikamali: {
      front: { top: 21.0, left: 12.9, width: 72.5, height: 35.3 },
      left:  { top: 52.5, left: 50.0, width: 25.5, height: 15.0 },
      right: { top: 52.5, left: 24.0, width: 26.5, height: 15.0 }
    },
    bere: {
      // Nakış katlanan manşet bandına oturur — kullanıcının Mor'da elle ayarladığı değer (10 Tem)
      front: { top: 62.0, left: 22.0, width: 57.0, height: 25.0 }
    }
  };

  function modelSafeFor(btn, view) {
    var h = (btn && btn.dataset.model || "").toLowerCase();
    for (var key in MODEL_SAFE) {
      if (h.indexOf(key) !== -1) return MODEL_SAFE[key][view] || null;
    }
    return null;
  }

  // Patch şapka: beyaz patch içi tasarım alanları (fotoğraf analizinden, renk bazlı)
  const PATCH_SAFE_BY_COLOR = {
    gri:      { top: 22.2, left: 37.3, width: 27.6, height: 27.6 },
    bordo:    { top: 23.3, left: 37.7, width: 27.1, height: 27.2 },
    haki:     { top: 22.1, left: 35.8, width: 28.3, height: 28.2 },
    camel:    { top: 22.8, left: 36.3, width: 27.4, height: 27.4 },
    beyaz:    { top: 23.0, left: 36.9, width: 27.8, height: 27.9 },
    siyah:    { top: 21.1, left: 36.5, width: 28.5, height: 28.1 },
    gecemavi: { top: 23.0, left: 37.5, width: 27.9, height: 27.8 },
    lacivert: { top: 24.9, left: 36.1, width: 27.7, height: 27.7 },
    kirmizi:  { top: 24.5, left: 36.4, width: 27.1, height: 27.2 },
    bej:      { top: 22.6, left: 36.4, width: 27.1, height: 27.2 },
    mavi:     { top: 21.7, left: 36.4, width: 27.1, height: 27.2 }
  };

  function normColorKey(name) {
    return (name || "").toLowerCase()
      .replace(/ı/g, "i").replace(/ö/g, "o").replace(/ü/g, "u")
      .replace(/ş/g, "s").replace(/ç/g, "c").replace(/ğ/g, "g")
      .replace(/[^a-z]/g, "");
  }

  function patchColorKeyForVariant(btn) {
    var img = btn && btn.querySelector("img");
    var title = img ? (img.alt || "") : "";
    var renk = normColorKey(title.split("/")[0]);
    var key = null;
    if (renk.indexOf("gecemavi") !== -1 || renk.indexOf("gece") !== -1) key = "gecemavi";
    else if (renk.indexOf("lacivert") !== -1) key = "lacivert";
    else if (renk.indexOf("saks") !== -1 || renk.indexOf("mavi") !== -1) key = "mavi";
    else {
      ["gri","bordo","haki","camel","beyaz","siyah","kirmizi","bej"].forEach(function (k) {
        if (renk.indexOf(k) !== -1) key = k;
      });
    }
    return key;
  }

  function patchSafeForVariant(btn) {
    var key = patchColorKeyForVariant(btn);
    return key ? PATCH_SAFE_BY_COLOR[key] : null;
  }

  // Siyah patch: varyant yok — renk anahtarına göre tema asseti (patch-siyah-<renk>.jpg)
  let patchColor = "beyaz";
  function patchBlackImage(btn) {
    var key = patchColorKeyForVariant(btn);
    if (!key) return null;
    return glyphBase + "patch-siyah-" + key + ".jpg?v=20260713";
  }

  function selectedVariantBtn() {
    return selectedVariantId
      ? document.querySelector('.hat-option[data-variant-id="' + selectedVariantId + '"]')
      : null;
  }

  // Hazır şapkalar (New Era): nakış yalnız SAĞ yana yapılır
  function onlyRightModel() {
    var b = selectedVariantBtn();
    return !!(b && b.dataset.onlySide === "right");
  }

  // Tasarım oluşturulmadan önce: sadece-sağ modelde görünümü sağa zorla
  function ensureDesignableView() {
    if (onlyRightModel() && currentView !== "right" && viewImage("right")) setView("right");
  }

  function viewImage(view) {
    var btn = selectedVariantBtn();
    if (!btn) return null;
    if (view === "left") return btn.dataset.sideLeft || null;
    if (view === "right") return btn.dataset.sideRight || null;
    if (patchColor === "siyah" && techniqueOf(btn) === "uv") {
      var siyahImg = patchBlackImage(btn);
      if (siyahImg) return siyahImg;
    }
    return btn.dataset.image || null;
  }

  function viewSafeAreaValues(view) {
    var btn = selectedVariantBtn();
    var str = "";
    if (btn) {
      str = view === "left" ? btn.dataset.safeAreaLeft
          : view === "right" ? btn.dataset.safeAreaRight
          : btn.dataset.safeArea;
    }
    var fromMeta = parseSafeArea(str);
    if (fromMeta) return fromMeta;
    // Patch ürünü: ön tasarım alanı = patch içi (renk bazlı harita)
    if (view === "front" && btn && techniqueOf(btn) === "uv") {
      var pSafe = patchSafeForVariant(btn);
      if (pSafe) return Object.assign({}, pSafe);
    }
    // Model bazlı alanlar (yıkamalı vb.)
    var mSafe = modelSafeFor(btn, view);
    if (mSafe) return Object.assign({}, mSafe);
    var fallback = view === "front" ? DEFAULT_SAFE_AREA
                 : view === "left"  ? DEFAULT_SIDE_SAFE_AREA_LEFT
                 : DEFAULT_SIDE_SAFE_AREA_RIGHT;
    return Object.assign({}, fallback);
  }

  function applySafeAreaForVariant() {
    currentSafeArea = viewSafeAreaValues(currentView);
  }

  function refreshViewSwitcher() {
    if (!viewSwitcher) return;
    var hasLeft = !!viewImage("left");
    var hasRight = !!viewImage("right");
    viewSwitcher.classList.toggle("is-hidden", !hasLeft && !hasRight);
    var section = document.querySelector(".braver-customizer");
    if (section) section.classList.toggle("has-views", hasLeft || hasRight);
    viewSwitcher.querySelectorAll("button").forEach(function (btn) {
      var v = btn.dataset.view;
      var src = viewImage(v);
      btn.style.display = (v === "front" || src) ? "" : "none";
      btn.classList.toggle("active", v === currentView);
      var thumb = btn.querySelector("img");
      if (thumb && src) {
        // küçük önizleme: 180px versiyonu yeterli
        thumb.src = src.replace(/width=1200/, "width=180");
      }
    });
  }

  function setView(view) {
    if (view === currentView) return;
    if (view !== "front" && !viewImage(view)) return;
    freezeCurrentDesign(); // aktif tasarım kendi görünümünde sabitlenir
    currentView = view;
    var img = viewImage(view);
    if (img) mainHat.src = img;
    // görünürlük ÖNCE: ara checkBounds çağrıları gizli elemanı (0,0) sanmasın
    committedDesigns.forEach(function (d) {
      d.el.style.display = (d.details.view || "front") === view ? "" : "none";
    });
    applySafeAreaForVariant();
    autoSafeArea();
    refreshViewSwitcher();
    // Bağlam görünüme bağlı (3D=ön / nakış=yan): font listesi, araçlar, boyut tabanı
    applyTechniqueFilters(currentTechnique);
    updateAddButton();
    checkBounds();
    // görsel yükleme/yerleşim oturduktan sonra güvence denetimi
    setTimeout(checkBounds, 150);
  }

  var baseMaskD = "";

  function updateHatMask() {
    var mask = document.getElementById("hatMask");
    var hole = document.getElementById("patchHolePath");
    if (!mask || !hole) return;
    if (!isUv()) { mask.classList.remove("on"); baseMaskD = ""; return; }
    mask.src = mainHat.src;
    var a = currentSafeArea;
    var l = a.left / 100, t = a.top / 100, w = a.width / 100, h = a.height / 100;
    baseMaskD = "M0,0 H1 V1 H0 Z M" + l + "," + t + " h" + w + " v" + h + " h-" + w + " Z";
    hole.setAttribute("d", baseMaskD);
    mask.classList.add("on");
    refreshMaskButtonHoles();
  }

  function refreshMaskButtonHoles() { /* yüzen butonlara geçildi */ }

  // Tutamaç butonları: tasarım kutusunun DIŞINDA, köşelerde yüzer (maske üstünde)
  function positionActionButtons() {
    var btns = [deleteText, rotateText, resizeText];
    var visible = !textBox.classList.contains("is-hidden") &&
                  textBox.classList.contains("active");
    btns.forEach(function (b) { b.style.display = visible ? "flex" : "none"; });
    if (!visible) return;
    var host = document.getElementById("stageZoom");
    var sr = host.getBoundingClientRect();
    var tr = textBox.getBoundingClientRect();
    var scale = (sr.width / host.offsetWidth) || 1;
    var m = 6; // köşeden dışa pay
    function place(b, cx, cy) {
      b.style.left = ((cx - sr.left) / scale) + "px";
      b.style.top = ((cy - sr.top) / scale) + "px";
    }
    place(deleteText, tr.left - m, tr.bottom + m);
    place(rotateText, tr.right + m, tr.top - m);
    place(resizeText, tr.right + m, tr.bottom + m);
  }

  function autoSafeArea() {
    const area = currentSafeArea;
    safeArea.style.top    = area.top    + "%";
    safeArea.style.left   = area.left   + "%";
    safeArea.style.width  = area.width  + "%";
    safeArea.style.height = area.height + "%";
    addBtn.style.top    = area.top    + "%";
    addBtn.style.left   = area.left   + "%";
    addBtn.style.width  = area.width  + "%";
    addBtn.style.height = area.height + "%";
    textBox.style.top   = (area.top  + area.height / 2) + "%";
    textBox.style.left  = (area.left + area.width  / 2) + "%";
    updateHatMask();
    checkBounds();
  }

  function render() {
    if (activeDesignType === "logo" && mode === "resize" && logoResizeBaseWidth && logoResizeBaseHeight) {
      const previewScale = Math.max(0.1, currentSize / Math.max(1, startSize));
      embCanvas.style.width = Math.max(1, Math.round(logoResizeBaseWidth * previewScale)) + "px";
      embCanvas.style.height = Math.max(1, Math.round(logoResizeBaseHeight * previewScale)) + "px";
    }
    textBox.style.transform =
      "translate(calc(-50% + " + x + "px), calc(-50% + " + y + "px)) " +
      "rotate(" + rotation + "deg)";
    positionActionButtons();
    checkBounds();
  }

  function scheduleRender() {
    if (renderFrame) return;
    renderFrame = window.requestAnimationFrame(function () {
      renderFrame = null;
      render();
    });
  }

  function angleFromTextCenter(clientX, clientY) {
    const rect = textBox.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    return Math.atan2(clientY - centerY, clientX - centerX) * 180 / Math.PI;
  }

  function isOutsideArea(rect, area) {
    var T = 1.5; // piksel yuvarlama toleransı
    return rect.left < area.left - T || rect.right > area.right + T ||
           rect.top  < area.top  - T || rect.bottom > area.bottom + T;
  }

  // Safe area gizliyken (idle durum) DOM rect'i (0,0,0,0) döner ve her şey
  // "alan dışında" sanılır. Bu yüzden alanı şapka görselinden hesapla.
  function safeAreaClientRect() {
    // DİKKAT: .safe-area CSS transition'lı (all .25s) — görünüm değişiminin hemen
    // ardından rect ARA/ESKİ değeri döndürür (fit/checkBounds yanlış alan görür).
    // Bu yüzden alan her zaman yüzdelerden hesaplanır; zoom mainHat rect'ine zaten yansır.
    var st = mainHat.getBoundingClientRect();
    if (!st.width || !st.height) {
      var r = safeArea.getBoundingClientRect();
      if (r.width && r.height) return r;
    }
    var a = currentSafeArea || DEFAULT_SAFE_AREA;
    return {
      left:   st.left + st.width  * a.left / 100,
      top:    st.top  + st.height * a.top  / 100,
      right:  st.left + st.width  * (a.left + a.width)  / 100,
      bottom: st.top  + st.height * (a.top  + a.height) / 100,
      width:  st.width  * a.width  / 100,
      height: st.height * a.height / 100
    };
  }

  function checkBounds() {
    if (!addToCartBtn || !safeArea || !warning) return;
    var hasActive = !textBox.classList.contains("is-hidden");
    if (!hasActive && committedDesigns.length === 0) {
      addToCartBtn.disabled = true;
      warning.classList.add("is-hidden");
      warning.textContent = warningDefaultText;
      safeArea.classList.remove("error");
      return;
    }

    const area = safeAreaClientRect();
    var anyOutside = false;
    var fontInvalid = false;
    // UV/patch: taşan kısımlar maske ile gizleniyor; uyarı ve kilit gereksiz
    if (isUv()) {
      textBox.classList.remove("outside");
      committedDesigns.forEach(function (d) { d.el.classList.remove("outside"); });
      if (activeDesignType === "text" && isPngFont(selectedFont) && !pngFontSupports(selectedFont, currentText)) {
        warning.textContent = "Seçili font bu yazıdaki bazı karakterleri desteklemiyor";
        warning.classList.remove("is-hidden");
        safeArea.classList.add("error");
        addToCartBtn.disabled = true;
        return;
      }
      warning.classList.add("is-hidden");
      warning.textContent = warningDefaultText;
      safeArea.classList.remove("error");
      addToCartBtn.disabled = false;
      return;
    }

    if (hasActive) {
      fontInvalid = activeDesignType === "text" && isPngFont(selectedFont) && !pngFontSupports(selectedFont, currentText);
      var outside = isOutsideArea(textBox.getBoundingClientRect(), area);
      textBox.classList.toggle("outside", outside);
      if (outside) anyOutside = true;
    }

    committedDesigns.forEach(function (d) {
      // Yalnız aktif görünümdeki ve GÖRÜNÜR tasarımlar denetlenir; gizli
      // elemanların rect'i (0,0,0,0) döndüğü için yanlış alarm verir.
      if ((d.details.view || "front") !== currentView || d.el.style.display === "none") {
        d.el.classList.remove("outside");
        return;
      }
      var out = isOutsideArea(d.el.getBoundingClientRect(), area);
      d.el.classList.toggle("outside", out);
      if (out) anyOutside = true;
    });

    if (anyOutside || fontInvalid) {
      warning.textContent = fontInvalid
        ? "Seçili font bu yazıdaki bazı karakterleri desteklemiyor"
        : warningDefaultText;
      warning.classList.remove("is-hidden");
      safeArea.classList.add("error");
      addToCartBtn.disabled = true;
    } else {
      warning.classList.add("is-hidden");
      warning.textContent = warningDefaultText;
      safeArea.classList.remove("error");
      addToCartBtn.disabled = false;
    }
  }

  function setIdle() {
    if (textBox.classList.contains("is-hidden")) return;
    textBox.classList.add("idle");
    textBox.classList.remove("active");
    safeArea.classList.add("hidden");
    positionActionButtons();
  }

  function setActive() {
    applyLayerOrder();
    textBox.classList.remove("idle");
    textBox.classList.add("active");
    safeArea.classList.remove("hidden");
    positionActionButtons();
    requestAnimationFrame(positionActionButtons); // yerleşim oturunca ikinci geçiş
  }

  // Yazı paneli sekmeleri (mobil): Yazı / Font / Renk / Boyut
  var drawerConfirm = document.getElementById("drawerConfirm");
  function setTpTab(name) {
    if (name === "font" && typeof initFontPreviews === "function") initFontPreviews();
    document.querySelectorAll(".tp-tab").forEach(function (b) {
      b.classList.toggle("active", b.dataset.tp === name);
    });
    document.querySelectorAll("#textPanel .tp-group").forEach(function (g) {
      g.classList.toggle("tp-active", g.dataset.tp === name);
    });
  }
  document.querySelectorAll(".tp-tab").forEach(function (b) {
    b.addEventListener("click", function () { setTpTab(b.dataset.tp); });
  });
  // Mobil: çekmeceyi tutamaçtan aşağı çekerek (veya tutamaca dokunarak) kapat
  (function () {
    var grab = document.getElementById("drawerGrab");
    if (!grab || !mobileDrawer) return;
    var dragging = false, startY = 0, delta = 0;
    grab.addEventListener("pointerdown", function (e) {
      dragging = true;
      startY = e.clientY;
      delta = 0;
      mobileDrawer.style.transition = "none";
      try { grab.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    grab.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      delta = Math.max(0, e.clientY - startY);
      mobileDrawer.style.transform = "translateY(" + delta + "px)";
    });
    function endGrab() {
      if (!dragging) return;
      dragging = false;
      mobileDrawer.style.transition = "";
      mobileDrawer.style.transform = "";
      // Yeterince çekildiyse ya da kısa dokunuşsa kapat
      if (delta > 60 || delta < 6) mobileDrawer.classList.remove("open");
    }
    grab.addEventListener("pointerup", endGrab);
    grab.addEventListener("pointercancel", endGrab);
  })();

  if (drawerConfirm) {
    drawerConfirm.addEventListener("click", function () {
      if (textPanel.classList.contains("active")) {
        if (applyText) applyText.click(); // boş yazıda uyarı verir, çekmece açık kalır
        return;
      }
      if (logoPanel.classList.contains("active")) {
        var applyLogoBtn = document.getElementById("applyLogo");
        if (applyLogoBtn) { applyLogoBtn.click(); return; }
      }
      mobileDrawer.classList.remove("open"); // desen panelinde ✓ = kapat (desen tıklamayla uygulanır)
    });
  }

  function openPanel(panel) {
    mobileDrawer.classList.add("open");
    [textPanel, logoPanel, patternPanel].forEach(function (p) {
      p.classList.remove("active");
    });
    panel.classList.add("active");
    if (panel === textPanel) setTpTab("text");
    // ✓ onay yalnız araç panellerinde (teknik/menü ekranlarında değil)
    if (drawerConfirm) drawerConfirm.classList.add("show");
  }

  function isDesktopCustomizer() {
    return window.matchMedia && window.matchMedia("(min-width: 1200px)").matches;
  }

  function syncResponsiveControls() {
    if (isDesktopCustomizer()) {
      mobileBar.classList.remove("is-hidden");
      mobileDrawer.classList.add("open");
      var techActive = (techniquePanel && techniquePanel.classList.contains("active")) ||
                       (toolsMenuPanel && toolsMenuPanel.classList.contains("active"));
      if (techActive) {
        return;
      }
      if (!textPanel.classList.contains("active") &&
          !logoPanel.classList.contains("active") &&
          !patternPanel.classList.contains("active")) {
        openText.classList.add("active");
        textPanel.classList.add("active");
      }
      return;
    }

    // Mobil: yalnız teknik henüz seçilmemişken gizle; seçildiyse araç çubuğu kalıcı
    if (!techniqueChosen && textBox.classList.contains("is-hidden")) {
      mobileBar.classList.add("is-hidden");
      mobileDrawer.classList.remove("open");
    }
  }

  /* ── Teknik seçim girişi (sağ panel içinde) ──────────────── */

  const techniquePanel = document.getElementById("techniquePanel");
  const toolsMenuPanel = document.getElementById("toolsMenuPanel");
  const changeTechniqueBtn = document.getElementById("changeTechniqueBtn");

  function showToolsMenu() {
    mobileDrawer.classList.add("open");
    [textPanel, logoPanel, patternPanel, techniquePanel, toolsMenuPanel].forEach(function (p) {
      if (p) p.classList.remove("active");
    });
    if (toolsMenuPanel) toolsMenuPanel.classList.add("active");
    barButtons.forEach(function (b) { b.classList.remove("active"); });
    closeDrawer.classList.remove("is-hidden");
    if (drawerConfirm) drawerConfirm.classList.remove("show");
  }

  function techniqueOf(el) {
    if (el.dataset.technique) return el.dataset.technique;
    // Metafield yoksa ürün handle'ından çıkarım: "patch" geçenler UV
    var h = (el.dataset.model || "").toLowerCase();
    if (h.indexOf("patch") !== -1) return "uv";
    return "nakis";
  }

  function showTechniquePanel() {
    mobileDrawer.classList.add("open");
    [textPanel, logoPanel, patternPanel, techniquePanel, toolsMenuPanel].forEach(function (p) {
      if (p) p.classList.remove("active");
    });
    if (techniquePanel) techniquePanel.classList.add("active");
    barButtons.forEach(function (b) { b.classList.remove("active"); });
    mobileBar.classList.add("is-hidden"); // seçim yapılana dek sekmeler gizli
    closeDrawer.classList.add("is-hidden"); // teknik listesinden geri yok
    if (drawerConfirm) drawerConfirm.classList.remove("show");
  }

  function applyTechniqueFilters(t) {
    // Modelleri tekniğe göre filtrele (uyan yoksa hepsi kalır — geçiş dönemi)
    // 3D için uygun modeller = nakış modelleri (patch/uv modelleri 3D alamaz)
    var modelBtns = [...document.querySelectorAll(".model-option")];
    if (modelBtns.length) {
      var modelTech = t === "uv" ? "uv" : "nakis";
      // Sadece-sağ modeller (New Era) yalnız klasik nakışta listelenir (3D ön yüz ister)
      var matching = modelBtns.filter(function (b) {
        if (b.dataset.onlySide && t !== "nakis") return false;
        return techniqueOf(b) === modelTech;
      });
      if (matching.length) {
        modelBtns.forEach(function (b) {
          var hide = techniqueOf(b) !== modelTech || (b.dataset.onlySide && t !== "nakis");
          b.classList.toggle("is-hidden", !!hide);
        });
        if (!matching.some(function (b) { return b.classList.contains("active"); })) {
          selectModel(matching[0].dataset.model);
          modelBtns.forEach(function (b) { b.classList.toggle("active", b === matching[0]); });
        }
      } else {
        modelBtns.forEach(function (b) { b.classList.remove("is-hidden"); });
      }
    }
    var notice = document.getElementById("techniqueNotice");
    if (notice) {
      var anyUv = [...document.querySelectorAll(".model-option, .hat-option")]
        .some(function (b) { return techniqueOf(b) === "uv"; });
      notice.classList.toggle("is-hidden", !(t === "uv" && !anyUv));
    }
    // Fontları BAĞLAMA göre filtrele (teknik + görünüm):
    // 3D yalnız ön yüze uygulanır; 3D seçiliyken yan görünümler klasik nakıştır
    var eff = effectiveTechnique(currentView);
    var firstVisible = null;
    var currentVisible = false;
    document.querySelectorAll(".font-list button").forEach(function (b) {
      var ft = b.dataset.tech;
      var show = ft ? ft === eff : eff !== "uv" && eff !== "3d";
      b.classList.toggle("is-hidden", !show);
      if (show && !firstVisible) firstVisible = b;
      if (show && b.dataset.font === selectedFont) currentVisible = true;
    });
    if (!currentVisible && firstVisible) {
      selectedFont = firstVisible.dataset.font;
      fontToggle.textContent = FONT_LABELS[selectedFont] || firstVisible.textContent;
      ensureEffectFontLoaded(selectedFont);
      if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
        scheduleEmbroideryUpdate();
      }
    }
    // 3D bağlamında (ön yüz) yalnız yazı: desen ve medya/yükleme gizli;
    // yan görünümlerde (klasik nakış) geri gelir
    var only3dText = eff === "3d";
    document.querySelectorAll('.tools-menu-card[data-panel="pattern"], .tools-menu-card[data-panel="logo"]')
      .forEach(function (b) { b.classList.toggle("is-hidden", only3dText); });
    if (openLogo) openLogo.classList.toggle("is-hidden", only3dText);
    var openPatternBtn = document.getElementById("openPatternPanel");
    if (openPatternBtn) openPatternBtn.classList.toggle("is-hidden", only3dText);
    // 3D seçiliyken yan görünümde bilgi bandı: bu yüz klasik nakışla işlenir
    var sideNotice = document.getElementById("sideNakisNotice");
    if (sideNotice) {
      sideNotice.classList.toggle("is-hidden", !(currentTechnique === "3d" && currentView !== "front"));
    }
    // 3D bağlamında minimum yazı boyutu 3 cm: kaydırıcı tabanı + aktif tasarımı yükselt
    if (sizeInput) sizeInput.min = String(eff === "3d" ? minTextSizePx() : 20);
    if (eff === "3d" && activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
      var minPx3d = minTextSizePx();
      if (currentSize < minPx3d) {
        currentSize = minPx3d;
        if (sizeInput) sizeInput.value = String(Math.round(currentSize));
        updateEmbroidery();
      }
    }
    updatePriceDisplay();
  }

  let techniqueChosen = false;
  let chosenTechnique = "";

  function chooseTechnique(t) {
    techniqueChosen = true;
    chosenTechnique = t;
    currentTechnique = t;
    applyTechniqueUi();
    if (isDesktopCustomizer()) {
      showToolsMenu();
    } else {
      // Mobil: önce tasarım türü menüsü (Yazı/Desenler/Medya) — doğrudan
      // yazı paneline atlanmasın (kullanıcı geri basmadan seçenekleri görsün)
      mobileBar.classList.remove("is-hidden");
      showToolsMenu();
    }

    applyTechniqueFilters(t);
  }

  // Sahnede tasarım var mı? (sabitlenmiş ya da aktif)
  function hasAnyDesign() {
    return committedDesigns.length > 0 || !textBox.classList.contains("is-hidden");
  }

  // Teknik değişiminde tüm tasarımları temizle (teknikler karışmasın)
  function clearAllDesigns() {
    committedDesigns.forEach(function (d) {
      if (d.el && d.el.parentNode) d.el.parentNode.removeChild(d.el);
    });
    committedDesigns = [];
    textBox.classList.add("is-hidden");
    textBox.classList.remove("active", "idle", "outside");
    x = 0; y = 0; rotation = 0; scale = 1;
    if (textInput) textInput.value = "";
    updateAddButton();
    checkBounds();
  }

  // Onay kutusu: farklı tekniğe geçerken mevcut tasarımlar kaybolacak
  var techConfirmEl = document.getElementById("techConfirm");
  var techConfirmYes = null;
  function askTechniqueConfirm(onYes) {
    if (!techConfirmEl) { onYes(); return; }
    techConfirmYes = onYes;
    techConfirmEl.classList.remove("is-hidden");
  }
  if (techConfirmEl) {
    techConfirmEl.querySelectorAll("[data-tech-cancel]").forEach(function (el) {
      el.addEventListener("click", function () {
        techConfirmYes = null;
        techConfirmEl.classList.add("is-hidden");
      });
    });
    var techOkBtn = document.getElementById("techConfirmOk");
    if (techOkBtn) techOkBtn.addEventListener("click", function () {
      techConfirmEl.classList.add("is-hidden");
      var fn = techConfirmYes;
      techConfirmYes = null;
      if (fn) fn();
    });
  }

  if (techniquePanel) {
    techniquePanel.querySelectorAll(".technique-card").forEach(function (card) {
      card.addEventListener("click", function () {
        var t = card.dataset.technique;
        if (techniqueChosen && t !== currentTechnique && hasAnyDesign()) {
          askTechniqueConfirm(function () {
            clearAllDesigns();
            chooseTechnique(t);
          });
          return;
        }
        chooseTechnique(t);
      });
    });
  }
  if (changeTechniqueBtn) {
    changeTechniqueBtn.addEventListener("click", showTechniquePanel);
  }
  if (toolsMenuPanel) {
    toolsMenuPanel.querySelectorAll(".tools-menu-card").forEach(function (card) {
      card.addEventListener("click", function () {
        var p = card.dataset.panel === "logo" ? logoPanel
              : card.dataset.panel === "pattern" ? patternPanel
              : textPanel;
        [techniquePanel, toolsMenuPanel].forEach(function (pp) { if (pp) pp.classList.remove("active"); });
        openPanel(p);
        closeDrawer.classList.remove("is-hidden");
      });
    });
  }

  /* ── İlk render ─────────────────────────────────────────── */

  PNG_FONTS.forEach(preloadPngFont);
  ensureEffectFontLoaded(selectedFont);
  applySafeAreaForVariant();
  refreshViewSwitcher();
  autoSafeArea();
  updateEmbroidery();
  syncResponsiveControls();
  refreshKonturRow();
  applyTechniqueUi();
  // Başlangıç fiyatı: aktif (yoksa ilk) şapka seçeneğinden
  (function () {
    var activeHat = document.querySelector(".hat-option.active") ||
                    document.querySelector(".hat-option:not(.is-hidden)") ||
                    document.querySelector(".hat-option");
    if (activeHat && activeHat.dataset.price != null) {
      selectedVariantPrice = Number(activeHat.dataset.price || 0);
    }
    updatePriceDisplay();
  })();
  // Toplu alım indirimi tablosu (modal)
  (function () {
    var bulkLink = document.getElementById("bulkLink");
    var bulkModal = document.getElementById("bulkModal");
    if (!bulkLink || !bulkModal) return;
    function openBulk() { bulkModal.classList.remove("is-hidden"); }
    function closeBulk() { bulkModal.classList.add("is-hidden"); }
    bulkLink.addEventListener("click", openBulk);
    bulkModal.querySelectorAll("[data-bulk-close]").forEach(function (el) {
      el.addEventListener("click", closeBulk);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeBulk();
    });
  })();
  // Adet seçici
  (function () {
    if (!qtyInput) return;
    function setQty(q) {
      q = Math.floor(q);
      if (!(q > 0)) q = 1;
      qtyInput.value = String(q);
      updatePriceDisplay();
    }
    if (qtyMinus) qtyMinus.addEventListener("click", function () { setQty(currentQty() - 1); });
    if (qtyPlus)  qtyPlus.addEventListener("click", function () { setQty(currentQty() + 1); });
    qtyInput.addEventListener("input", function () { updatePriceDisplay(); });
    qtyInput.addEventListener("change", function () { setQty(currentQty()); });
  })();
  // Tutamaç butonlarını sahne katmanına taşı (maske ve tasarımların üstünde)
  (function () {
    var host = document.getElementById("stageZoom");
    [deleteText, rotateText, resizeText].forEach(function (b) {
      host.appendChild(b);
      b.classList.add("floating-action");
    });
  })();
  window.addEventListener("resize", positionActionButtons);

  // setTimeout(0) şart: applyTechniqueFilters, dosyanın ilerisinde tanımlanan
  // selectModel/modelList'e dokunabiliyor (TDZ çökmesi yaşandı)
  setTimeout(function () { applyTechniqueFilters(currentTechnique); }, 0);
  // Masaüstünde giriş ekranı otomatik; mobilde "Tasarım ekle"ye basınca açılır
  if (!urlTeknik && techniquePanel && isDesktopCustomizer()) showTechniquePanel();
  window.addEventListener("resize", syncResponsiveControls);

  /* ── Renk butonları ─────────────────────────────────────── */

  var konturRow = document.getElementById("konturColorRow");
  var konturButtons = document.querySelectorAll("#konturPalette button");
  function isTwoToneFont(font) {
    var p = PNG_FONT_PROFILES[font];
    return !!(p && p.twoTone);
  }
  function refreshKonturRow() {
    if (konturRow) konturRow.classList.toggle("is-hidden", !isTwoToneFont(selectedFont));
  }
  konturButtons.forEach(function (btn) {
    btn.style.setProperty("--swatch-color", btn.dataset.kcolor);
    btn.addEventListener("click", function () {
      konturButtons.forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      selectedKonturColor = btn.dataset.kcolor;
      if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
        updateEmbroidery();
      }
    });
  });

  colorButtons.forEach(function (btn) {
    btn.style.setProperty("--swatch-color", btn.dataset.color);
    btn.addEventListener("click", function () {
      colorButtons.forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      selectedColor = btn.dataset.color;
      // Aktif yazı tasarımı varsa rengi anında uygula
      if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
        updateEmbroidery();
      }
    });
  });

  renderLogoColorTools();

  if (logoColorMinus) {
    logoColorMinus.addEventListener("click", function () {
      logoMaxColors = Math.max(1, logoMaxColors - 1);
      renderLogoColorTools();
      if (logoImage) renderLogoCanvas();
    });
  }

  if (logoColorPlus) {
    logoColorPlus.addEventListener("click", function () {
      logoMaxColors = Math.min(15, logoMaxColors + 1);
      renderLogoColorTools();
      if (logoImage) renderLogoCanvas();
    });
  }

  /* ── Tasarım Ekle ───────────────────────────────────────── */

  addBtn.addEventListener("click", function () {
    ensureDesignableView(); // New Era: tasarım sağ yanda başlar
    freezeCurrentDesign(); // aktif tasarım varsa sahneye sabitle, yeni slot aç

    // Yeni tasarım için girişleri sıfırla
    currentText = "BRAVER";
    currentSize = 46;
    currentTracking = 0;
    activeDesignType = "text";
    if (textInput) textInput.value = "";
    if (sizeInput) sizeInput.value = "46";
    if (trackingInput) trackingInput.value = "0";
    setFontWarning("");
    if (logoFileName) logoFileName.textContent = "PNG, JPG, WebP veya SVG";

    updateAddButton();
    if (isDesktopCustomizer()) {
      showToolsMenu();
    } else if (!techniqueChosen && techniquePanel) {
      showTechniquePanel();
    } else {
      mobileBar.classList.remove("is-hidden");
    }
    safeArea.classList.remove("hidden");
  });

  barButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      barButtons.forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
    });
  });

  openText.addEventListener("click",    function () { openPanel(textPanel);    });
  openLogo.addEventListener("click",    function () { openPanel(logoPanel);    });
  openPattern.addEventListener("click", function () { openPanel(patternPanel); });

  closeDrawer.addEventListener("click", function () {
    if (isDesktopCustomizer()) {
      // Geri zinciri: araç paneli → "Tasarım ekle" → "Teknik seç"
      if (toolsMenuPanel && toolsMenuPanel.classList.contains("active")) {
        showTechniquePanel();
      } else {
        showToolsMenu();
      }
      return;
    }
    mobileDrawer.classList.remove("open");
  });

  /* ── Font seçici ─────────────────────────────────────────── */

  // Her font seçeneği kendi yazı tipinde görünsün. Nakış/3D fontları (PNG
  // glif motoru olanlar) şapkadakiyle birebir aynı görünsün diye canvas'a
  // çizilir; UV fontlar şapkada da aynı CSS fontuyla çizildiği için
  // font-family yeterli.
  var fontPreviewsReady = false;

  function buildFontPreviewCanvas(btn, prefix, label) {
    var fontSize = 22;
    var pad = 3;
    var tries = 0;
    function attempt() {
      var text = pngFontSupports(prefix, label) ? label
        : (pngFontSupports(prefix, label.toUpperCase()) ? label.toUpperCase() : "ABC");
      var m = measurePngText(prefix, text, fontSize); // glif yüklemesini de tetikler
      if (!m) {
        if (++tries < 60) setTimeout(attempt, 250);
        return;
      }
      var dpr = Math.min(window.devicePixelRatio || 1, 2) * TEXT_SS;
      var w = Math.ceil(m.width + pad * 2);
      var h = Math.ceil(m.ascent + m.descent + pad * 2);
      var canvas = document.createElement("canvas");
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.className = "font-prev";
      canvas.style.height = "22px";
      canvas.style.width = Math.round(22 * w / h) + "px";
      renderPngText(prefix, canvas, text, "#222222", fontSize, pad);
      btn.textContent = "";
      btn.appendChild(canvas);
    }
    attempt();
  }

  function initFontPreviews() {
    if (fontPreviewsReady) return;
    fontPreviewsReady = true;
    document.querySelectorAll(".font-list button").forEach(function (btn) {
      var key = btn.dataset.font;
      var label = FONT_LABELS[key] || btn.textContent.trim();
      btn.title = label;
      if (isPngFont(key)) {
        buildFontPreviewCanvas(btn, key, label);
        return;
      }
      var spec = EFFECT_FONTS[key];
      if (!spec) return;
      btn.style.fontFamily = spec.family;
      btn.style.fontWeight = spec.weight || "400";
      btn.style.fontStyle = spec.style || "normal";
      btn.classList.add("has-preview");
    });
  }

  fontToggle.addEventListener("click", function () {
    initFontPreviews();
    fontList.classList.toggle("open");
  });

  document.querySelectorAll(".font-list button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      selectedFont = btn.dataset.font;
      fontToggle.textContent = FONT_LABELS[selectedFont] || btn.textContent;
      fontList.classList.remove("open");
      preloadPngFont(selectedFont);
      ensureEffectFontLoaded(selectedFont);
      refreshKonturRow();
      var normalized = normalizeTextInputForSelectedFont();
      if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) currentText = normalized || "BRAVER";
      updateFontWarning(normalized || currentText);
      if (activeDesignType === "text") scheduleEmbroideryUpdate();
    });
  });

  if (textInput) {
    // Canlı önizleme: yazarken şapkaya anında yansır (Uygula beklemez)
    textInput.addEventListener("input", function () {
      var nextText = normalizeTextInputForSelectedFont();
      updateFontWarning(nextText);

      // Yazı silinip boşaldıysa aktif yazı kutusunu kaldır
      if (!nextText || !nextText.trim()) {
        if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
          textBox.classList.add("is-hidden");
          textBox.classList.remove("active", "idle", "outside");
          updateAddButton();
          checkBounds();
        }
        return;
      }

      if (textBox.classList.contains("is-hidden") || activeDesignType !== "text") {
        // İlk harf: kutuyu sahneye çıkar (applyText ile aynı kurulum)
        ensureDesignableView(); // New Era: yazı sağ yanda oluşur
        prepareDesignSlot("text");
        activeDesignType = "text";
        currentSize = Math.max(minTextSizePx(), Number(sizeInput.value || 46));
        if (sizeInput && Number(sizeInput.value) < currentSize) sizeInput.value = String(Math.round(currentSize));
        if (trackingInput) currentTracking = Number(trackingInput.value || 0) / 100;
        scale = 1;
        currentText = nextText;
        updateEmbroidery();
        textBox.classList.remove("is-hidden");
        setActive();
        fitTextToSafeArea();
        showAddAnotherButton();
        checkBounds();
      } else {
        currentText = nextText;
        updateEmbroidery();
        fitDesignToSafeArea();
        checkBounds();
      }
    });
  }

  if (trackingInput) {
    trackingInput.addEventListener("input", function () {
      currentTracking = Number(trackingInput.value || 0) / 100;
      if (activeDesignType === "text" && !textBox.classList.contains("is-hidden")) {
        updateEmbroidery();
      }
    });
  }

  if (sizeInput) {
    sizeInput.addEventListener("input", function () {
      if (activeDesignType !== "text" || textBox.classList.contains("is-hidden")) return;
      currentSize = Math.max(minTextSizePx(), Number(sizeInput.value || 46));
      if (Number(sizeInput.value) < currentSize) sizeInput.value = String(Math.round(currentSize));
      updateEmbroidery();
    });
  }

  /* ── Uygula ─────────────────────────────────────────────── */

  applyText.addEventListener("click", function () {
    const nextText = normalizeTextInputForSelectedFont();
    if (!nextText || !nextText.trim()) {
      setFontWarning("Önce bir yazı yaz.");
      if (textInput) textInput.focus();
      return;
    }
    if (!updateFontWarning(nextText)) return;
    ensureDesignableView(); // New Era: tasarım sağ yanda
    prepareDesignSlot("text");
    activeDesignType = "text";
    currentText = nextText;
    currentSize = Math.max(minTextSizePx(), Number(sizeInput.value || 46));
    if (sizeInput && Number(sizeInput.value) < currentSize) sizeInput.value = String(Math.round(currentSize));
    if (trackingInput) currentTracking = Number(trackingInput.value || 0) / 100;
    scale = 1;
    updateEmbroidery();

    textBox.classList.remove("is-hidden");
    setActive();
    fitTextToSafeArea();
    mobileDrawer.classList.remove("open");

    showAddAnotherButton();
    checkBounds();
    // Yerleşim oturduktan sonra ikinci sığdırma geçişi: ilk geçişte canvas
    // ölçüsü asenkron kaldığında (ör. 3D önden yana geçişte büyük boyut) yakınsasın
    setTimeout(function () { fitDesignToSafeArea(); checkBounds(); }, 120);
  });

  if (logoInput) {
    logoInput.addEventListener("change", function () {
      const file = logoInput.files && logoInput.files[0];
      if (!file) return;
      // iPhone HEIC/HEIF fotoğrafları tarayıcıda AÇILAMAZ (tip image/* geçse bile
      // decode edilemez) — en sık 'okunamadı' sebebi; net yönlendirme ver
      var adUzanti = (file.name.match(/\.([a-z0-9]+)$/i) || [])[1] || "";
      if (/heic|heif/i.test(file.type) || /^(heic|heif)$/i.test(adUzanti)) {
        setLogoWarning("iPhone fotoğrafı (HEIC) tarayıcıda desteklenmiyor. Fotoğraflar uygulamasından seçersen otomatik çevrilir; ya da görseli JPEG/PNG olarak kaydedip yükle.");
        logoInput.value = "";
        return;
      }
      if (!/^image\//.test(file.type)) {
        if (file.type === "application/pdf" || /\.pdf$/i.test(file.name)) {
          setLogoWarning("PDF dosyaları desteklenmiyor. Logonu PNG, JPG, WebP ya da SVG olarak kaydedip yükle.");
        } else {
          setLogoWarning("Lütfen PNG, JPG, WebP veya SVG formatında bir görsel seç." + (file.type || adUzanti ? " (seçilen: " + (file.type || "." + adUzanti) + ")" : ""));
        }
        logoInput.value = "";
        return;
      }
      // İçerik kontrolü: uzantı .png olsa da içerik HEIC/AVIF olabilir (yeniden
      // adlandırılmış dosya — işletim sistemi tipi UZANTIDAN yazar). Sihirli
      // baytlara bakıp gerçek biçimi söyleriz; tarayıcının açabildiklerinde devam.
      function yukleDevam(gercekTip) {
        if (gercekTip === "heic" || gercekTip === "avif" || gercekTip === "tiff") {
          setLogoWarning("Bu dosyanın adı ." + (adUzanti || "png") + " ama içeriği " + gercekTip.toUpperCase() +
            " — tarayıcılar bu biçimi açamaz. Görseli bir görüntüleyicide açıp gerçek JPEG/PNG olarak yeniden kaydet (yalnız adını değiştirmek yetmez).");
          logoInput.value = "";
          return;
        }
        if (logoObjectUrl) URL.revokeObjectURL(logoObjectUrl);
        logoObjectUrl = URL.createObjectURL(file);
        logoSourceFile = file;
        resetBgRemoval();
        const img = new Image();
        img.onload = function () {
          logoImage = img;
          logoName = file.name;
          logoSource = "upload";
          logoColorMap = {};
          logoDetectedColors = [];
          logoSelectedSourceColor = "";
          if (logoFileName) logoFileName.textContent = file.name;
          setLogoWarning("");
          renderLogoColorTools();
          updateLogoPreview();
        };
        img.onerror = function () {
          // hangi tip okunamadı — müşteri desteğinde teşhis için mesaja yaz
          var tespit = gercekTip ? "içerik: " + gercekTip : (file.type || "." + adUzanti || "bilinmeyen tip");
          setLogoWarning("Bu logo dosyası okunamadı (" + tespit + "). Dosya bozuk olabilir — görseli açıp JPEG/PNG olarak yeniden kaydedip tekrar dene.");
          logoInput.value = "";
        };
        img.src = logoObjectUrl;
      }

      try {
        file.slice(0, 32).arrayBuffer().then(function (buf) {
          var b = new Uint8Array(buf);
          function str(off, len) { var s = ""; for (var i = off; i < off + len && i < b.length; i++) s += String.fromCharCode(b[i]); return s; }
          var t = null;
          if (b[0] === 0x89 && str(1, 3) === "PNG") t = "png";
          else if (b[0] === 0xFF && b[1] === 0xD8) t = "jpeg";
          else if (str(0, 4) === "RIFF" && str(8, 4) === "WEBP") t = "webp";
          else if (str(0, 4) === "GIF8") t = "gif";
          else if (str(4, 4) === "ftyp") t = /avif/i.test(str(8, 4)) ? "avif" : "heic";
          else if ((b[0] === 0x49 && b[1] === 0x49) || (b[0] === 0x4D && b[1] === 0x4D)) t = "tiff";
          else if (/^\s*<|^\xEF\xBB\xBF/.test(str(0, 6))) t = "svg";
          yukleDevam(t);
        }, function () { yukleDevam(null); });
      } catch (e) { yukleDevam(null); }
    });
  }

  if (applyLogo) {
    applyLogo.addEventListener("click", function () {
      if (!logoImage) {
        setLogoWarning("Önce bir logo dosyası seç.");
        return;
      }
      ensureDesignableView(); // New Era: tasarım sağ yanda
      prepareDesignSlot("logo");
      activeDesignType = "logo";
      currentSize = Number(logoSizeInput && logoSizeInput.value || 120);
      scale = 1;
      setFontWarning("");
      setLogoWarning("");
      renderLogoCanvas();

      textBox.classList.remove("is-hidden");
      setActive();
      if (isUv()) {
        fillLogoToSafeArea(); // patch: görsel alanı otomatik doldursun
      } else {
        fitDesignToSafeArea();
      }
      mobileDrawer.classList.remove("open");

      showAddAnotherButton();
      checkBounds();
    });
  }

  /* ── UV: arka plan kaldırma ─────────────────────────────── */
  // Kenarlardan taşan (flood-fill) yöntem: kenar piksellerinin baskın rengine
  // yakın ve KENARDAN ulaşılabilir pikseller şeffaflanır — logonun içindeki
  // aynı renk alanlar korunur.
  let logoBgRemoved = false;
  let logoOriginalImage = null;
  const bgRemoveBtn = document.getElementById("bgRemoveBtn");

  // Panelde yüklenen görselin küçük önizlemesi (damalı zemin: şeffaflık görünür)
  function updateLogoPreview() {
    var wrap = document.getElementById("logoPreview");
    var img = document.getElementById("logoPreviewImg");
    if (!wrap || !img) return;
    if (logoImage && logoImage.src) {
      img.src = logoImage.src;
      wrap.classList.remove("is-hidden");
    } else {
      img.removeAttribute("src");
      wrap.classList.add("is-hidden");
    }
  }

  function resetBgRemoval() {
    logoBgRemoved = false;
    logoOriginalImage = null;
    if (bgRemoveBtn) {
      bgRemoveBtn.classList.remove("is-on");
      bgRemoveBtn.textContent = "✂ Arka planı kaldır";
      bgRemoveBtn.disabled = false;
    }
  }

  function removeImageBackground(img) {
    var MAXP = 2000;
    var W = img.naturalWidth, H = img.naturalHeight;
    var k = Math.min(1, MAXP / Math.max(W, H));
    W = Math.max(1, Math.round(W * k));
    H = Math.max(1, Math.round(H * k));
    var c = document.createElement("canvas");
    c.width = W; c.height = H;
    var ctx = c.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, 0, 0, W, H);
    var im = ctx.getImageData(0, 0, W, H);
    var d = im.data;

    // Kenar piksellerinin ortalaması = arka plan rengi
    var sr = 0, sg = 0, sb = 0, n = 0;
    var edgeIdx = [];
    function addEdge(x, y) {
      var i = (y * W + x) * 4;
      sr += d[i]; sg += d[i + 1]; sb += d[i + 2]; n++;
      edgeIdx.push(i);
    }
    for (var x = 0; x < W; x += 2) { addEdge(x, 0); addEdge(x, H - 1); }
    for (var y = 0; y < H; y += 2) { addEdge(0, y); addEdge(W - 1, y); }
    var br = sr / n, bg = sg / n, bb = sb / n;

    function dist(i) {
      return Math.max(Math.abs(d[i] - br), Math.abs(d[i + 1] - bg), Math.abs(d[i + 2] - bb));
    }

    // Zemin ne kadar dalgalıysa (JPEG gürültüsü, vinyet) tolerans o kadar geniş
    var dev = 0;
    for (var e = 0; e < edgeIdx.length; e++) dev += dist(edgeIdx[e]);
    dev = dev / Math.max(1, edgeIdx.length);
    var TOL = Math.min(90, Math.max(40, Math.round(dev * 2.5 + 24)));
    var SOFT = 28; // yumuşak geçiş bandı

    // Kenarlardan BFS — iki katılım yolu:
    // (a) ortalama zemine yakınlık, (b) geldiği komşuya yerel süreklilik
    // (kademeli koyulaşan/aydınlanan zeminleri zincirleme takip eder)
    var visited = new Uint8Array(W * H);
    var stack = new Int32Array(W * H);
    var sp = 0;
    function tryPush(p, fromI) {
      if (visited[p]) return;
      var i = p * 4;
      var ds = dist(i);
      var avgIle = ds <= TOL + SOFT;
      var yerel = false;
      if (!avgIle && fromI >= 0 && ds <= 140) {
        yerel = Math.max(
          Math.abs(d[i] - d[fromI]),
          Math.abs(d[i + 1] - d[fromI + 1]),
          Math.abs(d[i + 2] - d[fromI + 2])
        ) <= 16;
      }
      if (!avgIle && !yerel) return;
      visited[p] = 1;
      d[i + 3] = (avgIle && ds > TOL) ? Math.round(d[i + 3] * (ds - TOL) / SOFT) : 0;
      stack[sp++] = p;
    }
    for (x = 0; x < W; x++) { tryPush(x, -1); tryPush((H - 1) * W + x, -1); }
    for (y = 0; y < H; y++) { tryPush(y * W, -1); tryPush(y * W + W - 1, -1); }
    while (sp > 0) {
      var p = stack[--sp];
      var pi = p * 4;
      var px = p % W, py = (p / W) | 0;
      if (px > 0) tryPush(p - 1, pi);
      if (px < W - 1) tryPush(p + 1, pi);
      if (py > 0) tryPush(p - W, pi);
      if (py < H - 1) tryPush(p + W, pi);
    }
    ctx.putImageData(im, 0, 0);
    return c;
  }

  if (bgRemoveBtn) {
    bgRemoveBtn.addEventListener("click", function () {
      if (!logoImage || !logoImage.naturalWidth) {
        setLogoWarning("Önce bir görsel seç.");
        return;
      }
      if (logoBgRemoved) {
        // Geri al
        if (logoOriginalImage) logoImage = logoOriginalImage;
        logoBgRemoved = false;
        bgRemoveBtn.classList.remove("is-on");
        bgRemoveBtn.textContent = "✂ Arka planı kaldır";
        updateLogoPreview();
        if (activeDesignType === "logo" && !textBox.classList.contains("is-hidden")) renderLogoCanvas();
        return;
      }
      bgRemoveBtn.disabled = true;
      bgRemoveBtn.textContent = "İşleniyor...";
      setTimeout(function () {
        try {
          logoOriginalImage = logoImage;
          var processed = removeImageBackground(logoImage);
          var out = new Image();
          out.onload = function () {
            logoImage = out;
            logoBgRemoved = true;
            bgRemoveBtn.disabled = false;
            bgRemoveBtn.classList.add("is-on");
            bgRemoveBtn.textContent = "✓ Arka plan kaldırıldı — geri al";
            updateLogoPreview();
            if (activeDesignType === "logo" && !textBox.classList.contains("is-hidden")) renderLogoCanvas();
          };
          out.src = processed.toDataURL("image/png");
        } catch (e) {
          bgRemoveBtn.disabled = false;
          bgRemoveBtn.textContent = "✂ Arka planı kaldır";
          setLogoWarning("Arka plan kaldırılamadı, farklı bir görsel dene.");
        }
      }, 30);
    });
  }

  // UV patch: yüklenen görseli patch alanına tam sığdır (en boy korunarak,
  // ortalanmış) — müşteri boyutlamayla uğraşmasın. DOM rect yerine canvas
  // stil boyutundan hesaplanır (ilk render'da rect bayat olabiliyor).
  function fillLogoToSafeArea() {
    var effW = parseFloat(embCanvas.style.width) || embCanvas.width;
    var effH = parseFloat(embCanvas.style.height) || embCanvas.height;
    var area = safeAreaClientRect();
    var mhRect = mainHat.getBoundingClientRect();
    var z = (mainHat.offsetWidth ? mhRect.width / mainHat.offsetWidth : 1) || 1;
    var aw = area.width / z, ah = area.height / z;
    if (!effW || !effH || !aw || !ah) return;
    var k = Math.min(aw / effW, ah / effH) * 0.98; // kutu çerçevesi payı
    if (!isFinite(k) || k <= 0) return;
    currentSize = Math.max(20, Math.floor(currentSize * k));
    if (logoSizeInput) logoSizeInput.value = String(Math.round(currentSize));
    x = 0; y = 0; rotation = 0; // patch ortası
    renderLogoCanvas();
  }

  /* ── Hazır desenler ─────────────────────────────────────── */

  const patternWarning = document.getElementById("patternWarning");
  function setPatternWarning(msg) {
    if (!patternWarning) return;
    patternWarning.textContent = msg || "";
    patternWarning.classList.toggle("is-hidden", !msg);
  }

  document.querySelectorAll(".pattern-option").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var url = btn.dataset.src;
      if (!url || btn.classList.contains("is-loading")) return;
      setPatternWarning("");
      btn.classList.add("is-loading");

      var img = new Image();
      img.crossOrigin = "anonymous"; // CDN'den piksel okuyabilmek için CORS
      img.onload = function () {
        btn.classList.remove("is-loading");
        logoImage = img;
        logoName = (url.split("/").pop() || "desen").split("?")[0];
        logoSource = "pattern";
        logoSourceFile = null; // hazır desen: müşteri dosyası yok
        resetBgRemoval();
        updateLogoPreview();
        logoColorMap = {};
        logoDetectedColors = [];
        logoSelectedSourceColor = "";

        ensureDesignableView(); // New Era: tasarım sağ yanda
        prepareDesignSlot("logo");
        activeDesignType = "logo";
        currentSize = Number(logoSizeInput && logoSizeInput.value || 120);
        scale = 1;
        setFontWarning("");
        renderLogoCanvas();

        textBox.classList.remove("is-hidden");
        setActive();
        fitDesignToSafeArea();
        mobileDrawer.classList.remove("open");
        showAddAnotherButton();
        checkBounds();
      };
      img.onerror = function () {
        btn.classList.remove("is-loading");
        setPatternWarning("Desen yüklenemedi, tekrar dene.");
      };
      img.src = url;
    });
  });

  /* ── Sürükleme / Döndürme / Boyutlandırma ───────────────── */

  [textBox, embCanvas].forEach(function (element) {
    if (!element) return;
    element.addEventListener("contextmenu", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    element.addEventListener("dragstart", function (e) {
      e.preventDefault();
    });
  });

  textBox.addEventListener("pointerdown", function (e) {
    if (e.target.closest("button")) return;
    mode = "drag";
    startPointerX = e.clientX; startPointerY = e.clientY;
    startX = x; startY = y;
    setActive();
    e.preventDefault();
  });

  rotateText.addEventListener("pointerdown", function (e) {
    mode = "rotate";
    startPointerX = e.clientX;
    startAngle = angleFromTextCenter(e.clientX, e.clientY);
    startRotation = rotation;
    setActive();
    e.stopPropagation();
    e.preventDefault();
  });

  resizeText.addEventListener("pointerdown", function (e) {
    mode = "resize";
    startPointerX = e.clientX;
    startSize = currentSize;
    logoResizeBaseWidth = activeDesignType === "logo" ? (parseFloat(embCanvas.style.width) || embCanvas.offsetWidth || embCanvas.width) : 0;
    logoResizeBaseHeight = activeDesignType === "logo" ? (parseFloat(embCanvas.style.height) || embCanvas.offsetHeight || embCanvas.height) : 0;
    setActive();
    e.stopPropagation();
    e.preventDefault();
  });

  window.addEventListener("pointermove", function (e) {
    if (!mode) return;
    if (mode === "drag") {
      // zoom'dayken imleç hareketi sahne ölçeğine bölünür
      x = startX + (e.clientX - startPointerX) / zoomLevel;
      y = startY + (e.clientY - startPointerY) / zoomLevel;
    }
    if (mode === "rotate") {
      rotation = startRotation + angleFromTextCenter(e.clientX, e.clientY) - startAngle;
    }
    if (mode === "resize") {
      // logoda tavan slider'la aynı (808): 404 tavanı büyük ekranlarda safe area'dan
      // küçük kalıyordu — logolar alanı dolduramıyordu
      var sizeCap = activeDesignType === "logo" ? 808 : 404;
      currentSize = Math.max(activeDesignType === "text" ? minTextSizePx() : 20, Math.min(sizeCap, startSize + (e.clientX - startPointerX) * 0.6 / zoomLevel));
      if (activeDesignType === "logo" && logoSizeInput) {
        logoSizeInput.value = String(Math.round(Math.min(sizeCap, currentSize)));
      } else if (sizeInput) {
        sizeInput.value = String(Math.round(Math.min(sizeCap, currentSize)));
      }
      scale = 1;
      if (activeDesignType === "logo") {
        scheduleRender();
      } else {
        updateDesign();
      }
      return;
    }
    scheduleRender();
  });

  window.addEventListener("pointerup", function () {
    const wasLogoResize = mode === "resize" && activeDesignType === "logo";
    mode = null;
    logoResizeBaseWidth = 0;
    logoResizeBaseHeight = 0;
    if (wasLogoResize) renderLogoCanvas();
  });

  /* ── Silme ───────────────────────────────────────────────── */

  deleteText.addEventListener("click", function (e) {
    e.stopPropagation();
    textBox.classList.add("is-hidden");
    textBox.classList.remove("active", "idle", "outside");
    x = 0; y = 0; rotation = 0; scale = 1;
    activeDesignType = "text";
    render();
    updateAddButton();
    setTimeout(function () { addBtn.classList.remove("is-fading"); }, 20);
    checkBounds();
  });

  /* ── Dışa tıklama → idle ─────────────────────────────────── */

  document.addEventListener("click", function (e) {
    var hedef = e.target;
    var yuzenButon = hedef.closest && hedef.closest(".floating-action");
    if (!textBox.contains(hedef) &&
        !yuzenButon &&
        !mobileDrawer.contains(hedef) &&
        !mobileBar.contains(hedef)) {
      setIdle();
    }
  });

  textBox.addEventListener("click", function (e) {
    e.stopPropagation();
    setActive();
    mobileBar.classList.remove("is-hidden");
    barButtons.forEach(function (b) { b.classList.remove("active"); });
    if (activeDesignType === "logo") {
      openLogo.classList.add("active");
      if (logoSizeInput) logoSizeInput.value = String(Math.round(currentSize));
      openPanel(logoPanel);
    } else {
      openText.classList.add("active");
      textInput.value = currentText;
      openPanel(textPanel);
    }
  });

  /* ── Şapka Değiştir ─────────────────────────────────────── */

  changeHatBtn.addEventListener("click", function () {
    hatList.classList.toggle("active");
  });

  function applyTechniqueUi() {
    var tools = document.querySelector(".logo-color-tools");
    if (tools) tools.classList.toggle("is-hidden", isUv());
    var pcs = document.getElementById("patchColorSwitch");
    if (pcs) pcs.classList.toggle("is-hidden", !isUv());
    var bgb = document.getElementById("bgRemoveBtn");
    if (bgb) bgb.classList.toggle("is-hidden", !isUv());
  }

  // Koyu patch'te varsayılan yazı rengi beyaz, açıkta siyah (görünmez renk tuzağı)
  function applyPatchColorDefaults() {
    var darkPatch = patchColor === "siyah";
    var defColor = darkPatch ? "#ffffff" : "#000000";
    var invisible = darkPatch ? "#000000" : "#ffffff";
    var hasActiveText = activeDesignType === "text" && !textBox.classList.contains("is-hidden");
    if (!hasActiveText || selectedColor === invisible) {
      selectedColor = defColor;
      colorButtons.forEach(function (b) {
        b.classList.toggle("active", b.dataset.color === defColor);
      });
      if (hasActiveText) updateEmbroidery();
    }
  }

  function selectVariant(btn) {
    if (!urlTeknik) {
      // Ürün tekniği zorunluysa (patch→uv) ona uy; değilse kullanıcının SEÇTİĞİ teknik korunur
      // (renk/model tıklaması 3D seçimini sıfırlamasın)
      var prevTech = currentTechnique;
      var vt = techniqueOf(btn);
      currentTechnique = vt === "uv" ? "uv"
        : (chosenTechnique && chosenTechnique !== "uv" ? chosenTechnique : vt);
      if (currentTechnique !== prevTech) applyTechniqueFilters(currentTechnique);
    }
    applyTechniqueUi();
    var btnImg = btn.querySelector("img");
    selectedColorName = btnImg ? (btnImg.alt || "") : "";
    // UV patch: koyu patch'te varsayılan yazı rengi beyaz olsun (görünmez renk tuzağı)
    if (isUv()) applyPatchColorDefaults();
    if (btn.dataset.variantId && addToCartBtn) {
      selectedVariantId = btn.dataset.variantId;
      addToCartBtn.dataset.variantId = btn.dataset.variantId;
    }
    if (btn.dataset.price != null) selectedVariantPrice = Number(btn.dataset.price || 0);
    updatePriceDisplay();
    // Sadece-sağ model (New Era): tasarım görünümü doğrudan sağ yan
    if (btn.dataset.onlySide === "right" && viewImage("right")) currentView = "right";
    // Yeni şapkada mevcut görünüm yoksa öne dön
    if (currentView !== "front" && !viewImage(currentView)) currentView = "front";
    var img = viewImage(currentView);
    if (img) mainHat.src = img;
    applySafeAreaForVariant();
    refreshViewSwitcher();
    updateHatMask();
    setTimeout(autoSafeArea, 100);
  }

  document.querySelectorAll(".hat-option").forEach(function (btn) {
    btn.addEventListener("click", function () {
      selectVariant(btn);
      hatList.classList.remove("active");
    });
  });

  // Patch rengi (Beyaz/Siyah) — görsel tema assetinden, varyant değişmez
  document.querySelectorAll("#patchColorSwitch button[data-pcolor]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (patchColor === b.dataset.pcolor) return;
      patchColor = b.dataset.pcolor;
      document.querySelectorAll("#patchColorSwitch button[data-pcolor]").forEach(function (x) {
        x.classList.toggle("active", x === b);
      });
      var img = viewImage(currentView);
      if (img) mainHat.src = img;
      updateHatMask();
      applyPatchColorDefaults();
    });
  });

  // Şapka görsellerini arka planda önceden yükle: renk/yüz geçişleri anlık olsun
  var preloadedHatImgs = {};
  function preloadHatImages(modelHandle) {
    var urls = [];
    document.querySelectorAll(".hat-option").forEach(function (b) {
      if (modelHandle && b.dataset.model && b.dataset.model !== modelHandle) return;
      [b.dataset.image, b.dataset.sideLeft, b.dataset.sideRight].forEach(function (u) {
        if (u && !preloadedHatImgs[u]) urls.push(u);
      });
    });
    // Sırayla indir (hepsini aynı anda başlatıp bant genişliğini boğmamak için)
    var i = 0;
    (function next() {
      if (i >= urls.length) return;
      var u = urls[i++];
      var im = new Image();
      preloadedHatImgs[u] = im;
      im.onload = im.onerror = function () { setTimeout(next, 30); };
      im.src = u;
    })();
  }
  if ("requestIdleCallback" in window) {
    requestIdleCallback(function () { preloadHatImages(currentModel); }, { timeout: 3000 });
  } else {
    setTimeout(function () { preloadHatImages(currentModel); }, 1200);
  }

  /* ── Model seçici ────────────────────────────────────────── */

  const modelList = document.getElementById("modelList");
  let currentModel = (document.querySelector(".hat-option") || {}).dataset
    ? document.querySelector(".hat-option").dataset.model : "";

  function selectModel(handle) {
    currentModel = handle;
    // Model butonlarını işaretle
    if (modelList) {
      modelList.querySelectorAll(".model-option").forEach(function (b) {
        b.classList.toggle("active", b.dataset.model === handle);
      });
    }
    // Sadece bu modelin renklerini göster
    var firstOfModel = null;
    document.querySelectorAll(".hat-option").forEach(function (b) {
      var match = b.dataset.model === handle;
      b.classList.toggle("is-hidden", !match);
      if (match && !firstOfModel) firstOfModel = b;
    });
    if (firstOfModel) selectVariant(firstOfModel);
    checkBounds();
    preloadHatImages(handle);
  }

  if (modelList) {
    modelList.querySelectorAll(".model-option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.dataset.model === currentModel) return;
        selectModel(btn.dataset.model);
      });
    });
  }

  /* ── Cloudinary yükleme + Sipariş özeti PDF ───────────────── */

  function cloudConfigured() {
    var c = window.BRAVER_CLOUDINARY || {};
    return !!(c.cloud && c.preset);
  }

  // Üretim dosyası deposu: Cloudflare Worker (Cloudinary yeni hesaplarda
  // PDF/ZIP teslimini kısıtladığı için raw dosyalar worker KV'sinde durur)
  var BRAVER_DEPO = "https://braver-siparis-worker.yusufsenr.workers.dev/uretim-listesi-braver73";

  // Zaman aşımlı fetch (#15183): müşterinin ağı worker bağlantısını askıda
  // bırakınca fetch dakikalarca dönmüyordu → ZIP 55 sn sınırına yetişmiyordu.
  function zamanAsimliFetch(url, opts, ms) {
    if (typeof AbortController === "undefined") return fetch(url, opts);
    var ac = new AbortController();
    var t = setTimeout(function () { try { ac.abort(); } catch (e) {} }, ms || 25000);
    return fetch(url, Object.assign({}, opts || {}, { signal: ac.signal }))
      .then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }

  function cloudUpload(blob, resourceType, publicId) {
    if (!blob) return Promise.resolve(null);
    if (resourceType === "raw") {
      // publicId ör: "braver/ozet-123.pdf" → depo adı "ozet-123.pdf"
      var ad = String(publicId || "").split("/").pop();
      var tryOnce = function () {
        return zamanAsimliFetch(BRAVER_DEPO + "/yukle?ad=" + encodeURIComponent(ad), {
          method: "POST",
          body: blob
        }, 25000).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { return (d && d.url) || null; });
      };
      // geçici ağ hatalarına karşı 1 tekrar (2 sn arayla)
      return tryOnce().catch(function () { return null; }).then(function (url) {
        if (url) return url;
        return new Promise(function (res) { setTimeout(res, 2000); })
          .then(tryOnce)
          .catch(function () { return null; });
      });
    }
    var c = window.BRAVER_CLOUDINARY || {};
    if (!c.cloud || !c.preset) return Promise.resolve(null);
    var fd = new FormData();
    fd.append("file", blob);
    fd.append("upload_preset", c.preset);
    if (publicId) fd.append("public_id", publicId);
    return fetch("https://api.cloudinary.com/v1_1/" + c.cloud + "/" + (resourceType || "image") + "/upload",
      { method: "POST", body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.secure_url || null; })
      .catch(function () { return null; });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve) {
      if (!canvas) { resolve(null); return; }
      if (canvas.toBlob) canvas.toBlob(function (b) { resolve(b); }, type || "image/png", quality);
      else resolve(null);
    });
  }

  // allDesignDetails ile aynı sırada, her tasarımın canvas'ı ile birlikte
  function allDesignCanvases() {
    var list = committedDesigns.map(function (d) {
      return { details: d.details, canvas: d.el.querySelector("canvas") };
    });
    if (!textBox.classList.contains("is-hidden")) {
      list.push({ details: currentDesignDetails(), canvas: embCanvas });
    }
    return list;
  }

  // Tasarım alanlarının gerçek genişlikleri (üretim ölçüsü)
  var SAFE_AREA_CM = { front: 13.5, left: 8, right: 8 };
  // Patch içi 6,5 cm; aktif alan %16 genişletilmiş olduğundan 6,5 × 1,16
  var PATCH_AREA_CM = 6.75;

  function cmPerPx(view) {
    var v = view || "front";
    var a = viewSafeAreaValues(v);
    var stageW = mainHat.offsetWidth || 600;
    var areaPx = stageW * a.width / 100;
    var cm = isUv() ? PATCH_AREA_CM : (SAFE_AREA_CM[v] || SAFE_AREA_CM.front);
    return areaPx > 0 ? cm / areaPx : 0;
  }

  function fmtCm(px, scale) {
    return (Math.round(px * scale * 10) / 10).toString().replace(".", ",");
  }

  // "8,2 × 3,1 cm · Konum: +0,4, -1,2 cm" — canvas display boyutundan
  function designCmInfo(det, canvas) {
    var s = cmPerPx(det.view);
    if (!s || !canvas) return null;
    var w = parseFloat(canvas.style.width) || canvas.width;
    var h = parseFloat(canvas.style.height) || canvas.height;
    var dx = det.x || 0, dy = det.y || 0;
    var sign = function (v) { return (v >= 0 ? "+" : "") + fmtCm(v, s); };

    // Alan dışına taşıyorsa basılan (kırpılmış) kısmın boyutunu ayrıca ver
    var printed = null;
    var a = viewSafeAreaValues(det.view || "front");
    var stageW = mainHat.offsetWidth || 600;
    var aw = a.width / 100 * stageW, ah = a.height / 100 * stageW;
    var rad = (det.rotation || 0) * Math.PI / 180;
    var bw = Math.abs(w * Math.cos(rad)) + Math.abs(h * Math.sin(rad));
    var bh = Math.abs(w * Math.sin(rad)) + Math.abs(h * Math.cos(rad));
    var cx = aw / 2 + dx, cyy = ah / 2 + dy;
    var ix = Math.max(0, Math.min(cx + bw / 2, aw) - Math.max(cx - bw / 2, 0));
    var iy = Math.max(0, Math.min(cyy + bh / 2, ah) - Math.max(cyy - bh / 2, 0));
    if (ix < bw - 0.5 || iy < bh - 0.5) {
      printed = fmtCm(ix, s) + " × " + fmtCm(iy, s) + " cm";
    }

    return {
      size: fmtCm(w, s) + " × " + fmtCm(h, s) + " cm",
      printed: printed,
      pos: sign(dx) + ", " + sign(dy) + " cm (merkezden)"
    };
  }

  function loadImgAsync(src) {
    return new Promise(function (resolve) {
      if (!src) { resolve(null); return; }
      var im = new Image();
      im.crossOrigin = "anonymous";
      im.onload = function () { resolve(im); };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }

  // Şeffaflığı gösteren damalı zemin
  function drawChecker(ctx, x, y, w, h) {
    var s = 14;
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    for (var yy = 0; yy < h; yy += s) {
      for (var xx = 0; xx < w; xx += s) {
        ctx.fillStyle = ((Math.floor(xx / s) + Math.floor(yy / s)) % 2 === 0) ? "#ffffff" : "#ececec";
        ctx.fillRect(x + xx, y + yy, s, s);
      }
    }
    ctx.restore();
    ctx.strokeStyle = "#dddddd"; ctx.lineWidth = 1;
    ctx.strokeRect(x, y, w, h);
  }

  // Safe area dışına taşan kısımlar üretimde yer almaz (sahnede şapka
  // maskesi taşanı örter) — üretim PNG'si, özet PDF'i ve önizleme de aynı
  // kırpımı kullansın. Tasarım tamamen alan içindeyse orijinal döner.
  function croppedDesignCanvas(it) {
    var d = it.details || {}, c = it.canvas;
    if (!c || !c.width) return c;
    var a = viewSafeAreaValues(d.view || "front");
    var stageW = mainHat.offsetWidth || 600;
    var S = 900, s = S / stageW;
    var aw = Math.max(2, a.width / 100 * S);
    var ah = Math.max(2, a.height / 100 * S);
    var w = (parseFloat(c.style.width) || c.width) * s;
    var h = (parseFloat(c.style.height) || c.height) * s;
    var cx = aw / 2 + (d.x || 0) * s;
    var cyy = ah / 2 + (d.y || 0) * s;
    var rad = (d.rotation || 0) * Math.PI / 180;
    var bw = Math.abs(w * Math.cos(rad)) + Math.abs(h * Math.sin(rad));
    var bh = Math.abs(w * Math.sin(rad)) + Math.abs(h * Math.cos(rad));
    if (cx - bw / 2 >= -1 && cx + bw / 2 <= aw + 1 &&
        cyy - bh / 2 >= -1 && cyy + bh / 2 <= ah + 1) {
      return c; // taşma yok — yüksek çözünürlüklü orijinal kalsın
    }
    // Orijinal canvas çözünürlüğünü koru (üretim dosyası kalitesi)
    var k = Math.max(1, Math.min(4, c.width / Math.max(1, w)));
    var cv = document.createElement("canvas");
    cv.width = Math.round(aw * k);
    cv.height = Math.round(ah * k);
    var x2 = cv.getContext("2d");
    x2.imageSmoothingEnabled = true;
    x2.imageSmoothingQuality = "high";
    x2.translate(cx * k, cyy * k);
    x2.rotate(rad);
    x2.drawImage(c, -w * k / 2, -h * k / 2, w * k, h * k);
    return cv;
  }

  // Efektsiz "temiz" üretim görseli (Zakeke'nin düz PNG'i gibi): logo
  // tasarımlarında orijinal görsel, nakışta iplik paletine indirgenmiş DÜZ
  // renklerle, cm boyutundan 600 DPI hedef çözünürlükte. Yazı tasarımlarında
  // üretilemez (glifler nakış görselinin kendisi) — null döner.
  // UV baskı YAZI tasarımı: sahne canvas'ı ekran çözünürlüğünde (~300px) — gerçek
  // raster baskı için yetersiz (#14522). TTF fontla 600 DPI'da yeniden render.
  // (Nakış yazılarında temiz PNG üretilmez: glif PNG'leri nakış görselinin kendisidir.)
  function uvTextHiRes(det, c) {
    if (det.technique !== "uv" || !det.text || !c) return null;
    var s = cmPerPx(det.view || "front");
    var wPx = parseFloat(c.style.width) || c.width;
    if (!s || !wPx) return null;
    var DPI = 600, MAXPX = 4800;
    var k = Math.min(MAXPX / Math.max(1, wPx), (s / 2.54) * DPI); // stil px → 600 DPI px
    var size = Number(det.size || 46) * k;
    var pad = Math.max(6, Number(det.size || 46) * 0.12) * k;
    var m = measureText(det.text, size, det.fontKey || selectedFont);
    var W = Math.ceil(m.width + pad * 2), H = Math.ceil(m.ascent + m.descent + pad * 2);
    if (!W || !H) return null;
    var cv = document.createElement("canvas");
    cv.width = W; cv.height = H;
    var ctx = cv.getContext("2d");
    ctx.font = fontStack(det.fontKey || selectedFont, Math.round(size));
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = det.color || "#000000";
    var rows = textRows(det.text);
    var lineAscent = Math.max(1, size * 0.78);
    var lineHeight = Math.max(size * 1.16, lineAscent + size * 0.22);
    rows.forEach(function (line, i) {
      var mm = ctx.measureText(line);
      var left = Math.max(0, mm.actualBoundingBoxLeft || 0);
      var right = Math.max(0, mm.actualBoundingBoxRight || mm.width);
      ctx.fillText(line, Math.round((W - (left + right)) / 2 + left), Math.round(pad + lineAscent + i * lineHeight));
    });
    var kirp = safeAreaKirp600(det, cv, k);
    if (kirp) return kirp;
    trimCanvas(cv, 1);
    return cv;
  }

  // 600 DPI temiz görseli müşterinin sahnede KIRPTIĞI gibi ver: tasarım safe
  // area'dan (patch alanından) taşıyorsa, çıktı safe area'nın kendisi olur
  // (ör. UV patch 6,75 cm → ~1594 px kare) ve tasarım oradaki konum/döndürme ile
  // içine bindirilip alan dışı atılır. Taşma yoksa null (tam görsel kalsın).
  // Geometri croppedDesignCanvas ile aynı; `k` = stil px → 600 DPI px oranı.
  function safeAreaKirp600(det, hi, k) {
    if (!hi || !hi.width || !k) return null;
    var a = viewSafeAreaValues(det.view || "front");
    var stageW = mainHat.offsetWidth || 600;
    var aw = Math.max(2, a.width / 100 * stageW);
    var ah = Math.max(2, a.height / 100 * stageW);
    var w = hi.width / k, h = hi.height / k;
    var cx = aw / 2 + (det.x || 0);
    var cy = ah / 2 + (det.y || 0);
    var rad = (det.rotation || 0) * Math.PI / 180;
    var bw = Math.abs(w * Math.cos(rad)) + Math.abs(h * Math.sin(rad));
    var bh = Math.abs(w * Math.sin(rad)) + Math.abs(h * Math.cos(rad));
    if (cx - bw / 2 >= -1 && cx + bw / 2 <= aw + 1 &&
        cy - bh / 2 >= -1 && cy + bh / 2 <= ah + 1) return null;
    var MAXPX = 4800;
    var kk = Math.min(k, MAXPX / Math.max(aw, ah));
    var cv = document.createElement("canvas");
    cv.width = Math.round(aw * kk);
    cv.height = Math.round(ah * kk);
    var x2 = cv.getContext("2d");
    x2.imageSmoothingEnabled = true;
    x2.imageSmoothingQuality = "high";
    x2.translate(cx * kk, cy * kk);
    x2.rotate(rad);
    x2.drawImage(hi, -w * kk / 2, -h * kk / 2, w * kk, h * kk);
    return cv;
  }

  function cleanDesignCanvas(dc) {
    var det = dc.details || {};
    var c = dc.canvas;
    if (det.type !== "Logo") return uvTextHiRes(det, c);
    if (!det.logoImage || !det.logoImage.naturalWidth || !c) return null;
    var s = cmPerPx(det.view || "front");
    var wPx = parseFloat(c.style.width) || c.width;
    var hPx = parseFloat(c.style.height) || c.height;
    if (!s || !wPx) return null;
    var DPI = 600, MAXPX = 4800;
    var outW = Math.min(MAXPX, Math.max(50, Math.round(wPx * s / 2.54 * DPI)));
    var outH = Math.max(1, Math.round(outW * det.logoImage.naturalHeight / det.logoImage.naturalWidth));
    var cv = document.createElement("canvas");
    cv.width = outW; cv.height = outH;
    var ctx = cv.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(det.logoImage, 0, 0, outW, outH);
    if (det.technique !== "uv") {
      var img = ctx.getImageData(0, 0, outW, outH);
      var data = img.data;
      var map = det.logoColorMap || {};
      for (var i = 0; i < data.length; i += 4) {
        if (data[i + 3] <= 24) { data[i + 3] = 0; continue; }
        var hex = logoThreadColor(data[i], data[i + 1], data[i + 2]);
        var mapped = normalizeHex(map[hex]) || hex;
        if (mapped === "transparent") { data[i + 3] = 0; continue; }
        var rgb = hexToRgb(mapped);
        data[i] = rgb.r; data[i + 1] = rgb.g; data[i + 2] = rgb.b;
      }
      ctx.putImageData(img, 0, 0);
    }
    // Müşterinin kırptığı gibi: safe area / patch dışına taşan kısım atılır
    return safeAreaKirp600(det, cv, outW / wPx) || cv;
  }

  // Tasarımları şapka fotoğrafının üstüne bindir (sahnedeki konumlarıyla)
  function compositeView(view, items) {
    return loadImgAsync(viewImage(view)).then(function (hat) {
      var S = 900;
      var cv = document.createElement("canvas");
      cv.width = S; cv.height = S;
      var ctx = cv.getContext("2d");
      ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, S, S);
      if (hat) ctx.drawImage(hat, 0, 0, S, S);
      var stageW = mainHat.offsetWidth || 600;
      var s = S / stageW;
      // Sahnedeki gibi: safe area dışına taşan kısım görünmez (patch kırpımı)
      var aClip = viewSafeAreaValues(view);
      ctx.save();
      ctx.beginPath();
      ctx.rect(aClip.left / 100 * S, aClip.top / 100 * S, aClip.width / 100 * S, aClip.height / 100 * S);
      ctx.clip();
      items.slice().sort(function (a, b) {
        return Number(a.details.layer || 0) - Number(b.details.layer || 0);
      }).forEach(function (it) {
        var d = it.details, c = it.canvas;
        if (!c || !c.width) return;
        var a = viewSafeAreaValues(d.view || "front");
        var cx = (a.left + a.width / 2) / 100 * S + (d.x || 0) * s;
        var cyy = (a.top + a.height / 2) / 100 * S + (d.y || 0) * s;
        var w = (parseFloat(c.style.width) || c.width) * s;
        var h = (parseFloat(c.style.height) || c.height) * s;
        ctx.save();
        ctx.translate(cx, cyy);
        ctx.rotate((d.rotation || 0) * Math.PI / 180);
        ctx.drawImage(c, -w / 2, -h / 2, w, h);
        ctx.restore();
      });
      ctx.restore();
      return cv;
    });
  }

  // Zakeke tarzı çok sayfalı A4 özet: bilgi blokları + kompozit şapka + tasarım detayları
  function buildSummaryPages(info, designCanvases) {
    var byView = {};
    designCanvases.forEach(function (dc) {
      var v = dc.details.view || "front";
      (byView[v] = byView[v] || []).push(dc);
    });
    var usedViews = ["front", "left", "right"].filter(function (v) { return byView[v]; });

    var jobs = usedViews.map(function (v) { return compositeView(v, byView[v]); });
    jobs.push(loadImgAsync(viewImage("front")));

    return Promise.all(jobs).then(function (res) {
      var blankHat = res.pop();
      var composites = {};
      usedViews.forEach(function (v, i) { composites[v] = res[i]; });

      var W = 1240, H = 1754, M = 80, CW = W - 2 * M;
      var pages = [], ctx, cy;
      var ACCENT = "#1a73e8";

      function newPage() {
        var cv = document.createElement("canvas");
        cv.width = W; cv.height = H;
        ctx = cv.getContext("2d");
        ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, W, H);
        ctx.textBaseline = "top";
        cy = M;
        pages.push(cv);
      }
      function ensure(hNeed) { if (cy + hNeed > H - M) newPage(); }
      function sectionTitle(t, x, w) {
        ctx.fillStyle = ACCENT;
        ctx.fillRect(x, cy, w, 5);
        ctx.font = "700 26px Arial, sans-serif";
        ctx.fillText(t.toUpperCase(), x, cy + 16);
      }
      function kv(pairs, x, y0, labelW) {
        pairs.forEach(function (p, i) {
          ctx.font = "400 26px Arial, sans-serif";
          ctx.fillStyle = "#666666";
          ctx.fillText(p[0] + ":", x, y0 + i * 42);
          ctx.font = "700 26px Arial, sans-serif";
          ctx.fillStyle = "#111111";
          ctx.fillText(String(p[1] || "—"), x + labelW, y0 + i * 42);
        });
      }
      function fitDraw(c, x, y, w, h) {
        if (!c || !c.width) return;
        var s = Math.min(w / c.width, h / c.height);
        var dw = c.width * s, dh = c.height * s;
        ctx.drawImage(c, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
      }
      // Metni verilen genişliğe göre satırlara böl (uzun kelimeleri de kırar)
      function wrapLines(text, maxW) {
        var out = [], line = "";
        String(text).split(" ").forEach(function (word) {
          while (ctx.measureText(word).width > maxW && word.length > 4) {
            var cut = word.length - 1;
            while (cut > 1 && ctx.measureText(word.slice(0, cut)).width > maxW) cut--;
            if (line) { out.push(line); line = ""; }
            out.push(word.slice(0, cut));
            word = word.slice(cut);
          }
          var trial = line ? line + " " + word : word;
          if (ctx.measureText(trial).width > maxW && line) {
            out.push(line);
            line = word;
          } else {
            line = trial;
          }
        });
        if (line) out.push(line);
        return out;
      }

      newPage();

      // ── Başlık ──
      ctx.fillStyle = "#111111";
      ctx.font = "700 48px Arial, sans-serif";
      ctx.fillText("BRAVER — Sipariş Özeti", M, cy);
      cy += 80;

      // ── Bilgi blokları (iki sütun) ──
      var colW = (CW - 60) / 2;
      var d = new Date();
      var dateStr = d.toLocaleDateString("tr-TR") + " " + d.toLocaleTimeString("tr-TR").slice(0, 5);
      sectionTitle("Sipariş Bilgileri", M, colW);
      var infoTop = cy + 62;
      kv([
        ["Satıcı", "Braver"],
        ["Referans", info.referans || "—"],
        ["Tarih", dateStr],
        ["Ürün", info.model || "Kişiye özel şapka"],
        ["Adet", String(info.adet || 1)]
      ], M, infoTop, 130);
      sectionTitle("Tasarım Detayları", M + colW + 60, colW);
      kv([
        ["Varyant", info.color || "—"],
        ["Tasarım sayısı", String(designCanvases.length)],
        ["Uygulama", (function () {
          var ts = {};
          designCanvases.forEach(function (dc) { ts[(dc.details && dc.details.technique) || "nakis"] = true; });
          return ts.uv ? "UV Baskı"
            : ts["3d"] && ts.nakis ? "3D Kabartma (ön) + Nakış (yan)"
            : ts["3d"] ? "3D Kabartmalı Nakış" : "Nakış";
        })()]
      ], M + colW + 60, infoTop, 260);
      cy = infoTop + 5 * 42 + 30; // sol blokta 5 satır var (Referans dahil)

      // ── Boş şapka + tasarımlı ilk yüz ──
      var hatBox = Math.min(430, Math.floor((CW - 60) / 2));
      ensure(hatBox + 60);
      ctx.font = "400 24px Arial, sans-serif"; ctx.fillStyle = "#666666";
      ctx.fillText("Ürün", M, cy);
      ctx.fillText("Tasarımlı önizleme", M + hatBox + 60, cy);
      var hatTop = cy + 36;
      ctx.fillStyle = "#f5f6f7";
      ctx.fillRect(M, hatTop, hatBox, hatBox);
      if (blankHat) ctx.drawImage(blankHat, M, hatTop, hatBox, hatBox);
      var firstComp = composites[usedViews[0]];
      ctx.fillStyle = "#f5f6f7";
      ctx.fillRect(M + hatBox + 60, hatTop, hatBox, hatBox);
      if (firstComp) ctx.drawImage(firstComp, M + hatBox + 60, hatTop, hatBox, hatBox);
      cy = hatTop + hatBox + 46;

      // ── Yüz bazında bölümler ──
      usedViews.forEach(function (v) {
        var items = byView[v];
        var compBox = 400;
        var need = 62 + Math.max(compBox, items.length * 240) + 40;
        ensure(Math.min(need, H - 2 * M));

        sectionTitle("Özelleştirilen Alan — " + (VIEW_LABELS[v] || "Ön"), M, CW);
        cy += 62;
        var top0 = cy;
        var pageAtStart = pages.length;

        // Sol: kompozit şapka
        ctx.fillStyle = "#f5f6f7";
        ctx.fillRect(M, top0, compBox, compBox);
        if (composites[v]) ctx.drawImage(composites[v], M, top0, compBox, compBox);

        // Sağ: her tasarım şeffaf zeminde + detaylar
        var rx = M + compBox + 50;
        var rw = W - M - rx;
        var ry = top0;
        items.forEach(function (it, i) {
          var det = it.details;
          var pv = 200;
          var tx = rx + pv + 34;
          var maxTextW = W - M - tx;

          // Önce satırları hazırla ki blok yüksekliği bilinsin
          var lines = [];
          if (det.type === "Logo") {
            lines.push("Tür: Logo / Desen");
            if (det.file || det.label) lines.push("Dosya: " + (det.file || det.label));
            var rc = summaryReadableColors(det.colors);
            if (rc) lines.push("Renkler: " + rc);
            if (det.logoImage && det.logoImage.naturalWidth) {
              lines.push("ZIP: temiz PNG (600 DPI)" + (det.logoFile ? " + kaynak dosya" : ""));
            }
          } else {
            lines.push("Metin: “" + (det.text || "") + "”");
            lines.push("Font: " + (det.font || "—"));
            lines.push("Renk: " + colorName(det.color) +
              (det.konturColor ? "  ·  Kontur: " + colorName(det.konturColor) : ""));
            if (det.tracking) lines.push("Harf aralığı: " + Math.round(det.tracking * 100));
          }
          var cm = designCmInfo(det, it.canvas);
          if (cm) {
            lines.push("Boyut: " + cm.size);
            if (cm.printed) lines.push("Basılan kısım: " + cm.printed + " (alan dışı kırpılır)");
            lines.push("Konum: " + cm.pos);
          } else {
            lines.push("Boyut: " + Math.round(det.size || 0) +
              "  ·  Konum: " + Math.round(det.x || 0) + ", " + Math.round(det.y || 0));
          }
          lines.push("Döndürme: " + Math.round(det.rotation || 0) + "°");

          ctx.font = "400 25px Arial, sans-serif";
          var wrapped = [];
          lines.forEach(function (ln) {
            wrapLines(ln, maxTextW).forEach(function (w2) { wrapped.push(w2); });
          });
          var rowH = Math.max(240, 40 + wrapped.length * 36 + 24);

          if (ry + rowH > H - M) { newPage(); ry = cy; }

          drawChecker(ctx, rx, ry, pv, pv);
          fitDraw(croppedDesignCanvas(it), rx + 12, ry + 12, pv - 24, pv - 24);
          ctx.font = "700 28px Arial, sans-serif"; ctx.fillStyle = "#111111";
          ctx.fillText("Tasarım " + (i + 1), tx, ry);
          ctx.font = "400 25px Arial, sans-serif"; ctx.fillStyle = "#333333";
          wrapped.forEach(function (ln, li) { ctx.fillText(ln, tx, ry + 40 + li * 36); });
          ry += rowH;
        });

        // Sayfa değiştiyse kompozitin bulunduğu eski sayfayı hesaba katma
        var samePage = pages.length === pageAtStart;
        cy = (samePage ? Math.max(top0 + compBox, ry) : ry) + 40;
      });

      // Alt bilgi
      pages.forEach(function (p, pi) {
        var c2 = p.getContext("2d");
        c2.font = "400 22px Arial, sans-serif";
        c2.fillStyle = "#999999";
        c2.textBaseline = "top";
        c2.fillText("bravercap.com.tr  ·  Sayfa " + (pi + 1) + "/" + pages.length, M, H - 56);
      });

      return pages;
    });
  }

  function summaryReadableColors(str) {
    if (!str) return "";
    return str.split(",").map(function (pair) {
      var p = pair.trim();
      if (p.indexOf(">") !== -1) {
        var ab = p.split(">");
        return colorName(ab[0]) + " → " + colorName(ab[1]);
      }
      return colorName(p);
    }).join(", ");
  }

  function buildSummaryPdfBlob(pages) {
    var jsPDFCtor = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
    if (!jsPDFCtor || !pages || !pages.length) return null;
    try {
      var pdf = new jsPDFCtor({ unit: "pt", format: "a4", orientation: "portrait" });
      var pw = pdf.internal.pageSize.getWidth();
      var ph = pdf.internal.pageSize.getHeight();
      pages.forEach(function (cv, i) {
        if (i > 0) pdf.addPage();
        pdf.addImage(cv.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, pw, ph);
      });
      return pdf.output("blob");
    } catch (e) {
      return null;
    }
  }

  /* ── Sepete Ekle ─────────────────────────────────────────── */

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
      checkBounds();
      if (addToCartBtn.disabled) return;
      const designItems = allDesignCanvases();
      const designs = designItems.map(function (it) { return it.details; });

      // Model adı
      var modelTitle = "";
      if (modelList) {
        var activeModel = modelList.querySelector(".model-option.active");
        if (activeModel) modelTitle = (activeModel.querySelector("span") || {}).textContent || "";
      }
      // Şapka rengi (seçili varyantın adı)
      var colorTitle = selectedColorName;
      if (!colorTitle) {
        var firstBtn = document.querySelector(".hat-option:not(.is-hidden) img");
        if (firstBtn) colorTitle = firstBtn.alt || "";
      }

      // Logo renk eşlemesini okunaklı yap: "#000000>#ff0000" → "Siyah → Kırmızı"
      function readableColors(str) {
        if (!str) return "";
        return str.split(",").map(function (pair) {
          var p = pair.trim();
          if (p.indexOf(">") !== -1) {
            var ab = p.split(">");
            return colorName(ab[0]) + " → " + colorName(ab[1]);
          }
          return colorName(p);
        }).join(", ");
      }

      const properties = {};
      // ── Müşteriye ve admin'e görünen özet ──
      var headParts = [];
      if (modelTitle) headParts.push(modelTitle);
      if (colorTitle) headParts.push(colorTitle);
      properties["Ürün"] = headParts.join(" · ") || "Kişiye özel şapka";
      if (isUv()) properties["Patch Rengi"] = patchColor === "siyah" ? "Siyah" : "Beyaz";
      // Nakış/tasarım detayları sipariş özelliklerine YAZILMAZ (kullanıcı isteği,
      // 3 Ağu): hepsi zaten sipariş özeti PDF'inde; admin sayfası sade kalsın.

      // ── Ek ücretler (Zakeke tarzı ayrı ücret line item'ları) ──
      //  - Nakışta yüklenen logo başına logoAmount (hazır desenler ücretsiz)
      //  - Kullanılan her yan (sol/sağ) başına sideAmount
      var fees = window.BRAVER_FEES || {};
      var feeItems = [];
      var counts = feeCounts(designs);
      if (counts.logoCount > 0 && fees.logoVariantId) {
        feeItems.push({ id: Number(fees.logoVariantId), quantity: counts.logoCount,
          properties: { "_Ücret": "Yüklenen logo nakış · " + counts.logoCount + " adet" } });
      }
      // Yan ücreti HER ŞAPKAYA işlendiği için adetle çarpılır (20 Ağu kararı);
      // kilitte "*q" işareti bekçiye 'şapka satırının adediyle çarp' der —
      // müşteri sepette adedi değiştirse bile bekçi ücreti doğru sayıya eşitler
      var kilitParcalari = [];
      if (feeItems.length) feeItems.forEach(function (f) { kilitParcalari.push(f.id + "x" + f.quantity); });
      if (counts.sideCount > 0 && fees.sideVariantId) {
        var sideQty = counts.sideCount * currentQty();
        feeItems.push({ id: Number(fees.sideVariantId), quantity: sideQty,
          properties: { "_Ücret": "Yan uygulama · " + counts.sideCount + " yan × " + currentQty() + " şapka" } });
        // kilit TOPLAM sayıyı taşır (eski bekçiyle geriye uyumlu); adet-ölçekleme
        // kuralı ayrı özellikte — yalnız yeni bekçi anlar, sepette adet değişirse eşitler
        kilitParcalari.push(fees.sideVariantId + "x" + sideQty);
        properties["_ucret_kural"] = fees.sideVariantId + "x" + counts.sideCount + "*q";
      }
      if (counts.d3Count > 0 && fees.d3VariantId) {
        feeItems.push({ id: Number(fees.d3VariantId), quantity: 1,
          properties: { "_Ücret": "3D kabartma nakış" } });
        kilitParcalari.push(fees.d3VariantId + "x1");
      }
      // Ücret kilidi: sepet bekçisi (braver-fee-guard.js) bu listeden eksik
      // ücret satırlarını otomatik geri ekler (müşteri silerse/sıfırlarsa)
      if (kilitParcalari.length) {
        properties["_ucret_kilit"] = kilitParcalari.join(",");
      }

      function addFeeItems() {
        if (!feeItems.length) return Promise.resolve();
        return fetch("/cart/add.js", {
          method:  "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body:    JSON.stringify({ items: feeItems })
        }).then(function (res) {
          // Ücret eklenemezse (ör. varyant stok dışı) sepeti bloke etme
          if (!res.ok) return null;
          return res.json();
        }).catch(function () { return null; });
      }

      addToCartBtn.disabled = true;
      var cartErrorEl = document.getElementById("cartError");
      if (cartErrorEl) { cartErrorEl.classList.add("is-hidden"); cartErrorEl.textContent = ""; }

      // Gömülü önizleme: kompozit şapka görseli Shopify'ın dosya özelliği olarak
      // gönderilir → admin siparişte Zakeke'deki gibi küçük resim görünür
      var previewBlob = null;
      var byViewPrev = {};
      designItems.forEach(function (dc) {
        var v = dc.details.view || "front";
        (byViewPrev[v] = byViewPrev[v] || []).push(dc);
      });
      var prevView = byViewPrev.front ? "front" : byViewPrev.left ? "left" : "right";
      var previewWork = compositeView(prevView, byViewPrev[prevView] || [])
        .then(function (cv) { return canvasToBlob(cv, "image/jpeg", 0.85); })
        .then(function (b) { previewBlob = b; })
        .catch(function () {});

      var hatQty = currentQty();
      function postToCart() {
        var opts;
        if (previewBlob) {
          var fd = new FormData();
          fd.append("id", String(selectedVariantId));
          fd.append("quantity", String(hatQty));
          Object.keys(properties).forEach(function (k) {
            fd.append("properties[" + k + "]", properties[k]);
          });
          fd.append("properties[_Önizleme]", previewBlob, "onizleme.jpg");
          // YEDEK KANAL: worker'a erişilemediyse (ağ/engelleyici — #14255 vakası) üretim
          // dosyaları Shopify'ın kendi dosya özelliğiyle siparişe gömülür; admin'de
          // indirilebilir link görünür, worker webhook'ta bunları KV'ye çeker
          var zp = (typeof zipParcalari !== "undefined" && zipParcalari) || {};
          if (!properties["_Sipariş özeti (PDF)"] && zp.pdf) fd.append("properties[_Sipariş özeti (PDF)]", zp.pdf, "ozet-" + (typeof stamp !== "undefined" ? stamp : "x") + ".pdf");
          if (!properties["_Üretim dosyaları (ZIP)"] && zp.zipBlob) fd.append("properties[_Üretim dosyaları (ZIP)]", zp.zipBlob, "uretim-" + (typeof stamp !== "undefined" ? stamp : "x") + ".zip");
          opts = { method: "POST", headers: { "Accept": "application/json" }, body: fd };
        } else {
          opts = {
            method:  "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body:    JSON.stringify({ id: Number(selectedVariantId), quantity: hatQty, properties: properties })
          };
        }
        return fetch("/cart/add.js", opts)
          .then(function (res) {
            if (!res.ok) {
              // Shopify 422'de {description} döner (ör. stok yetersiz) — müşteriye göster
              return res.json().catch(function () { return {}; }).then(function (err) {
                throw new Error((err && (err.description || err.message)) || "Sepete eklenemedi");
              });
            }
            return res.json();
          })
          .then(function () { return addFeeItems(); })
          .then(function () {
            // ZIP en büyük/en son yükleme: zaman aşımıyla sepete geçildiyse yükleme
            // HÂLÂ sürüyor olabilir — sayfayı hemen değiştirmek isteği İPTAL EDER
            // (ZIP'i gelmeyen siparişlerin sebebi). Sepete gitmeden önce kalan
            // yüklemelerin bitmesini bekle (üst sınır 120 sn); worker dosyayı
            // referansla kendisi bulur.
            var kalan = (typeof jobs !== "undefined" && jobs) ? jobs : [];
            var bekleyen = kalan.length ? Promise.race([
              Promise.all(kalan.map(function (j) { return Promise.resolve(j).catch(function () {}); })),
              new Promise(function (r) { setTimeout(r, 120000); })
            ]) : Promise.resolve();
            addToCartBtn.textContent = "Sepete Eklendi — dosyalar yükleniyor, lütfen bekleyin…";
            return bekleyen.then(function () {
              addToCartBtn.textContent = "Sepete Eklendi";
              setTimeout(function () { window.location.href = "/cart"; }, 400);
            });
          });
      }

      // Cloudinary ayarlıysa: tasarım PNG'leri + sipariş özeti PDF yükle, URL'leri siparişe ekle
      var uploadWork = previewWork;
      if (cloudConfigured()) {
        addToCartBtn.textContent = "Dosyalar hazırlanıyor...";
        var stamp = Date.now();
        // Braver referansı: Shopify sipariş no checkout'ta oluştuğu için PDF'e
        // yazılamaz — bu referans hem PDF'te hem sipariş özelliğinde görünür,
        // dosya adlarındaki damgayla da (uretim-<stamp>.zip) eşleşir
        var referansNo = "BRV-" + String(stamp).slice(-8);
        properties["Referans No"] = referansNo;
        var designCanvases = designItems;
        var jobs = [previewWork];
        // ZIP yalnız DOSYA ÜRETİMİNİ bekler, yüklemeleri değil (#15183): worker'a
        // ulaşılamayan ağda yüklemeler askıda kalınca ZIP hiç oluşmuyor, yedek
        // kanalla siparişe de gömülemiyordu
        var blobJobs = [];
        var zipParcalari = { pngler: [], temiz: [], kaynak: [], pdf: null };

        // SİGORTA: tasarım durumunu paylaşım sistemine kaydet, linkini siparişe yaz —
        // dosyalar ne olursa olsun (#14255) linkten açıp yeniden üretilebilir
        jobs.push(serializeShareState().then(function (state) {
          return zamanAsimliFetch(BRAVER_DEPO + "/paylas", {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(state)
          }, 20000).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
            if (d && d.id) properties["_Tasarım linki"] = location.origin + location.pathname + "?tasarim=" + d.id;
          });
        }).catch(function () {}));

        // Sepet önizlemesi: Shopify uploads URL'i attachment başlığıyla sunulduğu
        // için vitrindeki <img> onu ÇİZEMEZ — worker kopyası inline sunulur,
        // sepet şablonları _onizleme_url'i kullanır (_Önizleme admin için kalır)
        jobs.push(previewWork.then(function () {
          if (!previewBlob) return null;
          return cloudUpload(previewBlob, "raw", "braver/onizleme-" + stamp + ".jpg")
            .then(function (url) { if (url) properties["_onizleme_url"] = url; });
        }).catch(function () {}));

        designCanvases.forEach(function (dc, i) {
          // Tekil görsel linki siparişe YAZILMAZ (hepsi üretim ZIP'inde) —
          // yalnız ZIP için blob üretilir
          blobJobs.push(
            canvasToBlob(croppedDesignCanvas(dc), "image/png").then(function (b) {
              zipParcalari.pngler[i] = b;
            }).catch(function () {})
          );
          // Zakeke paritesi: efektsiz 600 DPI temiz PNG + müşterinin orijinal dosyası
          var temizCv = cleanDesignCanvas(dc);
          if (temizCv) {
            blobJobs.push(canvasToBlob(temizCv, "image/png").then(function (b) {
              zipParcalari.temiz[i] = b;
            }).catch(function () {}));
          }
          var kf = dc.details && dc.details.logoFile;
          if (kf && kf.size) zipParcalari.kaynak[i] = kf;
        });

        var pdfBlobJob = buildSummaryPages({ model: modelTitle, color: colorTitle + (isUv() ? " / " + (patchColor === "siyah" ? "Siyah" : "Beyaz") + " patch" : ""), referans: referansNo, adet: hatQty }, designCanvases)
          .then(function (pages) {
            var pdfBlob = buildSummaryPdfBlob(pages);
            if (pdfBlob) zipParcalari.pdf = pdfBlob;
            return pdfBlob || null;
          })
          .catch(function () { return null; });
        blobJobs.push(pdfBlobJob);
        jobs.push(
          pdfBlobJob
            .then(function (pdfBlob) {
              return pdfBlob ? cloudUpload(pdfBlob, "raw", "braver/ozet-" + stamp + ".pdf") : null;
            })
            .then(function (url) {
              if (url) properties["_Sipariş özeti (PDF)"] = url;
            })
            .catch(function () {})
        );

        // Tüm üretim dosyaları tek pakette (Zakeke'nin zip'i gibi) — yalnız dosya
        // üretimini bekler; yükleme askıda kalsa da zipBlob yedek kanal için hazır olur
        var zipJob = Promise.all(blobJobs).then(function () {
          if (!window.JSZip) return null;
          var zip = new JSZip();
          if (zipParcalari.pdf) zip.file("siparis-ozeti.pdf", zipParcalari.pdf);
          zipParcalari.pngler.forEach(function (b, i) {
            if (!b) return;
            var det = designCanvases[i].details || {};
            var yuz = det.view === "left" ? "sol" : det.view === "right" ? "sag" : "on";
            zip.file("tasarim-" + (i + 1) + "-" + yuz + ".png", b);
            if (zipParcalari.temiz[i]) zip.file("tasarim-" + (i + 1) + "-" + yuz + "-temiz-600dpi.png", zipParcalari.temiz[i]);
            var kf = zipParcalari.kaynak[i];
            if (kf) zip.file("kaynak/" + (kf.name || "tasarim-" + (i + 1) + "-kaynak"), kf);
          });
          return zip.generateAsync({ type: "blob" }).then(function (zb) {
            zipParcalari.zipBlob = zb; // worker'a ulaşılamazsa Shopify dosya özelliği olarak gider
            return cloudUpload(zb, "raw", "braver/uretim-" + stamp + ".zip");
          }).then(function (url) {
            if (url) properties["_Üretim dosyaları (ZIP)"] = url;
          });
        }).catch(function () {});
        jobs.push(zipJob);

        // 55 sn üst sınır: yükleme takılırsa sepete eklemeyi bloke etme
        // (üretim dosyaları kritik — yavaş bağlantıda ZIP'e zaman tanı)
        var guard = new Promise(function (resolve) { setTimeout(resolve, 55000); });
        uploadWork = Promise.race([Promise.all(jobs), guard]);
      }

      uploadWork
        .then(function () {
          // Sessiz kayıp olmasın: dosya özelliği eksikse admin görsün
          if (typeof designCanvases !== "undefined" && designCanvases && designCanvases.length) {
            var zpp = (typeof zipParcalari !== "undefined" && zipParcalari) || {};
            if (!properties["_Sipariş özeti (PDF)"]) properties["_PDF durumu"] = zpp.pdf ? "Worker'a ulaşılamadı — dosya siparişe gömüldü" : "YÜKLENEMEDİ";
            if (!properties["_Üretim dosyaları (ZIP)"]) properties["_ZIP durumu"] = zpp.zipBlob ? "Worker'a ulaşılamadı — dosya siparişe gömüldü" : "YÜKLENEMEDİ";
          }
          addToCartBtn.textContent = "Ekleniyor...";
          return postToCart();
        })
        .catch(function (e) {
          addToCartBtn.textContent = "Tekrar Dene";
          addToCartBtn.disabled = false;
          var ce = document.getElementById("cartError");
          if (ce) {
            ce.textContent = (e && e.message) || "Sepete eklenemedi, tekrar deneyin.";
            ce.classList.remove("is-hidden");
          }
          checkBounds();
        });
    });
  }

  /* ── Tasarım paylaşımı (Zakeke paritesi): durum worker KV'ye kaydedilir,
     müşteri ?tasarim=<id> linkiyle aynı tasarımı yükleyip sipariş verir ── */

  const shareBtn = document.getElementById("shareDesignBtn");
  const shareResult = document.getElementById("shareResult");
  const shareUrlInput = document.getElementById("shareUrlInput");
  const shareCopyBtn = document.getElementById("shareCopyBtn");

  function imageToDataUrl(img) {
    try {
      var c = document.createElement("canvas");
      c.width = img.naturalWidth || img.width;
      c.height = img.naturalHeight || img.height;
      c.getContext("2d").drawImage(img, 0, 0);
      return c.toDataURL("image/png");
    } catch (e) { return null; }
  }

  function fileToDataUrl(file) {
    return new Promise(function (res) {
      var r = new FileReader();
      r.onload = function () { res(r.result); };
      r.onerror = function () { res(null); };
      r.readAsDataURL(file);
    });
  }

  function dataUrlToImage(dataUrl) {
    return new Promise(function (res, rej) {
      var img = new Image();
      img.onload = function () { res(img); };
      img.onerror = rej;
      img.src = dataUrl;
    });
  }

  function dataUrlToFile(dataUrl, ad) {
    try {
      var parca = dataUrl.split(",");
      var tip = (parca[0].match(/data:([^;]+)/) || [])[1] || "application/octet-stream";
      var bin = atob(parca[1]);
      var arr = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return new File([arr], ad || "kaynak", { type: tip });
    } catch (e) { return null; }
  }

  async function serializeShareState() {
    var designs = allDesignDetails();
    var out = [];
    for (var i = 0; i < designs.length; i++) {
      var d = designs[i];
      var j = {};
      Object.keys(d).forEach(function (k) {
        if (k === "logoImage" || k === "logoFile") return;
        var v = d[k];
        if (typeof v === "function") return;
        try { JSON.stringify(v); j[k] = v; } catch (e) {}
      });
      if (d.type === "Logo" && d.logoImage) {
        j.logoDataUrl = imageToDataUrl(d.logoImage);
        if (d.logoFile && d.logoFile.size) {
          j.kaynakAd = d.logoFile.name || "";
          j.kaynakDataUrl = await fileToDataUrl(d.logoFile);
        }
      }
      out.push(j);
    }
    return {
      v: 2,
      // boyut/konum px cinsinden — açan cihazda sahne genişliğine ORANLANIR
      // (masaüstü→mobil paylaşımda tasarım devleşmesin, tersi küçülmesin)
      stageW: mainHat.offsetWidth || 0,
      variantId: String(selectedVariantId || (addToCartBtn && addToCartBtn.dataset.variantId) || ""),
      technique: chosenTechnique || currentTechnique,
      patchColor: patchColor,
      qty: currentQty(),
      designs: out
    };
  }

  if (shareBtn) {
    shareBtn.addEventListener("click", function () {
      if (!hasAnyDesign()) {
        shareResult.classList.remove("is-hidden");
        shareUrlInput.value = "Önce bir tasarım ekleyin";
        return;
      }
      shareBtn.disabled = true;
      shareBtn.textContent = "Hazırlanıyor...";
      serializeShareState().then(function (state) {
        return fetch(BRAVER_DEPO + "/paylas", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(state)
        });
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          shareBtn.disabled = false;
          shareBtn.innerHTML = "&#128279; Tasarımı paylaş";
          if (!d || !d.id) {
            shareResult.classList.remove("is-hidden");
            shareUrlInput.value = "Paylaşım oluşturulamadı, tekrar deneyin";
            return;
          }
          var link = location.origin + location.pathname + "?tasarim=" + d.id;
          shareResult.classList.remove("is-hidden");
          shareUrlInput.value = link;
          shareUrlInput.select();
        })
        .catch(function () {
          shareBtn.disabled = false;
          shareBtn.innerHTML = "&#128279; Tasarımı paylaş";
          shareResult.classList.remove("is-hidden");
          shareUrlInput.value = "Paylaşım oluşturulamadı, tekrar deneyin";
        });
    });
  }

  if (shareCopyBtn) {
    shareCopyBtn.addEventListener("click", function () {
      var v = shareUrlInput.value || "";
      if (v.indexOf("http") !== 0) return;
      var done = function () {
        shareCopyBtn.textContent = "Kopyalandı ✓";
        shareCopyBtn.classList.add("copied");
        setTimeout(function () {
          shareCopyBtn.textContent = "Kopyala";
          shareCopyBtn.classList.remove("copied");
        }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(v).then(done, function () {
          shareUrlInput.select(); document.execCommand("copy"); done();
        });
      } else {
        shareUrlInput.select(); document.execCommand("copy"); done();
      }
    });
  }

  function bekle(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  async function loadSharedDesign(id) {
    var r, state;
    try {
      r = await fetch(BRAVER_DEPO + "/paylas/" + encodeURIComponent(id));
      state = r.ok ? await r.json() : null;
    } catch (e) { state = null; }
    if (!state || !state.designs || !state.designs.length) return;

    // 1) Varyant (model + renk)
    if (state.variantId) {
      var vbtn = document.querySelector('.hat-option[data-variant-id="' + state.variantId + '"]');
      if (vbtn) selectVariant(vbtn);
    }
    // 2) Teknik
    chooseTechnique(state.technique || currentTechnique);
    // 3) Patch rengi
    if (state.patchColor && state.patchColor !== patchColor) {
      var pb = document.querySelector('#patchColorSwitch button[data-pcolor="' + state.patchColor + '"]');
      if (pb) pb.click();
    }
    // 4) Adet
    if (qtyInput && Number(state.qty) > 1) {
      qtyInput.value = String(Math.round(Number(state.qty)));
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    await bekle(350); // varyant görseli + safe area otursun

    // Sahne genişliği oturana kadar bekle (ölçekleme için gerekli)
    for (var b = 0; b < 20 && mainHat.getBoundingClientRect().width < 50; b++) await bekle(250);

    // Cihazlar arası ölçek: kaydedilen px değerleri, kaydeden sahne genişliğine
    // göre oranlanır (masaüstü↔mobil paylaşımlarında boyut/konum aynı ORANDA kalır)
    var localW = mainHat.getBoundingClientRect().width;
    var k = (state.stageW > 50 && localW > 50) ? localW / state.stageW : 1;

    // 5) Tasarımlar: her birini aktif olarak kur, render'ı bekle, sabitle
    for (var i = 0; i < state.designs.length; i++) {
      var d = state.designs[i];
      var det = Object.assign({}, d);
      det.size = Number(d.size || 46) * k;
      det.x = Number(d.x || 0) * k;
      det.y = Number(d.y || 0) * k;
      if (det.type === "Logo") {
        if (!d.logoDataUrl) continue;
        try { det.logoImage = await dataUrlToImage(d.logoDataUrl); } catch (e) { continue; }
        det.logoFile = d.kaynakDataUrl ? dataUrlToFile(d.kaynakDataUrl, d.kaynakAd) : null;
      }
      setView(det.view || "front");
      restoreDesign(det);
      await bekle(650); // glif/canvas render'ı tamamlansın (freeze anlık kopya alır)
      if (i < state.designs.length - 1) freezeCurrentDesign();
    }
    // Son tasarım aktif kalır (müşteri düzenleyebilir); panelleri toparla
    setView((state.designs[state.designs.length - 1] || {}).view || "front");
    if (mobileDrawer) mobileDrawer.classList.remove("open");
    showToolsMenu();
    updatePriceDisplay();
    // Sınır kontrolü: sayfa/şapka görseli geç yüklenirse rect'ler 0 olur ve
    // tasarım yanlışlıkla "alan dışında" kalır — layout oturana dek tekrarla
    var deneme = 0;
    (function boundsRetry() {
      var hazir = mainHat.getBoundingClientRect().width >= 50;
      if (hazir) autoSafeArea(); // safe-area kutusu da 0-layout'ta çizilmiş olabilir
      updateAddButton();
      checkBounds();
      if (!hazir && deneme++ < 40) setTimeout(boundsRetry, 500);
    })();
  }

  // Sabit Uygula (masaüstü) ve araç çubuğu (mobil) ödeme barının HEMEN üstünde
  // durur; paylaş butonu gibi eklemeler barı uzatınca örtülmesinler diye ofset dinamik
  function updateApplyOffset() {
    var bar = document.getElementById("checkoutBar");
    var desktop = window.innerWidth >= 1200;
    [applyText, applyLogo].forEach(function (b) {
      if (!b) return;
      b.style.bottom = desktop && bar ? (bar.offsetHeight + 14) + "px" : "";
    });
    if (mobileBar) mobileBar.style.bottom = !desktop && bar ? bar.offsetHeight + "px" : "";
    // içerik sabit barların arkasında kalmasın
    var kok = document.querySelector(".braver-customizer");
    if (kok && !desktop && bar) kok.style.paddingBottom = (bar.offsetHeight + 100) + "px";
  }
  window.addEventListener("resize", updateApplyOffset);
  if (shareBtn) shareBtn.addEventListener("click", function () { setTimeout(updateApplyOffset, 100); });
  if (shareCopyBtn) shareCopyBtn.addEventListener("click", function () { setTimeout(updateApplyOffset, 100); });
  updateApplyOffset();
  setTimeout(updateApplyOffset, 800); // fiyat/bulk satırları yerleşince ikinci geçiş


  /* ── Mobil yazı giriş modalı: iOS klavyesi alt çekmeceyi örtüyor —
     Hatstore tarzı üstte modal; yazdıkça canlı önizleme sürer ── */
  var teModal = document.getElementById("textEntryModal");
  var teInput = document.getElementById("textEntryInput");
  var teOnceki = "";
  function teAc() {
    if (!teModal || !textInput) return;
    teOnceki = textInput.value;
    teInput.value = textInput.value;
    teModal.classList.remove("is-hidden");
    setTimeout(function () {
      teInput.focus();
      teInput.setSelectionRange(teInput.value.length, teInput.value.length);
    }, 60);
  }
  function teKapat() {
    if (!teModal) return;
    teModal.classList.add("is-hidden");
    teInput.blur();
  }
  if (teModal && textInput) {
    // mobilde çekmece textarea'sı klavyeyi AÇMAZ — dokununca üst modal açılır
    textInput.addEventListener("focus", function () {
      if (window.innerWidth >= 1200) return;
      textInput.blur();
      teAc();
    });
    teInput.addEventListener("input", function () {
      textInput.value = teInput.value;
      textInput.dispatchEvent(new Event("input", { bubbles: true })); // canlı önizleme
    });
    document.getElementById("textEntryOk").addEventListener("click", teKapat);
    document.getElementById("textEntryCancel").addEventListener("click", function () {
      textInput.value = teOnceki;
      textInput.dispatchEvent(new Event("input", { bubbles: true }));
      teKapat();
    });
    teModal.querySelector(".text-entry-modal__backdrop").addEventListener("click", teKapat);
  }

  /* ── Bayat sürüm kilidi: tarayıcı önbelleğinden gelen ESKİ customizer sürümü
     sipariş üretemesin (#14558: eski JS → dosyasız/yanlış ücretli sipariş).
     Sunucudaki taze HTML'in script ?v damgası bizimkinden farklıysa sayfayı
     önbelleği delerek yenile — yalnız tasarım başlamadan, oturumda bir kez. ── */
  (function () {
    try {
      if (sessionStorage.getItem("braverSurumKontrol")) return;
      var kendi = ([].slice.call(document.querySelectorAll("script[src]")).map(function (e) { return e.src; })
        .filter(function (u) { return u.indexOf("braver-customizer.js") > -1; })[0] || "").split("?v=")[1] || "";
      if (!kendi) return;
      fetch(location.pathname + "?surum=" + Date.now(), { cache: "no-store", credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var m = html.match(/braver-customizer\.js\?v=([0-9]+)/);
          if (!m || m[1] === kendi) return;
          if (hasAnyDesign()) return; // müşteri tasarlıyorsa bölme
          sessionStorage.setItem("braverSurumKontrol", "1");
          location.replace(location.pathname + location.search + (location.search ? "&" : "?") + "yenile=" + Date.now());
        }).catch(function () {});
    } catch (e) {}
  })();

  /* ── Giriş uyarısı (Zakeke'deki gibi): her açılışta, OK/×/arka plan/Esc ile kapanır ── */
  (function () {
    var en = document.getElementById("entryNotice");
    if (!en) return;
    function kapat() {
      en.classList.add("is-hidden");
      document.removeEventListener("keydown", escKapat);
    }
    function escKapat(e) { if (e.key === "Escape") kapat(); }
    [].slice.call(en.querySelectorAll("[data-entry-close]")).forEach(function (b) {
      b.addEventListener("click", kapat);
    });
    document.addEventListener("keydown", escKapat);
    en.classList.remove("is-hidden");
    var ok = document.getElementById("entryNoticeOk");
    if (ok) setTimeout(function () { try { ok.focus(); } catch (e) {} }, 50);
  })();

  var paylasilanId = new URLSearchParams(location.search).get("tasarim");
  if (paylasilanId && /^[a-z0-9]{6,16}$/i.test(paylasilanId)) {
    // init tamamlansın (teknik filtreleri setTimeout(0) ile erteleniyor)
    setTimeout(function () { loadSharedDesign(paylasilanId); }, 500);
  }

});
